// District/neighbourhood name translations — keyed by the canonical
// Traditional Chinese (zh-HK) string stored in CITY_DISTRICTS (see
// src/constants/districts.js). zh-HK itself needs no entry since that's
// the raw stored value. Mirrors the pattern used by specifyCatLabels in
// src/constants/translations.js.
export const districtLabels = {
  // Hong Kong
  '中西區': { 'zh-CN':'中西区', en:'Central & Western', ja:'中西区', ko:'중서구' },
  '灣仔': { 'zh-CN':'湾仔', en:'Wan Chai', ja:'ワンチャイ', ko:'완차이' },
  '東區': { 'zh-CN':'东区', en:'East District', ja:'東区', ko:'동구' },
  '南區': { 'zh-CN':'南区', en:'Southern District', ja:'南区', ko:'남구' },
  '尖沙咀': { 'zh-CN':'尖沙咀', en:'Tsim Sha Tsui', ja:'チムサーチョイ', ko:'침사추이' },
  '旺角': { 'zh-CN':'旺角', en:'Mong Kok', ja:'モンコック', ko:'몽콕' },
  '油麻地': { 'zh-CN':'油麻地', en:'Yau Ma Tei', ja:'ヤウマテイ', ko:'야우마테이' },
  '深水埗': { 'zh-CN':'深水埗', en:'Sham Shui Po', ja:'シャムスイポー', ko:'삼수이포' },
  '九龍城': { 'zh-CN':'九龙城', en:'Kowloon City', ja:'九龍城', ko:'까우룽청' },
  '黃大仙': { 'zh-CN':'黄大仙', en:'Wong Tai Sin', ja:'ウォンタイシン', ko:'웡타이신' },
  '觀塘': { 'zh-CN':'观塘', en:'Kwun Tong', ja:'クントン', ko:'관탕' },
  '荃灣': { 'zh-CN':'荃湾', en:'Tsuen Wan', ja:'チュンワン', ko:'취안완' },
  '葵青': { 'zh-CN':'葵青', en:'Kwai Tsing', ja:'クワイチン', ko:'콰이칭' },
  '屯門': { 'zh-CN':'屯门', en:'Tuen Mun', ja:'トゥエンムン', ko:'툰문' },
  '元朗': { 'zh-CN':'元朗', en:'Yuen Long', ja:'ユンロン', ko:'윈롱' },
  '北區': { 'zh-CN':'北区', en:'North District', ja:'北区', ko:'북구' },
  '大埔': { 'zh-CN':'大埔', en:'Tai Po', ja:'タイポー', ko:'타이포' },
  '沙田': { 'zh-CN':'沙田', en:'Sha Tin', ja:'シャティン', ko:'샤틴' },
  '西貢': { 'zh-CN':'西贡', en:'Sai Kung', ja:'サイクン', ko:'사이쿵' },
  '東涌': { 'zh-CN':'东涌', en:'Tung Chung', ja:'トンチョン', ko:'통충' },
  '坪洲': { 'zh-CN':'坪洲', en:'Peng Chau', ja:'ピンチャウ島', ko:'펭차우 섬' },
  '長洲': { 'zh-CN':'长洲', en:'Cheung Chau', ja:'チュンチャウ島', ko:'청차우 섬' },
  '梅窩': { 'zh-CN':'梅窝', en:'Mui Wo', ja:'ムイウォー', ko:'무이워' },
  '南丫島': { 'zh-CN':'南丫岛', en:'Lamma Island', ja:'ラマ島', ko:'라마 섬' },
  '愉景灣': { 'zh-CN':'愉景湾', en:'Discovery Bay', ja:'ディスカバリーベイ', ko:'디스커버리 베이' },
  '迪士尼': { 'zh-CN':'迪士尼', en:'Disneyland', ja:'ディズニーランド', ko:'디즈니랜드' },
  // Macau
  '氹仔': { 'zh-CN':'氹仔', en:'Taipa', ja:'タイパ', ko:'타이파' },
  '路氹': { 'zh-CN':'路氹', en:'Cotai', ja:'コタイ', ko:'코타이' },
  '澳門半島': { 'zh-CN':'澳门半岛', en:'Macau Peninsula', ja:'マカオ半島', ko:'마카오 반도' },
  '新口岸': { 'zh-CN':'新口岸', en:'NAPE', ja:'新口岸', ko:'신아오멘' },
  '黑沙環': { 'zh-CN':'黑沙环', en:'Areia Preta', ja:'アレイア・プレタ', ko:'아레이아 프레타' },
  '石排灣': { 'zh-CN':'石排湾', en:'Seac Pai Van', ja:'セアクパイヴァン', ko:'섹파이완' },
  '青洲': { 'zh-CN':'青洲', en:'Ilha Verde', ja:'イーリャヴェルデ', ko:'일랴베르드' },
  // Taipei
  '信義區': { 'zh-CN':'信义区', en:'Xinyi District', ja:'信義区', ko:'신이구' },
  '大安區': { 'zh-CN':'大安区', en:'Da\'an District', ja:'大安区', ko:'다안구' },
  '西門町': { 'zh-CN':'西门町', en:'Ximending', ja:'西門町', ko:'시먼딩' },
  '士林': { 'zh-CN':'士林', en:'Shilin', ja:'士林', ko:'스린' },
  '淡水': { 'zh-CN':'淡水', en:'Tamsui', ja:'淡水', ko:'단수이' },
  '九份老街': { 'zh-CN':'九份老街', en:'Jiufen Old Street', ja:'九份老街', ko:'주펀 옛거리' },
  '北投': { 'zh-CN':'北投', en:'Beitou', ja:'北投', ko:'베이터우' },
  '中山': { 'zh-CN':'中山', en:'Zhongshan', ja:'中山', ko:'중산' },
  '萬華': { 'zh-CN':'万华', en:'Wanhua', ja:'萬華', ko:'완화' },
  '松山': { 'zh-CN':'松山', en:'Songshan', ja:'松山', ko:'쑹산' },
  '大同': { 'zh-CN':'大同', en:'Datong', ja:'大同', ko:'다퉁' },
  '文山': { 'zh-CN':'文山', en:'Wenshan', ja:'文山', ko:'원산' },
  // Kaohsiung
  '駁二藝術特區': { 'zh-CN':'驳二艺术特区', en:'Pier-2 Art Center', ja:'駁二芸術特区', ko:'보얼 예술특구' },
  '西子灣': { 'zh-CN':'西子湾', en:'Sizihwan', ja:'西子湾', ko:'시즈완' },
  '六合夜市': { 'zh-CN':'六合夜市', en:'Liuhe Night Market', ja:'六合夜市', ko:'류허 야시장' },
  '瑞豐夜市': { 'zh-CN':'瑞丰夜市', en:'Ruifeng Night Market', ja:'瑞豊夜市', ko:'루이펑 야시장' },
  '旗津': { 'zh-CN':'旗津', en:'Cijin', ja:'旗津', ko:'치진' },
  '義大世界': { 'zh-CN':'义大世界', en:'E-Da World', ja:'義大世界', ko:'이다월드' },
  '美麗島': { 'zh-CN':'美丽岛', en:'Formosa Boulevard', ja:'美麗島', ko:'메이리다오' },
  '鹽埕': { 'zh-CN':'盐埕', en:'Yancheng', ja:'塩埕', ko:'옌청' },
  '左營': { 'zh-CN':'左营', en:'Zuoying', ja:'左営', ko:'줘잉' },
  '鼓山': { 'zh-CN':'鼓山', en:'Gushan', ja:'鼓山', ko:'구산' },
  // Taichung
  '逢甲夜市': { 'zh-CN':'逢甲夜市', en:'Fengjia Night Market', ja:'逢甲夜市', ko:'펑자 야시장' },
  '一中街': { 'zh-CN':'一中街', en:'Yizhong Street', ja:'一中街', ko:'이중제' },
  '彩虹眷村': { 'zh-CN':'彩虹眷村', en:'Rainbow Village', ja:'虹の村', ko:'레인보우 빌리지' },
  '高美濕地': { 'zh-CN':'高美湿地', en:'Gaomei Wetlands', ja:'高美湿地', ko:'가오메이 습지' },
  '東海大學': { 'zh-CN':'东海大学', en:'Tunghai University', ja:'東海大学', ko:'둥하이대학교' },
  '草悟道': { 'zh-CN':'草悟道', en:'Calligraphy Greenway', ja:'草悟道', ko:'차오우다오' },
  '大坑': { 'zh-CN':'大坑', en:'Dakeng', ja:'大坑', ko:'다컹' },
  '審計新村': { 'zh-CN':'审计新村', en:'Shen Ji New Village', ja:'審計新村', ko:'선지신촌' },
  '后里': { 'zh-CN':'后里', en:'Houli', ja:'后里', ko:'허우리' },
  '清水': { 'zh-CN':'清水', en:'Qingshui', ja:'清水', ko:'칭수이' },
  // Tainan
  '安平': { 'zh-CN':'安平', en:'Anping', ja:'安平', ko:'안핑' },
  '赤崎樓': { 'zh-CN':'赤崁楼', en:'Chihkan Tower', ja:'赤崁楼', ko:'츠칸러우' },
  '花園夜市': { 'zh-CN':'花园夜市', en:'Flower Night Market', ja:'花園夜市', ko:'화위안 야시장' },
  '孔廟': { 'zh-CN':'孔庙', en:'Confucius Temple', ja:'孔子廟', ko:'공자묘' },
  '神農街': { 'zh-CN':'神农街', en:'Shennong Street', ja:'神農街', ko:'선눙제' },
  '國華街': { 'zh-CN':'国华街', en:'Guohua Street', ja:'国華街', ko:'궈화제' },
  '林百貨': { 'zh-CN':'林百货', en:'Hayashi Department Store', ja:'林百貨', ko:'하야시백화점' },
  '奇美博物館': { 'zh-CN':'奇美博物馆', en:'Chimei Museum', ja:'奇美博物館', ko:'치메이 박물관' },
  '仁德': { 'zh-CN':'仁德', en:'Rende', ja:'仁徳', ko:'런더' },
  '永康': { 'zh-CN':'永康', en:'Yongkang', ja:'永康', ko:'융캉' },
  // Yilan
  '礁溪': { 'zh-CN':'礁溪', en:'Jiaoxi', ja:'礁渓', ko:'자오시' },
  '羅東': { 'zh-CN':'罗东', en:'Luodong', ja:'羅東', ko:'뤄둥' },
  '頭城': { 'zh-CN':'头城', en:'Toucheng', ja:'頭城', ko:'터우청' },
  '蘇澳': { 'zh-CN':'苏澳', en:'Su\'ao', ja:'蘇澳', ko:'쑤아오' },
  '冬山': { 'zh-CN':'冬山', en:'Dongshan', ja:'冬山', ko:'둥산' },
  '五結': { 'zh-CN':'五结', en:'Wujie', ja:'五結', ko:'우제' },
  '三星': { 'zh-CN':'三星', en:'Sanxing', ja:'三星', ko:'싼싱' },
  '宜蘭市': { 'zh-CN':'宜兰市', en:'Yilan City', ja:'宜蘭市', ko:'이란시' },
  // Hualien
  '花蓮市': { 'zh-CN':'花莲市', en:'Hualien City', ja:'花蓮市', ko:'화롄시' },
  '太魯閣': { 'zh-CN':'太鲁阁', en:'Taroko Gorge', ja:'タロコ渓谷', ko:'타이루거 협곡' },
  '七星潭': { 'zh-CN':'七星潭', en:'Qixingtan', ja:'七星潭', ko:'치싱탄' },
  '鯉魚潭': { 'zh-CN':'鲤鱼潭', en:'Liyu Lake', ja:'鯉魚潭', ko:'리위탄' },
  '瑞穗': { 'zh-CN':'瑞穗', en:'Ruisui', ja:'瑞穂', ko:'루이수이' },
  '玉里': { 'zh-CN':'玉里', en:'Yuli', ja:'玉里', ko:'위리' },
  '光復': { 'zh-CN':'光复', en:'Guangfu', ja:'光復', ko:'광푸' },
  // Kenting
  '墾丁大街': { 'zh-CN':'垦丁大街', en:'Kenting Main Street', ja:'墾丁大街', ko:'컨딩 대로' },
  '白沙灣': { 'zh-CN':'白沙湾', en:'White Sand Bay', ja:'白沙湾', ko:'백사만' },
  '貓鼻頭': { 'zh-CN':'猫鼻头', en:'Cape Maobitou', ja:'猫鼻頭', ko:'마오비터우' },
  '鵝鑾鼻': { 'zh-CN':'鹅銮鼻', en:'Eluanbi', ja:'鵝鑾鼻', ko:'어롼비' },
  '南灣': { 'zh-CN':'南湾', en:'Nanwan', ja:'南湾', ko:'난완' },
  '龍磐公園': { 'zh-CN':'龙磐公园', en:'Longpan Park', ja:'龍磐公園', ko:'룽판 공원' },
  '船帆石': { 'zh-CN':'船帆石', en:'Sail Rock', ja:'船帆石', ko:'촨판스' },
  // Jiufen
  '金瓜石': { 'zh-CN':'金瓜石', en:'Jinguashi', ja:'金瓜石', ko:'진과스' },
  '十分': { 'zh-CN':'十分', en:'Shifen', ja:'十分', ko:'스펀' },
  '平溪': { 'zh-CN':'平溪', en:'Pingxi', ja:'平渓', ko:'핑시' },
  '猴硐': { 'zh-CN':'猴硐', en:'Houtong', ja:'猴硐', ko:'허우둥' },
  // New Taipei
  '烏來溫泉': { 'zh-CN':'乌来温泉', en:'Wulai Hot Springs', ja:'烏来温泉', ko:'우라이 온천' },
  '三峽老街': { 'zh-CN':'三峡老街', en:'Sanxia Old Street', ja:'三峡老街', ko:'싼샤 옛거리' },
  '鶯歌陶瓷老街': { 'zh-CN':'莺歌陶瓷老街', en:'Yingge Ceramics Street', ja:'鶯歌陶瓷老街', ko:'잉거 도자기 거리' },
  '野柳地質公園': { 'zh-CN':'野柳地质公园', en:'Yehliu Geopark', ja:'野柳地質公園', ko:'예류 지질공원' },
  '深坑老街': { 'zh-CN':'深坑老街', en:'Shenkeng Old Street', ja:'深坑老街', ko:'선컹 옛거리' },
  '板橋車站': { 'zh-CN':'板桥车站', en:'Banqiao Station', ja:'板橋駅', ko:'반차오역' },
  // Taoyuan
  '大溪老街': { 'zh-CN':'大溪老街', en:'Daxi Old Street', ja:'大渓老街', ko:'다시 옛거리' },
  '慈湖': { 'zh-CN':'慈湖', en:'Cihu', ja:'慈湖', ko:'츠후' },
  '拉拉山': { 'zh-CN':'拉拉山', en:'Lalashan', ja:'拉拉山', ko:'라라산' },
  '小烏來風景區': { 'zh-CN':'小乌来风景区', en:'Xiaowulai Scenic Area', ja:'小烏来風景区', ko:'샤오우라이 풍경구' },
  '東眼山': { 'zh-CN':'东眼山', en:'Dongyanshan', ja:'東眼山', ko:'둥옌산' },
  '中壢夜市': { 'zh-CN':'中坜夜市', en:'Zhongli Night Market', ja:'中壢夜市', ko:'중리 야시장' },
  // Hsinchu County
  '內灣老街': { 'zh-CN':'内湾老街', en:'Neiwan Old Street', ja:'内湾老街', ko:'네이완 옛거리' },
  '北埔老街': { 'zh-CN':'北埔老街', en:'Beipu Old Street', ja:'北埔老街', ko:'베이푸 옛거리' },
  '關西六福村': { 'zh-CN':'关西六福村', en:'Leofoo Village', ja:'六福村', ko:'류푸촌' },
  '尖石鄉': { 'zh-CN':'尖石乡', en:'Jianshi', ja:'尖石郷', ko:'젠스향' },
  '峨眉湖': { 'zh-CN':'峨眉湖', en:'Emei Lake', ja:'峨眉湖', ko:'어메이호' },
  // Miaoli County
  '南庄老街': { 'zh-CN':'南庄老街', en:'Nanzhuang Old Street', ja:'南庄老街', ko:'난좡 옛거리' },
  '三義木雕街': { 'zh-CN':'三义木雕街', en:'Sanyi Woodcarving Street', ja:'三義木彫り街', ko:'싼이 목조거리' },
  '大湖草莓園': { 'zh-CN':'大湖草莓园', en:'Dahu Strawberry Farm', ja:'大湖いちご園', ko:'다후 딸기농원' },
  '通霄海水浴場': { 'zh-CN':'通霄海水浴场', en:'Tongxiao Beach', ja:'通霄海水浴場', ko:'퉁샤오 해수욕장' },
  '客家圓樓': { 'zh-CN':'客家圆楼', en:'Hakka Round House', ja:'客家円楼', ko:'객가원루' },
  // Chiayi County
  '阿里山': { 'zh-CN':'阿里山', en:'Alishan', ja:'阿里山', ko:'아리산' },
  '奮起湖老街': { 'zh-CN':'奋起湖老街', en:'Fenqihu Old Street', ja:'奮起湖老街', ko:'펀치후 옛거리' },
  '布袋港': { 'zh-CN':'布袋港', en:'Budai Port', ja:'布袋港', ko:'부다이항' },
  '故宮南院': { 'zh-CN':'故宫南院', en:'National Palace Museum Southern Branch', ja:'故宮南院', ko:'고궁남원' },
  '梅山瑞里': { 'zh-CN':'梅山瑞里', en:'Meishan Ruili', ja:'梅山瑞里', ko:'메이산 루이리' },
  // Yunlin County
  '劍湖山世界': { 'zh-CN':'剑湖山世界', en:'Janfusun Fancyworld', ja:'剣湖山世界', ko:'젠후산 판시월드' },
  '北港朝天宮': { 'zh-CN':'北港朝天宫', en:'Beigang Chaotian Temple', ja:'北港朝天宮', ko:'베이강 차오톈궁' },
  '古坑咖啡大街': { 'zh-CN':'古坑咖啡大街', en:'Gukeng Coffee Street', ja:'古坑コーヒー街', ko:'구컹 커피거리' },
  '虎尾糖廠': { 'zh-CN':'虎尾糖厂', en:'Huwei Sugar Factory', ja:'虎尾糖廠', ko:'후웨이 제당공장' },
  '西螺大橋': { 'zh-CN':'西螺大桥', en:'Xiluo Bridge', ja:'西螺大橋', ko:'시뤄대교' },
  // Penghu County
  '澎湖跨海大橋': { 'zh-CN':'澎湖跨海大桥', en:'Penghu Bridge', ja:'澎湖跨海大橋', ko:'펑후대교' },
  '七美嶼': { 'zh-CN':'七美屿', en:'Qimei Island', ja:'七美嶼', ko:'치메이섬' },
  '吉貝嶼': { 'zh-CN':'吉贝屿', en:'Jibei Island', ja:'吉貝嶼', ko:'지베이섬' },
  '馬公老街': { 'zh-CN':'马公老街', en:'Magong Old Street', ja:'馬公老街', ko:'마궁 옛거리' },
  '奎壁山': { 'zh-CN':'奎壁山', en:'Kuibishan', ja:'奎壁山', ko:'쿠이비산' },
  // Beijing
  '天安門': { 'zh-CN':'天安门', en:'Tiananmen', ja:'天安門', ko:'천안문' },
  '故宮': { 'zh-CN':'故宫', en:'Forbidden City', ja:'故宮', ko:'고궁' },
  '三里屯': { 'zh-CN':'三里屯', en:'Sanlitun', ja:'三里屯', ko:'싼리툰' },
  '王府井': { 'zh-CN':'王府井', en:'Wangfujing', ja:'王府井', ko:'왕푸징' },
  '頤和園': { 'zh-CN':'颐和园', en:'Summer Palace', ja:'頤和園', ko:'이화원' },
  '南鑼鼓巷': { 'zh-CN':'南锣鼓巷', en:'Nanluoguxiang', ja:'南鑼鼓巷', ko:'난뤄구샹' },
  '798藝術區': { 'zh-CN':'798艺术区', en:'798 Art Zone', ja:'798芸術区', ko:'798 예술구' },
  '什剎海': { 'zh-CN':'什刹海', en:'Shichahai', ja:'什刹海', ko:'스차하이' },
  '前門': { 'zh-CN':'前门', en:'Qianmen', ja:'前門', ko:'첸먼' },
  '西單': { 'zh-CN':'西单', en:'Xidan', ja:'西単', ko:'시단' },
  // Shanghai
  '外灘': { 'zh-CN':'外滩', en:'The Bund', ja:'外灘', ko:'와이탄' },
  '南京路': { 'zh-CN':'南京路', en:'Nanjing Road', ja:'南京路', ko:'난징루' },
  '豫園': { 'zh-CN':'豫园', en:'Yu Garden', ja:'豫園', ko:'위위안' },
  '新天地': { 'zh-CN':'新天地', en:'Xintiandi', ja:'新天地', ko:'신톈디' },
  '靜安寺': { 'zh-CN':'静安寺', en:'Jing\'an Temple', ja:'静安寺', ko:'징안사' },
  '田子坊': { 'zh-CN':'田子坊', en:'Tianzifang', ja:'田子坊', ko:'톈쯔팡' },
  '虹橋': { 'zh-CN':'虹桥', en:'Hongqiao', ja:'虹橋', ko:'훙차오' },
  '浦東': { 'zh-CN':'浦东', en:'Pudong', ja:'浦東', ko:'푸둥' },
  '徐匯': { 'zh-CN':'徐汇', en:'Xuhui', ja:'徐匯', ko:'쉬후이' },
  '長寧': { 'zh-CN':'长宁', en:'Changning', ja:'長寧', ko:'창닝' },
  // Guangzhou
  '天河': { 'zh-CN':'天河', en:'Tianhe', ja:'天河', ko:'톈허' },
  '越秀': { 'zh-CN':'越秀', en:'Yuexiu', ja:'越秀', ko:'웨슈' },
  '荔灣': { 'zh-CN':'荔湾', en:'Liwan', ja:'茘湾', ko:'리완' },
  '海珠': { 'zh-CN':'海珠', en:'Haizhu', ja:'海珠', ko:'하이주' },
  '番禺': { 'zh-CN':'番禺', en:'Panyu', ja:'番禺', ko:'판위' },
  '花都': { 'zh-CN':'花都', en:'Huadu', ja:'花都', ko:'화두' },
  '北京路': { 'zh-CN':'北京路', en:'Beijing Road', ja:'北京路', ko:'베이징루' },
  '珠江新城': { 'zh-CN':'珠江新城', en:'Zhujiang New Town', ja:'珠江新城', ko:'주장신청' },
  // Shenzhen
  '南山': { 'zh-CN':'南山', en:'Nanshan', ja:'南山', ko:'난산' },
  '福田': { 'zh-CN':'福田', en:'Futian', ja:'福田', ko:'푸톈' },
  '羅湖': { 'zh-CN':'罗湖', en:'Luohu', ja:'羅湖', ko:'뤄후' },
  '寶安': { 'zh-CN':'宝安', en:'Bao\'an', ja:'宝安', ko:'바오안' },
  '龍崗': { 'zh-CN':'龙岗', en:'Longgang', ja:'龍崗', ko:'룽강' },
  '鹽田': { 'zh-CN':'盐田', en:'Yantian', ja:'塩田', ko:'옌톈' },
  '東門': { 'zh-CN':'东门', en:'Dongmen', ja:'東門', ko:'둥먼' },
  '大鵬': { 'zh-CN':'大鹏', en:'Dapeng', ja:'大鵬', ko:'다펑' },
  // Chengdu
  '錦里': { 'zh-CN':'锦里', en:'Jinli Street', ja:'錦里', ko:'진리 거리' },
  '寬窄巷子': { 'zh-CN':'宽窄巷子', en:'Kuanzhai Alley', ja:'寛窄巷子', ko:'콴자이샹쯔' },
  '天府廣場': { 'zh-CN':'天府广场', en:'Tianfu Square', ja:'天府広場', ko:'톈푸광장' },
  '春熙路': { 'zh-CN':'春熙路', en:'Chunxi Road', ja:'春熙路', ko:'춘시루' },
  '武侯祠': { 'zh-CN':'武侯祠', en:'Wuhou Shrine', ja:'武侯祠', ko:'우허우사' },
  '都江堰': { 'zh-CN':'都江堰', en:'Dujiangyan', ja:'都江堰', ko:'두장옌' },
  '青城山': { 'zh-CN':'青城山', en:'Mount Qingcheng', ja:'青城山', ko:'칭청산' },
  '武隆': { 'zh-CN':'武隆', en:'Wulong', ja:'武隆', ko:'우룽' },
  '海口': { 'zh-CN':'海口', en:'Haikou', ja:'海口', ko:'하이커우' },
  '九寨溝': { 'zh-CN':'九寨沟', en:'Jiuzhaigou', ja:'九寨溝', ko:'주자이거우' },
  // Chongqing
  '解放碑': { 'zh-CN':'解放碑', en:'Jiefangbei', ja:'解放碑', ko:'제팡베이' },
  '磁器口': { 'zh-CN':'磁器口', en:'Ciqikou', ja:'磁器口', ko:'츠치커우' },
  '南岸': { 'zh-CN':'南岸', en:'South Bank', ja:'サウスバンク', ko:'사우스뱅크' },
  '渝中': { 'zh-CN':'渝中', en:'Yuzhong', ja:'渝中', ko:'위중' },
  '洪崖洞': { 'zh-CN':'洪崖洞', en:'Hongyadong', ja:'洪崖洞', ko:'훙야둥' },
  '觀音橋': { 'zh-CN':'观音桥', en:'Guanyinqiao', ja:'観音橋', ko:'관인차오' },
  '沙坪壩': { 'zh-CN':'沙坪坝', en:'Shapingba', ja:'沙坪壩', ko:'사핑바' },
  '北碚': { 'zh-CN':'北碚', en:'Beibei', ja:'北碚', ko:'베이베이' },
  // Xi'an
  '鐘鼓樓': { 'zh-CN':'钟鼓楼', en:'Bell and Drum Tower', ja:'鐘鼓楼', ko:'종고루' },
  '兵馬俑': { 'zh-CN':'兵马俑', en:'Terracotta Army', ja:'兵馬俑', ko:'병마용' },
  '大雁塔': { 'zh-CN':'大雁塔', en:'Big Wild Goose Pagoda', ja:'大雁塔', ko:'대안탑' },
  '回民街': { 'zh-CN':'回民街', en:'Muslim Quarter', ja:'回民街', ko:'후이족거리' },
  '曲江': { 'zh-CN':'曲江', en:'Qujiang', ja:'曲江', ko:'취장' },
  '城牆': { 'zh-CN':'城墙', en:'City Wall', ja:'城壁', ko:'성벽' },
  '碑林': { 'zh-CN':'碑林', en:'Forest of Stone Steles', ja:'碑林', ko:'비림' },
  '半坡': { 'zh-CN':'半坡', en:'Banpo', ja:'半坡', ko:'반포' },
  // Hangzhou
  '西湖': { 'zh-CN':'西湖', en:'West Lake', ja:'西湖', ko:'서호' },
  '靈隱寺': { 'zh-CN':'灵隐寺', en:'Lingyin Temple', ja:'霊隠寺', ko:'영은사' },
  '河坊街': { 'zh-CN':'河坊街', en:'Hefang Street', ja:'河坊街', ko:'허팡제' },
  '西溪濕地': { 'zh-CN':'西溪湿地', en:'Xixi Wetland', ja:'西渓湿地', ko:'시시습지' },
  '千島湖': { 'zh-CN':'千岛湖', en:'Qiandao Lake', ja:'千島湖', ko:'천도호' },
  '烏鎮': { 'zh-CN':'乌镇', en:'Wuzhen', ja:'烏鎮', ko:'우전' },
  '南潯': { 'zh-CN':'南浔', en:'Nanxun', ja:'南潯', ko:'난쉰' },
  '龍井': { 'zh-CN':'龙井', en:'Longjing', ja:'龍井', ko:'룽징' },
  // Xiamen
  '鼓浪嶼': { 'zh-CN':'鼓浪屿', en:'Gulangyu', ja:'鼓浪嶼', ko:'구랑위' },
  '中山路': { 'zh-CN':'中山路', en:'Zhongshan Road', ja:'中山路', ko:'중산루' },
  '曾厝垵': { 'zh-CN':'曾厝垵', en:'Zengcuoan', ja:'曾厝垵', ko:'쩡추안' },
  '集美': { 'zh-CN':'集美', en:'Jimei', ja:'集美', ko:'지메이' },
  '環島路': { 'zh-CN':'环岛路', en:'Island Ring Road', ja:'環島路', ko:'환다오루' },
  '南普陀': { 'zh-CN':'南普陀', en:'Nanputuo Temple', ja:'南普陀', ko:'난푸퉈사' },
  '廈門大學': { 'zh-CN':'厦门大学', en:'Xiamen University', ja:'厦門大学', ko:'샤먼대학교' },
  // Guilin
  '陽朔': { 'zh-CN':'阳朔', en:'Yangshuo', ja:'陽朔', ko:'양숴' },
  '漓江': { 'zh-CN':'漓江', en:'Li River', ja:'漓江', ko:'리장' },
  '象山': { 'zh-CN':'象山', en:'Elephant Trunk Hill', ja:'象山', ko:'상비산' },
  '七星公園': { 'zh-CN':'七星公园', en:'Seven Star Park', ja:'七星公園', ko:'치싱공원' },
  '龍脊梯田': { 'zh-CN':'龙脊梯田', en:'Longji Rice Terraces', ja:'龍脊棚田', ko:'룽지 계단식논' },
  '蘆笛岩': { 'zh-CN':'芦笛岩', en:'Reed Flute Cave', ja:'蘆笛岩', ko:'루디옌' },
  '正陽路': { 'zh-CN':'正阳路', en:'Zhengyang Road', ja:'正陽路', ko:'정양루' },
  // Sanya
  '亞龍灣': { 'zh-CN':'亚龙湾', en:'Yalong Bay', ja:'亜龍湾', ko:'야룽만' },
  '三亞灣': { 'zh-CN':'三亚湾', en:'Sanya Bay', ja:'三亜湾', ko:'싼야만' },
  '大東海': { 'zh-CN':'大东海', en:'Dadonghai', ja:'大東海', ko:'다둥하이' },
  '天涯海角': { 'zh-CN':'天涯海角', en:'Tianya Haijiao', ja:'天涯海角', ko:'톈야하이자오' },
  '蜈支洲島': { 'zh-CN':'蜈支洲岛', en:'Wuzhizhou Island', ja:'蜈支洲島', ko:'우즈저우섬' },
  '鹿回頭': { 'zh-CN':'鹿回头', en:'Deer Turning Head', ja:'鹿回頭', ko:'루후이터우' },
  // Zhangjiajie
  '天門山': { 'zh-CN':'天门山', en:'Tianmen Mountain', ja:'天門山', ko:'톈먼산' },
  '武陵源': { 'zh-CN':'武陵源', en:'Wulingyuan', ja:'武陵源', ko:'우링위안' },
  '黃石寨': { 'zh-CN':'黄石寨', en:'Huangshizhai', ja:'黄石寨', ko:'황스자이' },
  '金鞭溪': { 'zh-CN':'金鞭溪', en:'Golden Whip Stream', ja:'金鞭渓', ko:'진볜시' },
  '袁家界': { 'zh-CN':'袁家界', en:'Yuanjiajie', ja:'袁家界', ko:'위안자제' },
  '寶峰湖': { 'zh-CN':'宝峰湖', en:'Baofeng Lake', ja:'宝峰湖', ko:'바오펑호' },
  // Kunming
  '石林': { 'zh-CN':'石林', en:'Stone Forest', ja:'石林', ko:'스린' },
  '大觀樓': { 'zh-CN':'大观楼', en:'Daguan Pavilion', ja:'大観楼', ko:'다관러우' },
  '翠湖': { 'zh-CN':'翠湖', en:'Green Lake', ja:'翠湖', ko:'추이후' },
  '滇池': { 'zh-CN':'滇池', en:'Dianchi Lake', ja:'滇池', ko:'뎬츠' },
  '西山': { 'zh-CN':'西山', en:'Western Hills', ja:'西山', ko:'시산' },
  '碧雞坊': { 'zh-CN':'碧鸡坊', en:'Bijifang', ja:'碧鶏坊', ko:'비지팡' },
  '南屏步行街': { 'zh-CN':'南屏步行街', en:'Nanping Pedestrian Street', ja:'南屏歩行街', ko:'난핑보행가' },
  // Qingdao
  '棧橋': { 'zh-CN':'栈桥', en:'Zhanqiao Pier', ja:'桟橋', ko:'잔차오' },
  '五四廣場': { 'zh-CN':'五四广场', en:'May Fourth Square', ja:'五四広場', ko:'오사광장' },
  '八大關': { 'zh-CN':'八大关', en:'Badaguan', ja:'八大関', ko:'바다관' },
  '嶗山': { 'zh-CN':'崂山', en:'Mount Lao', ja:'崂山', ko:'라오산' },
  '台東': { 'zh-CN':'台东', en:'Taidong', ja:'台東', ko:'타이둥' },
  '奧帆中心': { 'zh-CN':'奥帆中心', en:'Olympic Sailing Center', ja:'五輪セーリングセンター', ko:'올림픽세일링센터' },
  // Suzhou
  '拙政園': { 'zh-CN':'拙政园', en:'Humble Administrator\'s Garden', ja:'拙政園', ko:'졸정원' },
  '平江路': { 'zh-CN':'平江路', en:'Pingjiang Road', ja:'平江路', ko:'핑장루' },
  '山塘街': { 'zh-CN':'山塘街', en:'Shantang Street', ja:'山塘街', ko:'산탕제' },
  '寒山寺': { 'zh-CN':'寒山寺', en:'Hanshan Temple', ja:'寒山寺', ko:'한산사' },
  '金雞湖': { 'zh-CN':'金鸡湖', en:'Jinji Lake', ja:'金鶏湖', ko:'진지호' },
  '周莊': { 'zh-CN':'周庄', en:'Zhouzhuang', ja:'周荘', ko:'저우좡' },
  // Zhuhai
  '情侶路': { 'zh-CN':'情侣路', en:'Lovers\' Road', ja:'情侶路', ko:'칭뤼루' },
  '長隆海洋王國': { 'zh-CN':'长隆海洋王国', en:'Chimelong Ocean Kingdom', ja:'長隆海洋王国', ko:'창룽 오션킹덤' },
  '珠海漁女': { 'zh-CN':'珠海渔女', en:'Fisher Girl Statue', ja:'珠海漁女像', ko:'주하이 어녀상' },
  '橫琴': { 'zh-CN':'横琴', en:'Hengqin', ja:'横琴', ko:'헝친' },
  '御溫泉': { 'zh-CN':'御温泉', en:'Imperial Springs', ja:'御温泉', ko:'위원천' },
  '外伶仃島': { 'zh-CN':'外伶仃岛', en:'Wailingding Island', ja:'外伶仃島', ko:'와이링딩섬' },
  // Foshan
  '祖廟': { 'zh-CN':'祖庙', en:'Ancestral Temple', ja:'祖廟', ko:'조묘' },
  '嶺南天地': { 'zh-CN':'岭南天地', en:'Lingnan Tiandi', ja:'嶺南天地', ko:'링난톈디' },
  '順德': { 'zh-CN':'顺德', en:'Shunde', ja:'順徳', ko:'순더' },
  '南風古灶': { 'zh-CN':'南风古灶', en:'Nanfeng Ancient Kiln', ja:'南風古窯', ko:'난펑고요' },
  '西樵山': { 'zh-CN':'西樵山', en:'Mount Xiqiao', ja:'西樵山', ko:'시차오산' },
  // Tokyo
  '澀谷': { 'zh-CN':'涩谷', en:'Shibuya', ja:'渋谷', ko:'시부야' },
  '新宿': { 'zh-CN':'新宿', en:'Shinjuku', ja:'新宿', ko:'신주쿠' },
  '淺草': { 'zh-CN':'浅草', en:'Asakusa', ja:'浅草', ko:'아사쿠사' },
  '銀座': { 'zh-CN':'银座', en:'Ginza', ja:'銀座', ko:'긴자' },
  '原宿': { 'zh-CN':'原宿', en:'Harajuku', ja:'原宿', ko:'하라주쿠' },
  '六本木': { 'zh-CN':'六本木', en:'Roppongi', ja:'六本木', ko:'롯폰기' },
  '秋葉原': { 'zh-CN':'秋叶原', en:'Akihabara', ja:'秋葉原', ko:'아키하바라' },
  '池袋': { 'zh-CN':'池袋', en:'Ikebukuro', ja:'池袋', ko:'이케부쿠로' },
  '上野': { 'zh-CN':'上野', en:'Ueno', ja:'上野', ko:'우에노' },
  '築地': { 'zh-CN':'筑地', en:'Tsukiji', ja:'築地', ko:'쓰키지' },
  '台場': { 'zh-CN':'台场', en:'Odaiba', ja:'お台場', ko:'오다이바' },
  '赤坂': { 'zh-CN':'赤坂', en:'Akasaka', ja:'赤坂', ko:'아카사카' },
  '惠比壽': { 'zh-CN':'惠比寿', en:'Ebisu', ja:'恵比寿', ko:'에비스' },
  '代官山': { 'zh-CN':'代官山', en:'Daikanyama', ja:'代官山', ko:'다이칸야마' },
  '中目黑': { 'zh-CN':'中目黑', en:'Nakameguro', ja:'中目黒', ko:'나카메구로' },
  // Osaka
  '道頓堀': { 'zh-CN':'道顿堀', en:'Dotonbori', ja:'道頓堀', ko:'도톤보리' },
  '心齋橋': { 'zh-CN':'心斋桥', en:'Shinsaibashi', ja:'心斎橋', ko:'신사이바시' },
  '難波': { 'zh-CN':'难波', en:'Namba', ja:'難波', ko:'난바' },
  '梅田': { 'zh-CN':'梅田', en:'Umeda', ja:'梅田', ko:'우메다' },
  '天王寺': { 'zh-CN':'天王寺', en:'Tennoji', ja:'天王寺', ko:'덴노지' },
  '新世界': { 'zh-CN':'新世界', en:'Shinsekai', ja:'新世界', ko:'신세카이' },
  '北堀江': { 'zh-CN':'北堀江', en:'Kitahorie', ja:'北堀江', ko:'기타호리에' },
  '大阪城': { 'zh-CN':'大阪城', en:'Osaka Castle', ja:'大阪城', ko:'오사카성' },
  '福島': { 'zh-CN':'福岛', en:'Fukushima (Osaka)', ja:'福島', ko:'후쿠시마(오사카)' },
  '此花区': { 'zh-CN':'此花区', en:'Konohana', ja:'此花区', ko:'고노하나' },
  // Kyoto
  '祇園': { 'zh-CN':'祇园', en:'Gion', ja:'祇園', ko:'기온' },
  '嵐山': { 'zh-CN':'岚山', en:'Arashiyama', ja:'嵐山', ko:'아라시야마' },
  '伏見稻荷': { 'zh-CN':'伏见稻荷', en:'Fushimi Inari', ja:'伏見稲荷', ko:'후시미이나리' },
  '金閣寺': { 'zh-CN':'金阁寺', en:'Kinkaku-ji', ja:'金閣寺', ko:'긴카쿠지' },
  '四條河原町': { 'zh-CN':'四条河原町', en:'Shijo Kawaramachi', ja:'四条河原町', ko:'시조 가와라마치' },
  '清水坂': { 'zh-CN':'清水坂', en:'Kiyomizuzaka', ja:'清水坂', ko:'기요미즈자카' },
  '錦市場': { 'zh-CN':'锦市场', en:'Nishiki Market', ja:'錦市場', ko:'니시키 시장' },
  '嵯峨野': { 'zh-CN':'嵯峨野', en:'Sagano', ja:'嵯峨野', ko:'사가노' },
  '哲學之道': { 'zh-CN':'哲学之道', en:'Philosopher\'s Path', ja:'哲学の道', ko:'철학의 길' },
  // Fukuoka
  '博多': { 'zh-CN':'博多', en:'Hakata', ja:'博多', ko:'하카타' },
  '中洲': { 'zh-CN':'中洲', en:'Nakasu', ja:'中洲', ko:'나카스' },
  '天神': { 'zh-CN':'天神', en:'Tenjin', ja:'天神', ko:'덴진' },
  '大濠公園': { 'zh-CN':'大濠公园', en:'Ohori Park', ja:'大濠公園', ko:'오호리공원' },
  '太宰府': { 'zh-CN':'太宰府', en:'Dazaifu', ja:'太宰府', ko:'다자이후' },
  '糸島': { 'zh-CN':'系岛', en:'Itoshima', ja:'糸島', ko:'이토시마' },
  '門司港': { 'zh-CN':'门司港', en:'Mojiko', ja:'門司港', ko:'모지코' },
  '小倉': { 'zh-CN':'小仓', en:'Kokura', ja:'小倉', ko:'고쿠라' },
  // Sapporo
  '大通公園': { 'zh-CN':'大通公园', en:'Odori Park', ja:'大通公園', ko:'오도리공원' },
  '薄野': { 'zh-CN':'薄野', en:'Susukino', ja:'すすきの', ko:'스스키노' },
  '圓山': { 'zh-CN':'圆山', en:'Maruyama', ja:'円山', ko:'마루야마' },
  '定山溪': { 'zh-CN':'定山溪', en:'Jozankei', ja:'定山渓', ko:'조잔케이' },
  '小樽': { 'zh-CN':'小樽', en:'Otaru', ja:'小樽', ko:'오타루' },
  '富良野': { 'zh-CN':'富良野', en:'Furano', ja:'富良野', ko:'후라노' },
  '旭川': { 'zh-CN':'旭川', en:'Asahikawa', ja:'旭川', ko:'아사히카와' },
  '函館': { 'zh-CN':'函馆', en:'Hakodate', ja:'函館', ko:'하코다테' },
  // Nagoya
  '榮': { 'zh-CN':'荣', en:'Sakae', ja:'栄', ko:'사카에' },
  '名古屋城': { 'zh-CN':'名古屋城', en:'Nagoya Castle', ja:'名古屋城', ko:'나고야성' },
  '大須': { 'zh-CN':'大须', en:'Osu', ja:'大須', ko:'오스' },
  '矢場町': { 'zh-CN':'矢场町', en:'Yabacho', ja:'矢場町', ko:'야바초' },
  '伏見': { 'zh-CN':'伏见', en:'Fushimi (Nagoya)', ja:'伏見', ko:'후시미(나고야)' },
  '栄生': { 'zh-CN':'荣生', en:'Sakaemachi', ja:'栄生', ko:'사카에마치' },
  '熱田神宮': { 'zh-CN':'热田神宫', en:'Atsuta Shrine', ja:'熱田神宮', ko:'아쓰타신궁' },
  // Okinawa
  '今歸仁': { 'zh-CN':'今归仁', en:'Nakijin', ja:'今帰仁', ko:'나키진' },
  '沖繩市': { 'zh-CN':'冲绳市', en:'Okinawa City', ja:'沖縄市', ko:'오키나와시' },
  '北谷': { 'zh-CN':'北谷', en:'Chatan', ja:'北谷', ko:'차탄' },
  '本部': { 'zh-CN':'本部', en:'Motobu', ja:'本部', ko:'모토부' },
  '名護': { 'zh-CN':'名护', en:'Nago', ja:'名護', ko:'나고' },
  '南城': { 'zh-CN':'南城', en:'Nanjo', ja:'南城', ko:'난조' },
  '讀谷': { 'zh-CN':'读谷', en:'Yomitan', ja:'読谷', ko:'요미탄' },
  '豐見城': { 'zh-CN':'丰见城', en:'Tomigusuku', ja:'豊見城', ko:'도미구스쿠' },
  '恩納': { 'zh-CN':'恩纳', en:'Onna', ja:'恩納', ko:'온나' },
  '北中城': { 'zh-CN':'北中城', en:'Kitanakagusuku', ja:'北中城', ko:'기타나카구스쿠' },
  '宇流麻': { 'zh-CN':'宇流麻', en:'Uruma', ja:'うるま', ko:'우루마' },
  '竹富': { 'zh-CN':'竹富', en:'Taketomi', ja:'竹富', ko:'다케토미' },
  '宜野灣': { 'zh-CN':'宜野湾', en:'Ginowan', ja:'宜野湾', ko:'기노완' },
  '浦添': { 'zh-CN':'浦添', en:'Urasoe', ja:'浦添', ko:'우라소에' },
  '糸滿': { 'zh-CN':'糸满', en:'Itoman', ja:'糸満', ko:'이토만' },
  '國頭': { 'zh-CN':'国头', en:'Kunigami', ja:'国頭', ko:'구니가미' },
  '東村': { 'zh-CN':'东村', en:'Higashi', ja:'東村', ko:'히가시' },
  '西原': { 'zh-CN':'西原', en:'Nishihara', ja:'西原', ko:'니시하라' },
  '渡嘉敷': { 'zh-CN':'渡嘉敷', en:'Tokashiki', ja:'渡嘉敷', ko:'도카시키' },
  '中城': { 'zh-CN':'中城', en:'Nakagusuku', ja:'中城', ko:'나카구스쿠' },
  '座間味': { 'zh-CN':'座间味', en:'Zamami', ja:'座間味', ko:'자마미' },
  '嘉手納': { 'zh-CN':'嘉手纳', en:'Kadena', ja:'嘉手納', ko:'가데나' },
  '金武': { 'zh-CN':'金武', en:'Kin', ja:'金武', ko:'긴' },
  '伊江': { 'zh-CN':'伊江', en:'Ie', ja:'伊江', ko:'이에' },
  '那霸': { 'zh-CN':'那霸', en:'Naha', ja:'那覇', ko:'나하' },
  '國際通': { 'zh-CN':'国际通', en:'Kokusai Street', ja:'国際通り', ko:'고쿠사이도리' },
  '美浮山': { 'zh-CN':'美浮山', en:'Bihyama', ja:'美浮山', ko:'비후야마' },
  '古宇利島': { 'zh-CN':'古宇利岛', en:'Kouri Island', ja:'古宇利島', ko:'고우리섬' },
  '石垣島': { 'zh-CN':'石垣岛', en:'Ishigaki Island', ja:'石垣島', ko:'이시가키섬' },
  '宮古島': { 'zh-CN':'宫古岛', en:'Miyako Island', ja:'宮古島', ko:'미야코섬' },
  '美麗海水族館': { 'zh-CN':'美丽海水族馆', en:'Churaumi Aquarium', ja:'美ら海水族館', ko:'추라우미 수족관' },
  '首里城': { 'zh-CN':'首里城', en:'Shuri Castle', ja:'首里城', ko:'슈리성' },
  // Hiroshima
  '和平紀念公園': { 'zh-CN':'和平纪念公园', en:'Peace Memorial Park', ja:'平和記念公園', ko:'평화기념공원' },
  '宮島': { 'zh-CN':'宫岛', en:'Miyajima', ja:'宮島', ko:'미야지마' },
  '廣島城': { 'zh-CN':'广岛城', en:'Hiroshima Castle', ja:'広島城', ko:'히로시마성' },
  '本通': { 'zh-CN':'本通', en:'Hondori', ja:'本通', ko:'혼도리' },
  '紙屋町': { 'zh-CN':'纸屋町', en:'Kamiyacho', ja:'紙屋町', ko:'가미야초' },
  '袋町': { 'zh-CN':'袋町', en:'Fukuromachi', ja:'袋町', ko:'후쿠로마치' },
  '尾道': { 'zh-CN':'尾道', en:'Onomichi', ja:'尾道', ko:'오노미치' },
  // Nara
  '奈良公園': { 'zh-CN':'奈良公园', en:'Nara Park', ja:'奈良公園', ko:'나라공원' },
  '東大寺': { 'zh-CN':'东大寺', en:'Todai-ji', ja:'東大寺', ko:'도다이지' },
  '春日大社': { 'zh-CN':'春日大社', en:'Kasuga Taisha', ja:'春日大社', ko:'가스가타이샤' },
  '興福寺': { 'zh-CN':'兴福寺', en:'Kofuku-ji', ja:'興福寺', ko:'고후쿠지' },
  '吉城園': { 'zh-CN':'吉城园', en:'Yoshikien Garden', ja:'吉城園', ko:'요시키엔' },
  '元興寺': { 'zh-CN':'元兴寺', en:'Gango-ji', ja:'元興寺', ko:'간고지' },
  '柳生': { 'zh-CN':'柳生', en:'Yagyu', ja:'柳生', ko:'야기우' },
  // Kobe
  '北野異人館': { 'zh-CN':'北野异人馆', en:'Kitano Ijinkan', ja:'北野異人館', ko:'기타노 이진칸' },
  '南京町': { 'zh-CN':'南京町', en:'Nankinmachi (Chinatown)', ja:'南京町', ko:'난킨마치' },
  '三宮': { 'zh-CN':'三宫', en:'Sannomiya', ja:'三宮', ko:'산노미야' },
  '元町': { 'zh-CN':'元町', en:'Motomachi', ja:'元町', ko:'모토마치' },
  '六甲山': { 'zh-CN':'六甲山', en:'Mount Rokko', ja:'六甲山', ko:'롯코산' },
  '有馬溫泉': { 'zh-CN':'有马温泉', en:'Arima Onsen', ja:'有馬温泉', ko:'아리마 온천' },
  '舞子': { 'zh-CN':'舞子', en:'Maiko', ja:'舞子', ko:'마이코' },
  // Kanazawa
  '兼六園': { 'zh-CN':'兼六园', en:'Kenrokuen Garden', ja:'兼六園', ko:'겐로쿠엔' },
  '長町武家屋敷': { 'zh-CN':'长町武家屋敷', en:'Nagamachi Samurai District', ja:'長町武家屋敷', ko:'나가마치 무가야시키' },
  '東茶屋街': { 'zh-CN':'东茶屋街', en:'Higashi Chaya District', ja:'東茶屋街', ko:'히가시차야가이' },
  '近江町市場': { 'zh-CN':'近江町市场', en:'Omicho Market', ja:'近江町市場', ko:'오미초 시장' },
  '金澤城公園': { 'zh-CN':'金泽城公园', en:'Kanazawa Castle Park', ja:'金沢城公園', ko:'가나자와성공원' },
  '西茶屋街': { 'zh-CN':'西茶屋街', en:'Nishi Chaya District', ja:'にし茶屋街', ko:'니시차야가이' },
  // Kumamoto
  '熊本城': { 'zh-CN':'熊本城', en:'Kumamoto Castle', ja:'熊本城', ko:'구마모토성' },
  '上通町': { 'zh-CN':'上通町', en:'Kamitoricho', ja:'上通町', ko:'가미토리초' },
  '下通町': { 'zh-CN':'下通町', en:'Shimotoricho', ja:'下通町', ko:'시모토리초' },
  '水前寺公園': { 'zh-CN':'水前寺公园', en:'Suizenji Garden', ja:'水前寺公園', ko:'스이젠지공원' },
  '黑川溫泉': { 'zh-CN':'黑川温泉', en:'Kurokawa Onsen', ja:'黒川温泉', ko:'구로카와 온천' },
  '阿蘇山': { 'zh-CN':'阿苏山', en:'Mount Aso', ja:'阿蘇山', ko:'아소산' },
  // Kagoshima
  '天文館': { 'zh-CN':'天文馆', en:'Tenmonkan', ja:'天文館', ko:'덴몬칸' },
  '櫻島': { 'zh-CN':'樱岛', en:'Sakurajima', ja:'桜島', ko:'사쿠라지마' },
  '仙巖園': { 'zh-CN':'仙岩园', en:'Sengan-en', ja:'仙巌園', ko:'센간엔' },
  '鹿兒島中央車站': { 'zh-CN':'鹿儿岛中央车站', en:'Kagoshima Chuo Station', ja:'鹿児島中央駅', ko:'가고시마추오역' },
  '指宿溫泉': { 'zh-CN':'指宿温泉', en:'Ibusuki Onsen', ja:'指宿温泉', ko:'이부스키 온천' },
  '霧島': { 'zh-CN':'雾岛', en:'Kirishima', ja:'霧島', ko:'기리시마' },
  // Nagasaki
  '出島': { 'zh-CN':'出岛', en:'Dejima', ja:'出島', ko:'데지마' },
  '眼鏡橋': { 'zh-CN':'眼镜桥', en:'Meganebashi', ja:'眼鏡橋', ko:'메가네바시' },
  '中華街': { 'zh-CN':'中华街', en:'Chinatown', ja:'中華街', ko:'중화가' },
  '稻佐山': { 'zh-CN':'稻佐山', en:'Mount Inasa', ja:'稲佐山', ko:'이나사산' },
  '平和公園': { 'zh-CN':'平和公园', en:'Peace Park', ja:'平和公園', ko:'평화공원' },
  '豪斯登堡': { 'zh-CN':'豪斯登堡', en:'Huis Ten Bosch', ja:'ハウステンボス', ko:'하우스텐보스' },
  // Sendai
  '青葉城址': { 'zh-CN':'青叶城址', en:'Aoba Castle Ruins', ja:'青葉城址', ko:'아오바성터' },
  '國分町': { 'zh-CN':'国分町', en:'Kokubuncho', ja:'国分町', ko:'고쿠분초' },
  '仙台站': { 'zh-CN':'仙台站', en:'Sendai Station', ja:'仙台駅', ko:'센다이역' },
  '松島': { 'zh-CN':'松岛', en:'Matsushima', ja:'松島', ko:'마쓰시마' },
  '秋保溫泉': { 'zh-CN':'秋保温泉', en:'Akiu Onsen', ja:'秋保温泉', ko:'아키우 온천' },
  '定禪寺通': { 'zh-CN':'定禅寺通', en:'Jozenji Street', ja:'定禅寺通り', ko:'조젠지도리' },
  // Nikko
  '東照宮': { 'zh-CN':'东照宫', en:'Toshogu Shrine', ja:'東照宮', ko:'도쇼구' },
  '中禪寺湖': { 'zh-CN':'中禅寺湖', en:'Lake Chuzenji', ja:'中禅寺湖', ko:'주젠지호' },
  '華嚴瀑布': { 'zh-CN':'华严瀑布', en:'Kegon Falls', ja:'華厳滝', ko:'게곤폭포' },
  '日光江戶村': { 'zh-CN':'日光江户村', en:'Nikko Edomura', ja:'日光江戸村', ko:'닛코에도무라' },
  '鬼怒川溫泉': { 'zh-CN':'鬼怒川温泉', en:'Kinugawa Onsen', ja:'鬼怒川温泉', ko:'기누가와 온천' },
  // Hakone
  '蘆之湖': { 'zh-CN':'芦之湖', en:'Lake Ashi', ja:'芦ノ湖', ko:'아시노코' },
  '大涌谷': { 'zh-CN':'大涌谷', en:'Owakudani', ja:'大涌谷', ko:'오와쿠다니' },
  '箱根神社': { 'zh-CN':'箱根神社', en:'Hakone Shrine', ja:'箱根神社', ko:'하코네신사' },
  '雕刻之森美術館': { 'zh-CN':'雕刻之森美术馆', en:'Hakone Open-Air Museum', ja:'彫刻の森美術館', ko:'조각의숲미술관' },
  '強羅': { 'zh-CN':'强罗', en:'Gora', ja:'強羅', ko:'고라' },
  '仙石原': { 'zh-CN':'仙石原', en:'Sengokuhara', ja:'仙石原', ko:'센고쿠하라' },
  // Hokkaido
  '美瑛': { 'zh-CN':'美瑛', en:'Biei', ja:'美瑛', ko:'비에이' },
  '洞爺湖': { 'zh-CN':'洞爷湖', en:'Lake Toya', ja:'洞爺湖', ko:'도야호' },
  '二世谷': { 'zh-CN':'二世谷', en:'Niseko', ja:'ニセコ', ko:'니세코' },
  '旭川動物園': { 'zh-CN':'旭川动物园', en:'Asahiyama Zoo', ja:'旭山動物園', ko:'아사히야마동물원' },
  // Seoul
  '明洞': { 'zh-CN':'明洞', en:'Myeongdong', ja:'明洞', ko:'명동' },
  '弘大': { 'zh-CN':'弘大', en:'Hongdae', ja:'弘大', ko:'홍대' },
  '江南': { 'zh-CN':'江南', en:'Gangnam', ja:'江南', ko:'강남' },
  '東大門': { 'zh-CN':'东大门', en:'Dongdaemun', ja:'東大門', ko:'동대문' },
  '仁寺洞': { 'zh-CN':'仁寺洞', en:'Insadong', ja:'仁寺洞', ko:'인사동' },
  '梨泰院': { 'zh-CN':'梨泰院', en:'Itaewon', ja:'梨泰院', ko:'이태원' },
  '北村': { 'zh-CN':'北村', en:'Bukchon', ja:'北村', ko:'북촌' },
  '益善洞': { 'zh-CN':'益善洞', en:'Ikseondong', ja:'益善洞', ko:'익선동' },
  '聖水洞': { 'zh-CN':'圣水洞', en:'Seongsudong', ja:'聖水洞', ko:'성수동' },
  '光化門': { 'zh-CN':'光化门', en:'Gwanghwamun', ja:'光化門', ko:'광화문' },
  '慶福宮': { 'zh-CN':'庆福宫', en:'Gyeongbokgung', ja:'景福宮', ko:'경복궁' },
  '樂天世界': { 'zh-CN':'乐天世界', en:'Lotte World', ja:'ロッテワールド', ko:'롯데월드' },
  // Busan
  '海雲台': { 'zh-CN':'海云台', en:'Haeundae', ja:'海雲台', ko:'해운대' },
  '廣安里': { 'zh-CN':'广安里', en:'Gwangalli', ja:'広安里', ko:'광안리' },
  '南浦洞': { 'zh-CN':'南浦洞', en:'Nampodong', ja:'南浦洞', ko:'남포동' },
  '甘川文化村': { 'zh-CN':'甘川文化村', en:'Gamcheon Culture Village', ja:'甘川文化村', ko:'감천문화마을' },
  '影島': { 'zh-CN':'影岛', en:'Yeongdo', ja:'影島', ko:'영도' },
  '機張': { 'zh-CN':'机张', en:'Gijang', ja:'機張', ko:'기장' },
  '西面': { 'zh-CN':'西面', en:'Seomyeon', ja:'西面', ko:'서면' },
  // Jeju
  '濟州市': { 'zh-CN':'济州市', en:'Jeju City', ja:'済州市', ko:'제주시' },
  '西歸浦': { 'zh-CN':'西归浦', en:'Seogwipo', ja:'西帰浦', ko:'서귀포' },
  '城山日出峰': { 'zh-CN':'城山日出峰', en:'Seongsan Ilchulbong', ja:'城山日出峰', ko:'성산일출봉' },
  '漢拏山': { 'zh-CN':'汉拿山', en:'Hallasan', ja:'漢拏山', ko:'한라산' },
  '牛島': { 'zh-CN':'牛岛', en:'Udo Island', ja:'牛島', ko:'우도' },
  '萬丈窟': { 'zh-CN':'万丈窟', en:'Manjanggul Cave', ja:'万丈窟', ko:'만장굴' },
  'O\'Sulloc茶園': { 'zh-CN':'O\'Sulloc茶园', en:'O\'sulloc Tea Garden', ja:'オソルロック茶畑', ko:'오설록 티뮤지엄' },
  '翰林': { 'zh-CN':'翰林', en:'Hallim', ja:'翰林', ko:'한림' },
  // Incheon
  '仁川中華街': { 'zh-CN':'仁川中华街', en:'Incheon Chinatown', ja:'仁川中華街', ko:'인천차이나타운' },
  '松島國際都市': { 'zh-CN':'松岛国际都市', en:'Songdo International City', ja:'松島国際都市', ko:'송도국제도시' },
  '月尾島': { 'zh-CN':'月尾岛', en:'Wolmido', ja:'月尾島', ko:'월미도' },
  '富平': { 'zh-CN':'富平', en:'Bupyeong', ja:'富平', ko:'부평' },
  '江華島': { 'zh-CN':'江华岛', en:'Ganghwado', ja:'江華島', ko:'강화도' },
  '仁川大公園': { 'zh-CN':'仁川大公园', en:'Incheon Grand Park', ja:'仁川大公園', ko:'인천대공원' },
  '仁川國際機場': { 'zh-CN':'仁川国际机场', en:'Incheon International Airport', ja:'仁川国際空港', ko:'인천국제공항' },
  // Gyeongju
  '佛國寺': { 'zh-CN':'佛国寺', en:'Bulguksa', ja:'仏国寺', ko:'불국사' },
  '石窟庵': { 'zh-CN':'石窟庵', en:'Seokguram Grotto', ja:'石窟庵', ko:'석굴암' },
  '大陵苑': { 'zh-CN':'大陵苑', en:'Daereungwon Tomb Complex', ja:'大陵苑', ko:'대릉원' },
  '東宮與月池': { 'zh-CN':'东宫与月池', en:'Donggung Palace and Wolji Pond', ja:'東宮と月池', ko:'동궁과 월지' },
  '良洞民俗村': { 'zh-CN':'良洞民俗村', en:'Yangdong Folk Village', ja:'良洞民俗村', ko:'양동민속마을' },
  '慶州歷史遺跡區': { 'zh-CN':'庆州历史遗迹区', en:'Gyeongju Historic Areas', ja:'慶州歴史遺跡地区', ko:'경주역사유적지구' },
  // Daegu
  '西門市場': { 'zh-CN':'西门市场', en:'Seomun Market', ja:'西門市場', ko:'서문시장' },
  '東城路': { 'zh-CN':'东城路', en:'Dongseongno', ja:'東城路', ko:'동성로' },
  '八公山': { 'zh-CN':'八公山', en:'Palgongsan', ja:'八公山', ko:'팔공산' },
  '金光石路': { 'zh-CN':'金光石路', en:'Kim Kwang-seok Street', ja:'キム・グァンソク通り', ko:'김광석다시그리기길' },
  '桃城洞': { 'zh-CN':'桃城洞', en:'Dosungdong', ja:'桃城洞', ko:'도성동' },
  // Singapore
  '牛車水': { 'zh-CN':'牛车水', en:'Chinatown', ja:'チャイナタウン', ko:'차이나타운' },
  '小印度': { 'zh-CN':'小印度', en:'Little India', ja:'リトルインディア', ko:'리틀인디아' },
  '克拉碼頭': { 'zh-CN':'克拉码头', en:'Clarke Quay', ja:'クラークキー', ko:'클락키' },
  '烏節路': { 'zh-CN':'乌节路', en:'Orchard Road', ja:'オーチャードロード', ko:'오차드로드' },
  '聖淘沙': { 'zh-CN':'圣淘沙', en:'Sentosa', ja:'セントーサ島', ko:'센토사' },
  '濱海灣': { 'zh-CN':'滨海湾', en:'Marina Bay', ja:'マリーナベイ', ko:'마리나베이' },
  '武吉士': { 'zh-CN':'武吉士', en:'Bugis', ja:'ブギス', ko:'부기스' },
  '樟宜': { 'zh-CN':'樟宜', en:'Changi', ja:'チャンギ', ko:'창이' },
  '植物園': { 'zh-CN':'植物园', en:'Botanic Gardens', ja:'植物園', ko:'식물원' },
  // Bangkok
  '暹羅': { 'zh-CN':'暹罗', en:'Siam', ja:'サイアム', ko:'싸얌' },
  '考山路': { 'zh-CN':'考山路', en:'Khao San Road', ja:'カオサン通り', ko:'카오산로드' },
  '是隆': { 'zh-CN':'是隆', en:'Silom', ja:'シーロム', ko:'실롬' },
  '素坤逸': { 'zh-CN':'素坤逸', en:'Sukhumvit', ja:'スクンビット', ko:'수쿰빗' },
  '老城區': { 'zh-CN':'老城区', en:'Old Town', ja:'旧市街', ko:'구시가지' },
  '中國城': { 'zh-CN':'中国城', en:'Chinatown', ja:'チャイナタウン', ko:'차이나타운' },
  '查圖查週末市場': { 'zh-CN':'查图查周末市场', en:'Chatuchak Weekend Market', ja:'チャトゥチャック市場', ko:'짜뚜짝 시장' },
  '阿索克': { 'zh-CN':'阿索克', en:'Asok', ja:'アソーク', ko:'아속' },
  // Chiang Mai
  '古城區': { 'zh-CN':'古城区', en:'Old City', ja:'旧市街', ko:'올드시티' },
  '尼曼路': { 'zh-CN':'尼曼路', en:'Nimman Road', ja:'ニマンヘミン通り', ko:'님만해민' },
  '夜市': { 'zh-CN':'夜市', en:'Night Market', ja:'ナイトマーケット', ko:'야시장' },
  '素帖山': { 'zh-CN':'素贴山', en:'Doi Suthep', ja:'ドイステープ', ko:'도이수텝' },
  '雙龍寺': { 'zh-CN':'双龙寺', en:'Wat Phra That Doi Suthep', ja:'ワット・プラタート・ドイステープ', ko:'왓 프라탓 도이수텝' },
  '清邁夜市': { 'zh-CN':'清迈夜市', en:'Chiang Mai Night Bazaar', ja:'チェンマイ・ナイトバザール', ko:'치앙마이 나이트바자' },
  '三王紀念碑': { 'zh-CN':'三王纪念碑', en:'Three Kings Monument', ja:'三王記念碑', ko:'삼왕기념비' },
  // Phuket
  '芭東': { 'zh-CN':'芭东', en:'Patong', ja:'パトン', ko:'파통' },
  '卡塔': { 'zh-CN':'卡塔', en:'Kata', ja:'カタ', ko:'까따' },
  '卡隆': { 'zh-CN':'卡隆', en:'Karon', ja:'カロン', ko:'까론' },
  '老城': { 'zh-CN':'老城', en:'Old Town', ja:'旧市街', ko:'구시가지' },
  '奈漢': { 'zh-CN':'奈汉', en:'Nai Harn', ja:'ナイハン', ko:'나이한' },
  'Rawai': { 'zh-CN':'拉威', en:'Rawai', ja:'ラワイ', ko:'라와이' },
  '拉威': { 'zh-CN':'拉威', en:'Rawai', ja:'ラワイ', ko:'라와이' },
  '攀牙灣': { 'zh-CN':'攀牙湾', en:'Phang Nga Bay', ja:'パンガー湾', ko:'팡아만' },
  // Chiang Rai
  '白廟': { 'zh-CN':'白庙', en:'White Temple', ja:'ワットロンクン(白い寺)', ko:'왓 롱쿤(백색사원)' },
  '藍廟': { 'zh-CN':'蓝庙', en:'Blue Temple', ja:'ブルーテンプル', ko:'블루템플' },
  '黑屋博物館': { 'zh-CN':'黑屋博物馆', en:'Baan Dam Museum', ja:'ブラックハウス博物館', ko:'반담박물관' },
  '金三角': { 'zh-CN':'金三角', en:'Golden Triangle', ja:'ゴールデントライアングル', ko:'골든트라이앵글' },
  // Krabi
  '奧南海灘': { 'zh-CN':'奥南海滩', en:'Ao Nang Beach', ja:'アオナン・ビーチ', ko:'아오낭비치' },
  '雷利海灘': { 'zh-CN':'雷利海滩', en:'Railay Beach', ja:'ライレイ・ビーチ', ko:'라일레이비치' },
  '四島遊': { 'zh-CN':'四岛游', en:'Four Islands Tour', ja:'4島ツアー', ko:'포아일랜드투어' },
  '甲米鎮': { 'zh-CN':'甲米镇', en:'Krabi Town', ja:'クラビタウン', ko:'끄라비타운' },
  // Pattaya
  '芭達雅海灘': { 'zh-CN':'芭堤雅海滩', en:'Pattaya Beach', ja:'パタヤ・ビーチ', ko:'파타야비치' },
  '真理寺': { 'zh-CN':'真理寺', en:'Sanctuary of Truth', ja:'サンクチュアリ・オブ・トゥルース', ko:'사원 오브 트루스' },
  '格蘭島': { 'zh-CN':'格兰岛', en:'Koh Larn', ja:'ラン島', ko:'란섬' },
  '芭達雅步行街': { 'zh-CN':'芭堤雅步行街', en:'Pattaya Walking Street', ja:'パタヤ・ウォーキングストリート', ko:'파타야워킹스트리트' },
  // Bali
  '庫塔': { 'zh-CN':'库塔', en:'Kuta', ja:'クタ', ko:'꾸따' },
  '水明漾': { 'zh-CN':'水明漾', en:'Seminyak', ja:'スミニャック', ko:'스미냑' },
  '烏布': { 'zh-CN':'乌布', en:'Ubud', ja:'ウブド', ko:'우붓' },
  '努沙杜瓦': { 'zh-CN':'努沙杜瓦', en:'Nusa Dua', ja:'ヌサドゥア', ko:'누사두아' },
  '金巴蘭': { 'zh-CN':'金巴兰', en:'Jimbaran', ja:'ジンバラン', ko:'짐바란' },
  '水渡口': { 'zh-CN':'水渡口', en:'Sanur', ja:'サヌール', ko:'사누르' },
  '克羅波坎': { 'zh-CN':'克罗波坎', en:'Canggu', ja:'チャングー', ko:'짱구' },
  '坎古': { 'zh-CN':'坎古', en:'Canggu', ja:'チャングー', ko:'짱구' },
  '登巴薩': { 'zh-CN':'登巴萨', en:'Denpasar', ja:'デンパサール', ko:'덴파사르' },
  // Jakarta
  '科塔': { 'zh-CN':'科塔', en:'Kota Tua (Old Town)', ja:'コタ・トゥア', ko:'꼬따뚜아' },
  '甘榜查利亞': { 'zh-CN':'甘榜查利亚', en:'Kampung Chalia', ja:'カンプンチャリア', ko:'깜뿡찰리아' },
  '布洛克M': { 'zh-CN':'布洛克M', en:'Blok M', ja:'ブロックM', ko:'블록M' },
  '蘇迪曼': { 'zh-CN':'苏迪曼', en:'Sudirman', ja:'スディルマン', ko:'수디르만' },
  '坦格朗': { 'zh-CN':'坦格朗', en:'Tangerang', ja:'タンゲラン', ko:'땅그랑' },
  '科莫多港': { 'zh-CN':'科摩多港', en:'Tanjung Priok', ja:'タンジュンプリオク港', ko:'딴중쁘리옥항' },
  // Yogyakarta
  '婆羅浮屠': { 'zh-CN':'婆罗浮屠', en:'Borobudur', ja:'ボロブドゥール', ko:'보로부두르' },
  '普蘭班南': { 'zh-CN':'普兰巴南', en:'Prambanan', ja:'プランバナン', ko:'프람바난' },
  '克拉頓': { 'zh-CN':'克拉顿', en:'Kraton (Sultan\'s Palace)', ja:'クラトン王宮', ko:'끄라톤 왕궁' },
  '馬里奧博羅街': { 'zh-CN':'马里奥波罗街', en:'Malioboro Street', ja:'マリオボロ通り', ko:'말리오보로거리' },
  '烏布都': { 'zh-CN':'乌布都', en:'Ubud (Yogyakarta area)', ja:'ウブド地区', ko:'우붓 지역' },
  '日惹城堡': { 'zh-CN':'日惹城堡', en:'Yogyakarta Palace', ja:'ジョグジャカルタ王宮', ko:'족자카르타 왕궁' },
  // Surabaya
  '蘇拉巴亞動物園': { 'zh-CN':'苏拉巴亚动物园', en:'Surabaya Zoo', ja:'スラバヤ動物園', ko:'수라바야동물원' },
  '英雄紀念碑': { 'zh-CN':'英雄纪念碑', en:'Heroes Monument', ja:'英雄記念碑', ko:'영웅기념비' },
  '紅橋': { 'zh-CN':'红桥', en:'Red Bridge (Jembatan Merah)', ja:'赤い橋', ko:'젬바탄메라' },
  // Komodo
  '科莫多國家公園': { 'zh-CN':'科摩多国家公园', en:'Komodo National Park', ja:'コモド国立公園', ko:'코모도국립공원' },
  '粉紅沙灘': { 'zh-CN':'粉红沙滩', en:'Pink Beach', ja:'ピンクビーチ', ko:'핑크비치' },
  '巴達爾島': { 'zh-CN':'巴达尔岛', en:'Padar Island', ja:'パダール島', ko:'파다르섬' },
  '林卡島': { 'zh-CN':'林卡岛', en:'Rinca Island', ja:'リンチャ島', ko:'린짜섬' },
  // Kuala Lumpur
  '武吉免登': { 'zh-CN':'武吉免登', en:'Bukit Bintang', ja:'ブキビンタン', ko:'부킷빈탕' },
  'KLCC': { 'zh-CN':'KLCC', en:'KLCC', ja:'KLCC', ko:'KLCC' },
  '茨廠街': { 'zh-CN':'茨厂街', en:'Petaling Street', ja:'プタリン通り(チャイナタウン)', ko:'페탈링거리' },
  '孟沙': { 'zh-CN':'孟沙', en:'Bangsar', ja:'バンサー', ko:'방사' },
  '班底谷': { 'zh-CN':'班底谷', en:'Bandar Utama', ja:'バンダーウタマ', ko:'반다르우타마' },
  '黑風洞': { 'zh-CN':'黑风洞', en:'Batu Caves', ja:'バトゥ洞窟', ko:'바투동굴' },
  '布城': { 'zh-CN':'布城', en:'Putrajaya', ja:'プトラジャヤ', ko:'푸트라자야' },
  // Penang
  '喬治市': { 'zh-CN':'乔治市', en:'George Town', ja:'ジョージタウン', ko:'조지타운' },
  '峇都丁宜': { 'zh-CN':'峇都丁宜', en:'Batu Ferringhi', ja:'バトゥフェリンギ', ko:'바투페린기' },
  '亞依淡': { 'zh-CN':'亚依淡', en:'Air Itam', ja:'エアイタム', ko:'에어이탐' },
  '直落峇賴': { 'zh-CN':'直落峇赖', en:'Teluk Bahang', ja:'テロッバハン', ko:'텔룩바항' },
  '升旗山': { 'zh-CN':'升旗山', en:'Penang Hill', ja:'ペナンヒル', ko:'페낭힐' },
  '峇都茅': { 'zh-CN':'峇都茅', en:'Batu Maung', ja:'バトゥマウン', ko:'바투마웅' },
  // Malacca
  '雞場街': { 'zh-CN':'鸡场街', en:'Jonker Street', ja:'ジョンカー通り', ko:'존커스트리트' },
  '荷蘭紅屋': { 'zh-CN':'荷兰红屋', en:'Stadthuys (Dutch Square)', ja:'スタッダウス(オランダ広場)', ko:'스타다위스' },
  '聖保羅山': { 'zh-CN':'圣保罗山', en:'St. Paul\'s Hill', ja:'セントポールの丘', ko:'세인트폴언덕' },
  '馬六甲河畔': { 'zh-CN':'马六甲河畔', en:'Malacca Riverside', ja:'マラッカ川沿い', ko:'말라카강변' },
  // Ipoh
  '舊街場': { 'zh-CN':'旧街场', en:'Old Town', ja:'旧市街', ko:'올드타운' },
  '怡保壁畫街': { 'zh-CN':'怡保壁画街', en:'Ipoh Mural Street', ja:'イポー壁画通り', ko:'이포벽화거리' },
  '極樂洞': { 'zh-CN':'极乐洞', en:'Perak Tong Cave', ja:'ペラトン洞窟', ko:'페락퉁동굴' },
  '天空之鏡': { 'zh-CN':'天空之镜', en:'Mirror Lake', ja:'ミラーレイク', ko:'미러레이크' },
  // Kota Kinabalu
  '亞庇市中心': { 'zh-CN':'亚庇市中心', en:'Kota Kinabalu City Centre', ja:'コタキナバル中心部', ko:'코타키나발루시내' },
  '丹絨亞路海灘': { 'zh-CN':'丹绒亚路海滩', en:'Tanjung Aru Beach', ja:'タンジュンアル・ビーチ', ko:'딴중아루비치' },
  '神山': { 'zh-CN':'神山', en:'Mount Kinabalu', ja:'キナバル山', ko:'키나발루산' },
  '沙比島': { 'zh-CN':'沙比岛', en:'Sapi Island', ja:'サピ島', ko:'사피섬' },
  // Hanoi
  '還劍湖': { 'zh-CN':'还剑湖', en:'Hoan Kiem Lake', ja:'ホアンキエム湖', ko:'호안끼엠호수' },
  '文廟': { 'zh-CN':'文庙', en:'Temple of Literature', ja:'文廟', ko:'문묘' },
  '河內歌劇院': { 'zh-CN':'河内歌剧院', en:'Hanoi Opera House', ja:'ハノイ・オペラハウス', ko:'하노이오페라하우스' },
  '寧平': { 'zh-CN':'宁平', en:'Ninh Binh', ja:'ニンビン', ko:'닌빈' },
  // Ho Chi Minh City
  '第一郡': { 'zh-CN':'第一郡', en:'District 1', ja:'第1区', ko:'1군' },
  '第三郡': { 'zh-CN':'第三郡', en:'District 3', ja:'第3区', ko:'3군' },
  'Thao Dien': { 'zh-CN':'草田', en:'Thao Dien', ja:'タオディエン', ko:'타오디엔' },
  '濱城市場': { 'zh-CN':'滨城市场', en:'Ben Thanh Market', ja:'ベンタイン市場', ko:'벤탄시장' },
  '戰爭博物館': { 'zh-CN':'战争博物馆', en:'War Remnants Museum', ja:'戦争証跡博物館', ko:'전쟁박물관' },
  '湄公河': { 'zh-CN':'湄公河', en:'Mekong River', ja:'メコン川', ko:'메콩강' },
  // Da Nang
  '美山聖地': { 'zh-CN':'美山圣地', en:'My Son Sanctuary', ja:'ミーソン聖域', ko:'미선유적' },
  '會安': { 'zh-CN':'会安', en:'Hoi An', ja:'ホイアン', ko:'호이안' },
  '巴拿山': { 'zh-CN':'巴拿山', en:'Ba Na Hills', ja:'バーナーヒルズ', ko:'바나힐' },
  '美溪沙灘': { 'zh-CN':'美溪沙滩', en:'My Khe Beach', ja:'ミーケービーチ', ko:'미케비치' },
  '龍橋': { 'zh-CN':'龙桥', en:'Dragon Bridge', ja:'ドラゴン橋', ko:'용다리' },
  '五行山': { 'zh-CN':'五行山', en:'Marble Mountains', ja:'マーブルマウンテン', ko:'마블마운틴' },
  // Nha Trang
  '芽莊海灘': { 'zh-CN':'芽庄海滩', en:'Nha Trang Beach', ja:'ニャチャン・ビーチ', ko:'나트랑비치' },
  '婆那加占婆塔': { 'zh-CN':'婆那加占婆塔', en:'Po Nagar Cham Towers', ja:'ポーナガル塔', ko:'포나가르참탑' },
  '珍珠島樂園': { 'zh-CN':'珍珠岛乐园', en:'VinWonders Nha Trang', ja:'ヴィンパール', ko:'빈펄랜드' },
  '龍山寺': { 'zh-CN':'龙山寺', en:'Long Son Pagoda', ja:'ロンソン寺', ko:'롱선사' },
  // Phu Quoc
  '富國島': { 'zh-CN':'富国岛', en:'Phu Quoc Island', ja:'フーコック島', ko:'푸꾸옥섬' },
  '陽東海灘': { 'zh-CN':'阳东海滩', en:'Ong Lang Beach', ja:'オンラン・ビーチ', ko:'옹랑비치' },
  '富國夜市': { 'zh-CN':'富国夜市', en:'Phu Quoc Night Market', ja:'フーコック・ナイトマーケット', ko:'푸꾸옥야시장' },
  '珍珠樂園': { 'zh-CN':'珍珠乐园', en:'VinWonders Phu Quoc', ja:'ヴィンワンダーズ', ko:'빈원더스' },
  // Manila
  '因特拉穆羅斯': { 'zh-CN':'因特拉穆罗斯', en:'Intramuros', ja:'イントラムロス', ko:'인트라무로스' },
  'BGC': { 'zh-CN':'BGC', en:'BGC (Bonifacio Global City)', ja:'BGC', ko:'BGC' },
  '馬卡蒂': { 'zh-CN':'马卡蒂', en:'Makati', ja:'マカティ', ko:'마카티' },
  '馬尼拉灣': { 'zh-CN':'马尼拉湾', en:'Manila Bay', ja:'マニラ湾', ko:'마닐라만' },
  '羅哈斯大道': { 'zh-CN':'罗哈斯大道', en:'Roxas Boulevard', ja:'ロハス大通り', ko:'록사스대로' },
  '奎阿波': { 'zh-CN':'奎阿波', en:'Quiapo', ja:'キアポ', ko:'키아포' },
  // Cebu
  '宿霧市': { 'zh-CN':'宿雾市', en:'Cebu City', ja:'セブ市', ko:'세부시티' },
  '麥哲倫十字架': { 'zh-CN':'麦哲伦十字架', en:'Magellan\'s Cross', ja:'マゼランクロス', ko:'마젤란십자가' },
  '長灘島附近': { 'zh-CN':'长滩岛附近', en:'Near Boracay', ja:'ボラカイ島周辺', ko:'보라카이인근' },
  '莫阿爾博阿': { 'zh-CN':'莫阿尔博阿', en:'Moalboal', ja:'モアルボアル', ko:'모알보알' },
  '歐斯陸': { 'zh-CN':'欧斯陆', en:'Oslob', ja:'オスロブ', ko:'오슬롭' },
  // Siem Reap
  '吳哥窟': { 'zh-CN':'吴哥窟', en:'Angkor Wat', ja:'アンコールワット', ko:'앙코르와트' },
  '吳哥城': { 'zh-CN':'吴哥城', en:'Angkor Thom', ja:'アンコールトム', ko:'앙코르톰' },
  '塔普倫廟': { 'zh-CN':'塔普伦庙', en:'Ta Prohm', ja:'タプローム', ko:'타프롬' },
  '女王宮': { 'zh-CN':'女王宫', en:'Banteay Srei', ja:'バンテアイスレイ', ko:'반테아이스레이' },
  '洞里薩湖': { 'zh-CN':'洞里萨湖', en:'Tonle Sap Lake', ja:'トンレサップ湖', ko:'톤레삽호' },
  // Colombo
  '科倫坡堡': { 'zh-CN':'科伦坡堡', en:'Colombo Fort', ja:'コロンボ・フォート', ko:'콜롬보포트' },
  '貝塔': { 'zh-CN':'贝塔', en:'Pettah', ja:'ペター', ko:'페타' },
  '科倫坡3區': { 'zh-CN':'科伦坡3区', en:'Colombo 3', ja:'コロンボ3区', ko:'콜롬보3구역' },
  '甘地格漢': { 'zh-CN':'甘地格汉', en:'Gangaramaya', ja:'ガンガラマヤ', ko:'강가라마야' },
  '尼甘布': { 'zh-CN':'尼甘布', en:'Negombo', ja:'ネゴンボ', ko:'네곰보' },
  '加勒': { 'zh-CN':'加勒', en:'Galle', ja:'ゴール', ko:'골' },
  // Maldives
  '馬累': { 'zh-CN':'马累', en:'Malé', ja:'マレ', ko:'말레' },
  '北馬累環礁': { 'zh-CN':'北马累环礁', en:'North Malé Atoll', ja:'北マレ環礁', ko:'북말레환초' },
  '南馬累環礁': { 'zh-CN':'南马累环礁', en:'South Malé Atoll', ja:'南マレ環礁', ko:'남말레환초' },
  '阿里環礁': { 'zh-CN':'阿里环礁', en:'Ari Atoll', ja:'アリ環礁', ko:'아리환초' },
  '拉環礁': { 'zh-CN':'拉环礁', en:'Laamu Atoll', ja:'ラーム環礁', ko:'라무환초' },
  '巴環礁': { 'zh-CN':'巴环礁', en:'Baa Atoll', ja:'バア環礁', ko:'바환초' },
  // Mumbai
  '南孟買': { 'zh-CN':'南孟买', en:'South Mumbai', ja:'南ムンバイ', ko:'남뭄바이' },
  '科拉巴': { 'zh-CN':'科拉巴', en:'Colaba', ja:'コラバ', ko:'콜라바' },
  '達拉維': { 'zh-CN':'达拉维', en:'Dharavi', ja:'ダラヴィ', ko:'다라비' },
  '班德拉': { 'zh-CN':'班德拉', en:'Bandra', ja:'バンドラ', ko:'반드라' },
  '朱胡': { 'zh-CN':'朱胡', en:'Juhu', ja:'ジュフ', ko:'주후' },
  '波瓦拉': { 'zh-CN':'波瓦拉', en:'Powai', ja:'パワイ', ko:'파와이' },
  '安德里': { 'zh-CN':'安德里', en:'Andheri', ja:'アンデリ', ko:'안데리' },
  // Delhi
  '康諾特廣場': { 'zh-CN':'康诺特广场', en:'Connaught Place', ja:'コンノートプレイス', ko:'코노트플레이스' },
  '老德里': { 'zh-CN':'老德里', en:'Old Delhi', ja:'オールドデリー', ko:'올드델리' },
  '新德里': { 'zh-CN':'新德里', en:'New Delhi', ja:'ニューデリー', ko:'뉴델리' },
  '胡馬雍陵': { 'zh-CN':'胡马雍陵', en:'Humayun\'s Tomb', ja:'フマユーン廟', ko:'후마윤묘' },
  '勒第花園': { 'zh-CN':'勒第花园', en:'Lodi Gardens', ja:'ロディ庭園', ko:'로디가든' },
  '卡洛爾巴': { 'zh-CN':'卡罗尔巴', en:'Karol Bagh', ja:'カロールバーグ', ko:'카롤바그' },
  // Goa
  '巴拿吉': { 'zh-CN':'帕纳吉', en:'Panaji', ja:'パナジ', ko:'파나지' },
  '卡蘭古特': { 'zh-CN':'卡兰古特', en:'Calangute', ja:'カランガット', ko:'칼랑구트' },
  '博加': { 'zh-CN':'博加', en:'Baga', ja:'バガ', ko:'바가' },
  '阿夫蘭科': { 'zh-CN':'阿夫兰科', en:'Anjuna', ja:'アンジュナ', ko:'안주나' },
  '科爾瓦': { 'zh-CN':'科尔瓦', en:'Colva', ja:'コルヴァ', ko:'콜바' },
  '帕納吉': { 'zh-CN':'帕纳吉', en:'Panaji', ja:'パナジ', ko:'파나지' },
  // Jaipur
  '琥珀堡': { 'zh-CN':'琥珀堡', en:'Amber Fort', ja:'アンベール城', ko:'암베르성' },
  '風之宮殿': { 'zh-CN':'风之宫殿', en:'Hawa Mahal', ja:'ハワー・マハル(風の宮殿)', ko:'하와마할' },
  '城市宮殿': { 'zh-CN':'城市宫殿', en:'City Palace', ja:'シティパレス', ko:'시티팰리스' },
  '珍塔曼塔天文台': { 'zh-CN':'简塔曼塔天文台', en:'Jantar Mantar', ja:'ジャンタル・マンタル', ko:'잔타르만타르' },
  '粉紅城': { 'zh-CN':'粉红城', en:'Pink City', ja:'ピンクシティ', ko:'핑크시티' },
  // Agra
  '泰姬瑪哈陵': { 'zh-CN':'泰姬玛哈陵', en:'Taj Mahal', ja:'タージ・マハル', ko:'타지마할' },
  '阿格拉堡': { 'zh-CN':'阿格拉堡', en:'Agra Fort', ja:'アーグラ城', ko:'아그라성' },
  '法泰赫布爾西克里': { 'zh-CN':'法泰赫布尔西克里', en:'Fatehpur Sikri', ja:'ファテープル・シークリー', ko:'파테푸르시크리' },
  // Kathmandu
  '杜巴廣場': { 'zh-CN':'杜巴广场', en:'Durbar Square', ja:'ダルバール広場', ko:'더르바르광장' },
  '帕坦': { 'zh-CN':'帕坦', en:'Patan', ja:'パタン', ko:'파탄' },
  '巴克塔普爾': { 'zh-CN':'巴克塔普尔', en:'Bhaktapur', ja:'バクタプル', ko:'박타푸르' },
  '泰美爾': { 'zh-CN':'泰美尔', en:'Thamel', ja:'タメル', ko:'타멜' },
  '帕蘇帕蒂納特': { 'zh-CN':'帕苏帕蒂纳特', en:'Pashupatinath Temple', ja:'パシュパティナート', ko:'파슈파티나트' },
  '博達': { 'zh-CN':'博达', en:'Boudhanath', ja:'ボダナート', ko:'보드나트' },
  // Dubai
  '迪拜購物中心': { 'zh-CN':'迪拜购物中心', en:'Dubai Mall', ja:'ドバイモール', ko:'두바이몰' },
  '棕櫚島': { 'zh-CN':'棕榈岛', en:'Palm Jumeirah', ja:'パーム・ジュメイラ', ko:'팜주메이라' },
  '迪拜老城': { 'zh-CN':'迪拜老城', en:'Old Dubai', ja:'オールドドバイ', ko:'올드두바이' },
  '朱美拉': { 'zh-CN':'朱美拉', en:'Jumeirah', ja:'ジュメイラ', ko:'주메이라' },
  '迪拜碼頭': { 'zh-CN':'迪拜码头', en:'Dubai Marina', ja:'ドバイマリーナ', ko:'두바이마리나' },
  '溪邊區': { 'zh-CN':'溪边区', en:'Deira (Creekside)', ja:'デイラ', ko:'데이라' },
  '帆船酒店': { 'zh-CN':'帆船酒店', en:'Burj Al Arab', ja:'ブルジュ・アル・アラブ', ko:'부르즈알아랍' },
  '迪拜未來博物館': { 'zh-CN':'迪拜未来博物馆', en:'Museum of the Future', ja:'未来博物館', ko:'미래박물관' },
  // Abu Dhabi
  '謝赫扎耶德清真寺': { 'zh-CN':'谢赫扎耶德清真寺', en:'Sheikh Zayed Mosque', ja:'シェイク・ザーイド・モスク', ko:'셰이크자예드모스크' },
  '亞斯島': { 'zh-CN':'亚斯岛', en:'Yas Island', ja:'ヤス島', ko:'야스섬' },
  '科尼奇': { 'zh-CN':'科尼奇', en:'Corniche', ja:'コルニーシュ', ko:'코니시' },
  '薩迪亞特島': { 'zh-CN':'萨迪亚特岛', en:'Saadiyat Island', ja:'サディヤット島', ko:'사디야트섬' },
  '露瓦斯': { 'zh-CN':'露瓦斯', en:'Al Ruwais', ja:'ルワイス', ko:'루와이스' },
  '阿布達比島': { 'zh-CN':'阿布扎比岛', en:'Abu Dhabi Island', ja:'アブダビ島', ko:'아부다비섬' },
  // Doha
  '伊斯蘭藝術博物館': { 'zh-CN':'伊斯兰艺术博物馆', en:'Museum of Islamic Art', ja:'イスラム美術館', ko:'이슬람미술관' },
  '珍珠島': { 'zh-CN':'珍珠岛', en:'The Pearl', ja:'ザ・パール', ko:'더펄' },
  '哈里發球場': { 'zh-CN':'哈里发球场', en:'Khalifa Stadium', ja:'ハリーファ・スタジアム', ko:'칼리파스타디움' },
  '卡塔拉': { 'zh-CN':'卡塔拉', en:'Katara Cultural Village', ja:'カタラ文化村', ko:'카타라문화마을' },
  // Istanbul
  '蘇丹艾哈邁德': { 'zh-CN':'苏丹艾哈迈德', en:'Sultanahmet', ja:'スルタンアフメット', ko:'술탄아흐메트' },
  '格拉達': { 'zh-CN':'加拉塔', en:'Galata', ja:'ガラタ', ko:'갈라타' },
  '博斯普魯斯': { 'zh-CN':'博斯普鲁斯', en:'Bosphorus', ja:'ボスポラス海峡', ko:'보스포루스' },
  '貝西克塔什': { 'zh-CN':'贝西克塔斯', en:'Beşiktaş', ja:'ベシクタシュ', ko:'베식타쉬' },
  '尼尚塔斯': { 'zh-CN':'尼尚塔斯', en:'Nişantaşı', ja:'ニシャンタシュ', ko:'니샨타시' },
  '卡德克伊': { 'zh-CN':'卡德柯伊', en:'Kadıköy', ja:'カドキョイ', ko:'카드쿄이' },
  '法提赫': { 'zh-CN':'法提赫', en:'Fatih', ja:'ファーティフ', ko:'파티흐' },
  // Riyadh
  '王國中心塔': { 'zh-CN':'王国中心塔', en:'Kingdom Centre Tower', ja:'キングダムセンタータワー', ko:'킹덤센터타워' },
  '迪拉廣場': { 'zh-CN':'迪拉广场', en:'Deera Square', ja:'ディーラ広場', ko:'디라광장' },
  '利雅得老城': { 'zh-CN':'利雅得老城', en:'Old Riyadh', ja:'旧リヤド', ko:'올드리야드' },
  '阿爾馬斯馬克堡': { 'zh-CN':'阿尔马斯马克堡', en:'Masmak Fortress', ja:'マスマク要塞', ko:'마스마크요새' },
  // Jeddah
  '吉達老城': { 'zh-CN':'吉达老城', en:'Al-Balad (Old Jeddah)', ja:'アルバラド(旧市街)', ko:'알발라드' },
  '紅海海濱步道': { 'zh-CN':'红海海滨步道', en:'Red Sea Corniche', ja:'紅海コルニーシュ', ko:'홍해코니시' },
  '浮動清真寺': { 'zh-CN':'浮动清真寺', en:'Floating Mosque', ja:'浮遊モスク', ko:'플로팅모스크' },
  '阿爾巴拉德區': { 'zh-CN':'阿尔巴拉德区', en:'Al-Balad District', ja:'アルバラド地区', ko:'알발라드지구' },
  // Tel Aviv
  '雅法古城': { 'zh-CN':'雅法古城', en:'Old Jaffa', ja:'旧ヤッフォ', ko:'구야파' },
  '海灘區': { 'zh-CN':'海滩区', en:'Beachfront', ja:'ビーチエリア', ko:'해변지구' },
  '羅斯柴爾德大道': { 'zh-CN':'罗斯柴尔德大道', en:'Rothschild Boulevard', ja:'ロスチャイルド通り', ko:'로스차일드대로' },
  '卡梅爾市場': { 'zh-CN':'卡梅尔市场', en:'Carmel Market', ja:'カルメル市場', ko:'카르멜시장' },
  '白城': { 'zh-CN':'白城', en:'White City', ja:'ホワイトシティ', ko:'화이트시티' },
  // Paris
  '蒙馬特': { 'zh-CN':'蒙马特', en:'Montmartre', ja:'モンマルトル', ko:'몽마르트' },
  '瑪黑區': { 'zh-CN':'玛黑区', en:'Le Marais', ja:'マレ地区', ko:'마레지구' },
  '香榭大道': { 'zh-CN':'香榭大道', en:'Champs-Élysées', ja:'シャンゼリゼ通り', ko:'샹젤리제' },
  '左岸': { 'zh-CN':'左岸', en:'Left Bank', ja:'左岸', ko:'좌안' },
  '艾菲爾鐵塔': { 'zh-CN':'埃菲尔铁塔', en:'Eiffel Tower', ja:'エッフェル塔', ko:'에펠탑' },
  '拉丁區': { 'zh-CN':'拉丁区', en:'Latin Quarter', ja:'カルチェ・ラタン', ko:'라틴지구' },
  '聖日耳曼': { 'zh-CN':'圣日耳曼', en:'Saint-Germain', ja:'サンジェルマン', ko:'생제르맹' },
  '盧浮宮': { 'zh-CN':'卢浮宫', en:'Louvre', ja:'ルーヴル美術館', ko:'루브르박물관' },
  '楓丹白露': { 'zh-CN':'枫丹白露', en:'Fontainebleau', ja:'フォンテーヌブロー', ko:'퐁텐블로' },
  // London
  '西區': { 'zh-CN':'西区', en:'West End', ja:'ウエストエンド', ko:'웨스트엔드' },
  '肖爾迪奇': { 'zh-CN':'肖尔迪奇', en:'Shoreditch', ja:'ショーディッチ', ko:'쇼디치' },
  '諾丁山': { 'zh-CN':'诺丁山', en:'Notting Hill', ja:'ノッティングヒル', ko:'노팅힐' },
  '格林威治': { 'zh-CN':'格林威治', en:'Greenwich', ja:'グリニッジ', ko:'그리니치' },
  '坎頓': { 'zh-CN':'卡姆登', en:'Camden', ja:'カムデン', ko:'캠던' },
  '科文特花園': { 'zh-CN':'科文特花园', en:'Covent Garden', ja:'コベントガーデン', ko:'코벤트가든' },
  '切爾西': { 'zh-CN':'切尔西', en:'Chelsea', ja:'チェルシー', ko:'첼시' },
  '伊斯靈頓': { 'zh-CN':'伊斯灵顿', en:'Islington', ja:'イズリントン', ko:'이즐링턴' },
  // Rome
  '鬥獸場': { 'zh-CN':'斗兽场', en:'Colosseum', ja:'コロッセオ', ko:'콜로세움' },
  '梵蒂岡': { 'zh-CN':'梵蒂冈', en:'Vatican', ja:'バチカン', ko:'바티칸' },
  '特雷維噴泉': { 'zh-CN':'特莱维喷泉', en:'Trevi Fountain', ja:'トレヴィの泉', ko:'트레비분수' },
  '納沃納廣場': { 'zh-CN':'纳沃纳广场', en:'Piazza Navona', ja:'ナヴォーナ広場', ko:'나보나광장' },
  '西班牙階梯': { 'zh-CN':'西班牙台阶', en:'Spanish Steps', ja:'スペイン階段', ko:'스페인계단' },
  '博爾蓋塞': { 'zh-CN':'博尔盖塞', en:'Villa Borghese', ja:'ボルゲーゼ公園', ko:'보르게세공원' },
  '特拉斯提弗列': { 'zh-CN':'特拉斯提弗列', en:'Trastevere', ja:'トラステヴェレ', ko:'트라스테베레' },
  // Milan
  '時尚四邊形': { 'zh-CN':'时尚四边形', en:'Quadrilatero della Moda', ja:'モードの四角地帯', ko:'패션쿼드릴라테로' },
  '大教堂': { 'zh-CN':'大教堂', en:'Duomo', ja:'ドゥオーモ', ko:'두오모' },
  '布雷拉': { 'zh-CN':'布雷拉', en:'Brera', ja:'ブレラ', ko:'브레라' },
  'Navigli': { 'zh-CN':'纳维利运河区', en:'Navigli', ja:'ナヴィリオ', ko:'나빌리오' },
  '5Vie': { 'zh-CN':'5Vie', en:'5Vie District', ja:'5ヴィエ地区', ko:'5비에지구' },
  '維托里奧廣場': { 'zh-CN':'维托里奥广场', en:'Piazza Vittorio', ja:'ヴィットリオ広場', ko:'비토리오광장' },
  // Florence
  '烏菲茲美術館': { 'zh-CN':'乌菲兹美术馆', en:'Uffizi Gallery', ja:'ウフィツィ美術館', ko:'우피치미술관' },
  '舊橋': { 'zh-CN':'旧桥', en:'Ponte Vecchio', ja:'ヴェッキオ橋', ko:'베키오다리' },
  '聖母百花大教堂': { 'zh-CN':'圣母百花大教堂', en:'Florence Cathedral', ja:'サンタ・マリア・デル・フィオーレ大聖堂', ko:'피렌체대성당' },
  '米開朗基羅廣場': { 'zh-CN':'米开朗基罗广场', en:'Piazzale Michelangelo', ja:'ミケランジェロ広場', ko:'미켈란젤로광장' },
  '奧特拉諾': { 'zh-CN':'奥特拉诺', en:'Oltrarno', ja:'オルトラルノ', ko:'올트라르노' },
  '聖十字': { 'zh-CN':'圣十字', en:'Santa Croce', ja:'サンタクローチェ', ko:'산타크로체' },
  // Venice
  '聖馬可廣場': { 'zh-CN':'圣马可广场', en:'St. Mark\'s Square', ja:'サンマルコ広場', ko:'산마르코광장' },
  '麗都島': { 'zh-CN':'丽都岛', en:'Lido', ja:'リド島', ko:'리도섬' },
  '布拉諾': { 'zh-CN':'布拉诺', en:'Burano', ja:'ブラーノ島', ko:'부라노섬' },
  '穆拉諾': { 'zh-CN':'穆拉诺', en:'Murano', ja:'ムラーノ島', ko:'무라노섬' },
  '多爾索杜羅': { 'zh-CN':'多尔索杜罗', en:'Dorsoduro', ja:'ドルソドゥーロ', ko:'도르소두로' },
  '卡納雷吉奧': { 'zh-CN':'卡纳雷吉奥', en:'Cannaregio', ja:'カンナレージョ', ko:'칸나레조' },
  // Barcelona
  '哥德區': { 'zh-CN':'哥特区', en:'Gothic Quarter', ja:'ゴシック地区', ko:'고딕지구' },
  '聖家堂': { 'zh-CN':'圣家堂', en:'Sagrada Família', ja:'サグラダ・ファミリア', ko:'사그라다파밀리아' },
  '格拉西亞大道': { 'zh-CN':'格拉西亚大道', en:'Passeig de Gràcia', ja:'グラシア通り', ko:'그라시아거리' },
  '巴塞羅內塔': { 'zh-CN':'巴塞罗内塔', en:'Barceloneta', ja:'バルセロネータ', ko:'바르셀로네타' },
  '格拉西亞區': { 'zh-CN':'格拉西亚区', en:'Gràcia District', ja:'グラシア地区', ko:'그라시아지구' },
  '蒙特惠奇': { 'zh-CN':'蒙特惠奇', en:'Montjuïc', ja:'モンジュイック', ko:'몬주익' },
  // Madrid
  '普拉多博物館': { 'zh-CN':'普拉多博物馆', en:'Prado Museum', ja:'プラド美術館', ko:'프라도미술관' },
  '索菲亞王后': { 'zh-CN':'索菲亚王后', en:'Reina Sofía Museum', ja:'ソフィア王妃芸術センター', ko:'레이나소피아미술관' },
  '格蘭大道': { 'zh-CN':'格兰大道', en:'Gran Vía', ja:'グランビア通り', ko:'그란비아' },
  '馬約爾廣場': { 'zh-CN':'马约尔广场', en:'Plaza Mayor', ja:'マヨール広場', ko:'마요르광장' },
  '雷提羅公園': { 'zh-CN':'雷提罗公园', en:'Retiro Park', ja:'レティーロ公園', ko:'레티로공원' },
  '馬拉薩納': { 'zh-CN':'马拉萨尼亚', en:'Malasaña', ja:'マラサーニャ', ko:'말라사냐' },
  // Amsterdam
  '約旦': { 'zh-CN':'约旦区', en:'Jordaan', ja:'ヨルダーン', ko:'요르단지구' },
  '勒澤普廣場': { 'zh-CN':'莱茨广场', en:'Leidseplein', ja:'ライツェ広場', ko:'레이체플레인' },
  '博物館廣場': { 'zh-CN':'博物馆广场', en:'Museumplein', ja:'ミュージアム広場', ko:'뮤지엄광장' },
  '阿姆斯特爾': { 'zh-CN':'阿姆斯特尔', en:'Amstel', ja:'アムステル', ko:'암스텔' },
  '紅燈區': { 'zh-CN':'红灯区', en:'Red Light District', ja:'飾り窓地区', ko:'홍등가' },
  '弗雷德里克斯廣場': { 'zh-CN':'弗雷德里克广场', en:'Frederiksplein', ja:'フレデリック広場', ko:'프레더릭광장' },
  // Berlin
  '米特': { 'zh-CN':'米特', en:'Mitte', ja:'ミッテ', ko:'미테' },
  '普倫茨勞爾貝格': { 'zh-CN':'普伦茨劳尔贝格', en:'Prenzlauer Berg', ja:'プレンツラウアーベルク', ko:'프렌츨라우어베르크' },
  '腓特烈斯海因': { 'zh-CN':'腓特烈斯海因', en:'Friedrichshain', ja:'フリードリヒスハイン', ko:'프리드리히스하인' },
  '夏洛滕堡': { 'zh-CN':'夏洛滕堡', en:'Charlottenburg', ja:'シャルロッテンブルク', ko:'샤를로텐부르크' },
  '波茨坦廣場': { 'zh-CN':'波茨坦广场', en:'Potsdamer Platz', ja:'ポツダム広場', ko:'포츠담광장' },
  '十字山': { 'zh-CN':'十字山', en:'Kreuzberg', ja:'クロイツベルク', ko:'크로이츠베르크' },
  // Munich
  '馬林廣場': { 'zh-CN':'玛丽恩广场', en:'Marienplatz', ja:'マリエン広場', ko:'마리엔광장' },
  '英式花園': { 'zh-CN':'英式花园', en:'English Garden', ja:'イングリッシュガーデン', ko:'영국정원' },
  '奧林匹克公園': { 'zh-CN':'奥林匹克公园', en:'Olympic Park', ja:'オリンピック公園', ko:'올림픽공원' },
  '達豪': { 'zh-CN':'达豪', en:'Dachau', ja:'ダッハウ', ko:'다하우' },
  '施瓦賓': { 'zh-CN':'施瓦宾', en:'Schwabing', ja:'シュヴァービング', ko:'슈바빙' },
  '新天鵝堡': { 'zh-CN':'新天鹅堡', en:'Neuschwanstein Castle', ja:'ノイシュヴァンシュタイン城', ko:'노이슈반슈타인성' },
  // Prague
  '老城廣場': { 'zh-CN':'老城广场', en:'Old Town Square', ja:'旧市街広場', ko:'구시가지광장' },
  '查理大橋': { 'zh-CN':'查理大桥', en:'Charles Bridge', ja:'カレル橋', ko:'카를교' },
  '城堡區': { 'zh-CN':'城堡区', en:'Castle District', ja:'城地区', ko:'성지구' },
  '小城區': { 'zh-CN':'小城区', en:'Lesser Town', ja:'小地区', ko:'말라스트라나' },
  '維謝赫拉德': { 'zh-CN':'维谢赫拉德', en:'Vyšehrad', ja:'ヴィシェフラド', ko:'비셰흐라트' },
  '維諾赫拉迪': { 'zh-CN':'维诺赫拉迪', en:'Vinohrady', ja:'ヴィノフラディ', ko:'비노흐라디' },
  // Vienna
  '美泉宮': { 'zh-CN':'美泉宫', en:'Schönbrunn Palace', ja:'シェーンブルン宮殿', ko:'쇤부른궁전' },
  '環城大道': { 'zh-CN':'环城大道', en:'Ringstrasse', ja:'リングシュトラーセ', ko:'링슈트라세' },
  '瑪利亞廣場': { 'zh-CN':'玛利亚广场', en:'Maria-Theresien-Platz', ja:'マリア・テレジア広場', ko:'마리아테레지엔광장' },
  '普拉特': { 'zh-CN':'普拉特', en:'Prater', ja:'プラーター', ko:'프라터' },
  '納許馬爾克特': { 'zh-CN':'纳许市场', en:'Naschmarkt', ja:'ナッシュマルクト', ko:'나슈마르크트' },
  '格林津': { 'zh-CN':'格林津', en:'Grinzing', ja:'グリンツィング', ko:'그린칭' },
  // Budapest
  '布達城堡': { 'zh-CN':'布达城堡', en:'Buda Castle', ja:'ブダ城', ko:'부다성' },
  '漁夫堡': { 'zh-CN':'渔人堡', en:'Fisherman\'s Bastion', ja:'漁夫の砦', ko:'어부의요새' },
  '英雄廣場': { 'zh-CN':'英雄广场', en:'Heroes\' Square', ja:'英雄広場', ko:'영웅광장' },
  '安德拉什大街': { 'zh-CN':'安德拉什大街', en:'Andrássy Avenue', ja:'アンドラーシ通り', ko:'언드라시대로' },
  '魯達什溫泉': { 'zh-CN':'鲁达什温泉', en:'Rudas Baths', ja:'ルダシュ温泉', ko:'루다시온천' },
  '瑪格麗特島': { 'zh-CN':'玛格丽特岛', en:'Margaret Island', ja:'マルギット島', ko:'머르기트섬' },
  // Lisbon
  '阿爾法瑪': { 'zh-CN':'阿尔法玛', en:'Alfama', ja:'アルファマ', ko:'알파마' },
  '貝倫': { 'zh-CN':'贝伦', en:'Belém', ja:'ベレン', ko:'벨렝' },
  '希亞多': { 'zh-CN':'希亚多', en:'Chiado', ja:'シアード', ko:'시아두' },
  '拜薩': { 'zh-CN':'拜萨', en:'Baixa', ja:'バイシャ', ko:'바이샤' },
  '格拉薩': { 'zh-CN':'格拉萨', en:'Graça', ja:'グラサ', ko:'그라사' },
  '莫里斯卡': { 'zh-CN':'莫拉里亚', en:'Mouraria', ja:'モウラリア', ko:'모우라리아' },
  '辛特拉': { 'zh-CN':'辛特拉', en:'Sintra', ja:'シントラ', ko:'신트라' },
  // Athens
  '衛城': { 'zh-CN':'卫城', en:'Acropolis', ja:'アクロポリス', ko:'아크로폴리스' },
  '古市集': { 'zh-CN':'古市集', en:'Ancient Agora', ja:'古代アゴラ', ko:'고대아고라' },
  '憲法廣場': { 'zh-CN':'宪法广场', en:'Syntagma Square', ja:'シンタグマ広場', ko:'신타그마광장' },
  '普拉卡': { 'zh-CN':'普拉卡', en:'Plaka', ja:'プラカ', ko:'플라카' },
  '科洛納基': { 'zh-CN':'科洛纳基', en:'Kolonaki', ja:'コロナキ', ko:'콜로나키' },
  '莫納斯提拉奇': { 'zh-CN':'莫纳斯提拉奇', en:'Monastiraki', ja:'モナスティラキ', ko:'모나스티라키' },
  '維爾維': { 'zh-CN':'维爾维', en:'Vyronas', ja:'ヴィロナス', ko:'비로나스' },
  '大都會': { 'zh-CN':'大都会', en:'Metropolitan Cathedral Area', ja:'大都市圏', ko:'메트로폴리탄지구' },
  // Santorini
  '菲拉': { 'zh-CN':'菲拉', en:'Fira', ja:'フィラ', ko:'피라' },
  '伊亞': { 'zh-CN':'伊亚', en:'Oia', ja:'イア', ko:'이아' },
  '奧亞': { 'zh-CN':'奥亚', en:'Oia', ja:'イア', ko:'이아' },
  '佩里薩': { 'zh-CN':'佩里薩', en:'Perissa', ja:'ペリッサ', ko:'페리사' },
  '卡馬里': { 'zh-CN':'卡马里', en:'Kamari', ja:'カマリ', ko:'카마리' },
  '伊莫洛維格利': { 'zh-CN':'伊莫洛维格利', en:'Imerovigli', ja:'イメロヴィグリ', ko:'이메로비글리' },
  // Edinburgh
  '皇家英里': { 'zh-CN':'皇家英里大道', en:'Royal Mile', ja:'ロイヤルマイル', ko:'로열마일' },
  '新城': { 'zh-CN':'新城', en:'New Town', ja:'ニュータウン', ko:'뉴타운' },
  '舊城': { 'zh-CN':'旧城', en:'Old Town', ja:'旧市街', ko:'구시가지' },
  '萊斯': { 'zh-CN':'莱斯', en:'Leith', ja:'リース', ko:'리스' },
  '卡爾頓山': { 'zh-CN':'卡尔顿山', en:'Calton Hill', ja:'カールトン・ヒル', ko:'칼튼힐' },
  '迪恩村': { 'zh-CN':'迪恩村', en:'Dean Village', ja:'ディーン・ヴィレッジ', ko:'딘빌리지' },
  '斯托克布里奇': { 'zh-CN':'斯托克布里奇', en:'Stockbridge', ja:'ストックブリッジ', ko:'스톡브리지' },
  // Copenhagen
  '新港': { 'zh-CN':'新港', en:'Nyhavn', ja:'ニューハウン', ko:'뉘하운' },
  '腓特烈斯堡': { 'zh-CN':'腓特烈斯堡', en:'Frederiksberg', ja:'フレゼリクスベア', ko:'프레데릭스베르그' },
  '諾雷布羅': { 'zh-CN':'诺雷布罗', en:'Nørrebro', ja:'ノアブロ', ko:'뇌레브로' },
  '克里斯蒂安港': { 'zh-CN':'克里斯蒂安港', en:'Christianshavn', ja:'クリスチャンスハウン', ko:'크리스티안스하운' },
  '菲埃德比': { 'zh-CN':'菲埃德比', en:'Frederiksberg Have', ja:'フレデリクスベア公園', ko:'프레데릭스베르그공원' },
  '蒂沃利': { 'zh-CN':'蒂沃利', en:'Tivoli Gardens', ja:'チボリ公園', ko:'티볼리공원' },
  // Stockholm
  'Södermalm': { 'zh-CN':'南马尔姆', en:'Södermalm', ja:'セーデルマルム', ko:'쇠데르말름' },
  'Östermalm': { 'zh-CN':'东马尔姆', en:'Östermalm', ja:'エステルマルム', ko:'외스테르말름' },
  'Djurgården': { 'zh-CN':'动物园岛', en:'Djurgården', ja:'ユールゴーデン', ko:'유르고르덴' },
  '林地公墓': { 'zh-CN':'林地公墓', en:'Skogskyrkogården', ja:'森の墓地', ko:'스코그쉬르코고르덴' },
  '瓦薩博物館區': { 'zh-CN':'瓦萨博物馆区', en:'Vasa Museum Area', ja:'ヴァーサ博物館周辺', ko:'바사박물관지구' },
  // Oslo
  '阿克爾碼頭': { 'zh-CN':'阿克尔码头', en:'Aker Brygge', ja:'アーケシュブリッゲ', ko:'아케르브뤼게' },
  '格林爾洛卡': { 'zh-CN':'格伦纳洛卡', en:'Grünerløkka', ja:'グリューネルロッカ', ko:'그뤼네르뢰카' },
  '格拉夫森': { 'zh-CN':'格拉夫森', en:'Grefsen', ja:'グレフセン', ko:'그레프센' },
  'Majorstuen': { 'zh-CN':'马约斯图恩', en:'Majorstuen', ja:'マイヨシュトゥエン', ko:'마요르스투엔' },
  '比格達': { 'zh-CN':'比格达', en:'Bygdøy', ja:'ビグドイ', ko:'뷔그되위' },
  '霍姆科倫': { 'zh-CN':'霍姆科伦', en:'Holmenkollen', ja:'ホルメンコーレン', ko:'홀멘콜렌' },
  // Helsinki
  '設計區': { 'zh-CN':'设计区', en:'Design District', ja:'デザイン地区', ko:'디자인지구' },
  '卡利奧': { 'zh-CN':'卡利奥', en:'Kallio', ja:'カッリオ', ko:'칼리오' },
  '托洛': { 'zh-CN':'托洛', en:'Töölö', ja:'トーロ', ko:'퇼뢰' },
  '芬蘭堡': { 'zh-CN':'芬兰堡', en:'Suomenlinna', ja:'スオメンリンナ', ko:'수오멘린나' },
  '坎皮': { 'zh-CN':'坎皮', en:'Kamppi', ja:'カンッピ', ko:'캄피' },
  '烏拉斯卡里': { 'zh-CN':'乌拉斯卡里', en:'Ullanlinna', ja:'ウッランリンナ', ko:'울란린나' },
  // Zurich
  '湖濱': { 'zh-CN':'湖滨', en:'Lakefront', ja:'湖畔', ko:'호숫가' },
  '蘇黎世西區': { 'zh-CN':'苏黎世西区', en:'Zürich West', ja:'チューリッヒ・ヴェスト', ko:'취리히베스트' },
  'Kreis 4': { 'zh-CN':'第4区', en:'Kreis 4', ja:'クライス4', ko:'크라이스4' },
  'Kreis 5': { 'zh-CN':'第5区', en:'Kreis 5', ja:'クライス5', ko:'크라이스5' },
  '班霍夫大街': { 'zh-CN':'班霍夫大街', en:'Bahnhofstrasse', ja:'バーンホフ通り', ko:'반호프거리' },
  // Brussels
  '大廣場': { 'zh-CN':'大广场', en:'Grand Place', ja:'グラン・プラス', ko:'그랑플라스' },
  '上城': { 'zh-CN':'上城', en:'Upper Town', ja:'アッパータウン', ko:'어퍼타운' },
  '伊克塞爾': { 'zh-CN':'伊克塞尔', en:'Ixelles', ja:'イクセル', ko:'익셀' },
  '聖吉勒斯': { 'zh-CN':'圣吉勒斯', en:'Saint-Gilles', ja:'サン・ジル', ko:'생질' },
  '摩倫貝克': { 'zh-CN':'莫伦贝克', en:'Molenbeek', ja:'モーレンベーク', ko:'몰렌베이크' },
  '沙博隆': { 'zh-CN':'沙布隆', en:'Sablon', ja:'サブロン', ko:'사블롱' },
  // Dublin
  '坦普爾巴': { 'zh-CN':'坦普尔吧区', en:'Temple Bar', ja:'テンプルバー', ko:'템플바' },
  '多尼布魯克': { 'zh-CN':'多尼布鲁克', en:'Donnybrook', ja:'ドニーブルック', ko:'도니브룩' },
  '達基': { 'zh-CN':'达基', en:'Dalkey', ja:'ダルキー', ko:'돌키' },
  '鳳凰公園': { 'zh-CN':'凤凰公园', en:'Phoenix Park', ja:'フェニックス公園', ko:'피닉스공원' },
  '波特蘭': { 'zh-CN':'波特兰', en:'Portland Row', ja:'ポートランド', ko:'포틀랜드' },
  '克隆夕夫': { 'zh-CN':'克朗夕夫', en:'Clontarf', ja:'クロンターフ', ko:'클론타프' },
  // Reykjavik
  '舊市區': { 'zh-CN':'旧市区', en:'Old Town', ja:'旧市街', ko:'구시가지' },
  '101區': { 'zh-CN':'101区', en:'101 Reykjavík', ja:'101地区', ko:'101구역' },
  '藍湖': { 'zh-CN':'蓝湖', en:'Blue Lagoon', ja:'ブルーラグーン', ko:'블루라군' },
  '辛格韋德利': { 'zh-CN':'辛格维利尔', en:'Þingvellir', ja:'シンクヴェトリル', ko:'싱벨리르' },
  '黑沙灘': { 'zh-CN':'黑沙滩', en:'Black Sand Beach', ja:'黒砂海岸', ko:'검은모래해변' },
  '傑古沙龍': { 'zh-CN':'杰古沙龙', en:'Jökulsárlón', ja:'ヨークルサゥルロン氷河湖', ko:'요쿨살론' },
  // Dubrovnik
  '普洛切': { 'zh-CN':'普洛切', en:'Ploče', ja:'プロチェ', ko:'플로체' },
  '拉帕德': { 'zh-CN':'拉帕德', en:'Lapad', ja:'ラパド', ko:'라파드' },
  '斯捷潘': { 'zh-CN':'斯捷潘', en:'Stiepan', ja:'スティエパン', ko:'스티에판' },
  '科卡拉': { 'zh-CN':'科卡拉', en:'Kolorina', ja:'コロリナ', ko:'콜로리나' },
  // Naples
  '舊城區': { 'zh-CN':'旧城区', en:'Old Town', ja:'旧市街', ko:'구시가지' },
  '龐貝古城': { 'zh-CN':'庞贝古城', en:'Pompeii', ja:'ポンペイ', ko:'폼페이' },
  '蛋堡': { 'zh-CN':'蛋堡', en:'Castel dell\'Ovo', ja:'卵城', ko:'달걀성' },
  '卡波迪蒙特': { 'zh-CN':'卡波迪蒙特', en:'Capodimonte', ja:'カポディモンテ', ko:'카포디몬테' },
  '托萊多街': { 'zh-CN':'托莱多街', en:'Via Toledo', ja:'トレド通り', ko:'톨레도거리' },
  '基亞亞': { 'zh-CN':'基亚亚', en:'Chiaia', ja:'キアイア', ko:'키아이아' },
  // Turin
  '王宮': { 'zh-CN':'王宫', en:'Royal Palace', ja:'王宮', ko:'왕궁' },
  '波河公園': { 'zh-CN':'波河公园', en:'Parco del Valentino', ja:'ヴァレンティーノ公園', ko:'발렌티노공원' },
  '穆勒門': { 'zh-CN':'穆勒门', en:'Mole Antonelliana', ja:'モーレ・アントネッリアーナ', ko:'몰레안토넬리아나' },
  '格蘭馬達馬廣場': { 'zh-CN':'格兰马达马广场', en:'Piazza Castello', ja:'カステッロ広場', ko:'카스텔로광장' },
  '朱塞佩威爾第劇院': { 'zh-CN':'朱塞佩威尔第剧院', en:'Teatro Regio', ja:'レージョ劇場', ko:'레조극장' },
  '都靈大教堂': { 'zh-CN':'都灵大教堂', en:'Turin Cathedral', ja:'トリノ大聖堂', ko:'토리노대성당' },
  // Bologna
  '馬焦雷廣場': { 'zh-CN':'马焦雷广场', en:'Piazza Maggiore', ja:'マッジョーレ広場', ko:'마조레광장' },
  '雙塔': { 'zh-CN':'双塔', en:'Two Towers', ja:'2つの塔', ko:'두개의탑' },
  '波隆那大學區': { 'zh-CN':'博洛尼亚大学区', en:'University District', ja:'大学地区', ko:'대학지구' },
  '波特提科拱廊': { 'zh-CN':'波尔蒂科拱廊', en:'Portico Arcades', ja:'ポルティコ', ko:'포르티코' },
  '聖斯特凡諾教堂': { 'zh-CN':'圣斯特凡诺教堂', en:'Santo Stefano', ja:'サント・ステファノ教会', ko:'산토스테파노' },
  // Amalfi
  '阿馬爾菲海岸': { 'zh-CN':'阿马尔菲海岸', en:'Amalfi Coast', ja:'アマルフィ海岸', ko:'아말피해안' },
  '波西塔諾': { 'zh-CN':'波西塔诺', en:'Positano', ja:'ポジターノ', ko:'포지타노' },
  '拉維洛': { 'zh-CN':'拉维洛', en:'Ravello', ja:'ラヴェッロ', ko:'라벨로' },
  '大教堂廣場': { 'zh-CN':'大教堂广场', en:'Cathedral Square', ja:'大聖堂広場', ko:'대성당광장' },
  '艾米利亞諾洞穴': { 'zh-CN':'艾米利亚诺洞穴', en:'Emerald Grotto', ja:'エメラルドの洞窟', ko:'에메랄드동굴' },
  // Dresden
  '茨溫格宮': { 'zh-CN':'茨温格宫', en:'Zwinger Palace', ja:'ツヴィンガー宮殿', ko:'츠빙거궁전' },
  '聖母教堂': { 'zh-CN':'圣母教堂', en:'Frauenkirche', ja:'フラウエン教会', ko:'프라우엔교회' },
  '德勒斯登王宮': { 'zh-CN':'德累斯顿王宫', en:'Dresden Royal Palace', ja:'ドレスデン城', ko:'드레스덴궁전' },
  '易北河畔': { 'zh-CN':'易北河畔', en:'Elbe Riverside', ja:'エルベ川沿い', ko:'엘베강변' },
  '新城區': { 'zh-CN':'新城区', en:'New Town', ja:'新市街', ko:'노이슈타트' },
  // Heidelberg
  '海德堡城堡': { 'zh-CN':'海德堡城堡', en:'Heidelberg Castle', ja:'ハイデルベルク城', ko:'하이델베르크성' },
  '老橋': { 'zh-CN':'老桥', en:'Old Bridge', ja:'カール・テオドール橋', ko:'구시가지다리' },
  '哲學家小徑': { 'zh-CN':'哲学家小径', en:'Philosophers\' Walk', ja:'哲学の道', ko:'철학자의길' },
  '大學廣場': { 'zh-CN':'大学广场', en:'University Square', ja:'大学広場', ko:'대학광장' },
  '主街': { 'zh-CN':'主街', en:'Main Street (Hauptstrasse)', ja:'ハウプト通り', ko:'하우프트거리' },
  // Granada
  '阿爾罕布拉宮': { 'zh-CN':'阿尔罕布拉宫', en:'Alhambra', ja:'アルハンブラ宮殿', ko:'알함브라궁전' },
  '阿爾拜辛區': { 'zh-CN':'阿尔拜辛区', en:'Albaicín', ja:'アルバイシン', ko:'알바이신' },
  '薩克羅蒙特': { 'zh-CN':'萨克罗蒙特', en:'Sacromonte', ja:'サクロモンテ', ko:'사크로몬테' },
  // Valencia
  '藝術科學城': { 'zh-CN':'艺术科学城', en:'City of Arts and Sciences', ja:'芸術科学都市', ko:'예술과학도시' },
  '中央市場': { 'zh-CN':'中央市场', en:'Central Market', ja:'中央市場', ko:'중앙시장' },
  '絲綢交易所': { 'zh-CN':'丝绸交易所', en:'Silk Exchange', ja:'絹の取引所', ko:'실크거래소' },
  '土耳其塔': { 'zh-CN':'土耳其塔', en:'Torres de Serranos', ja:'セラーノス塔', ko:'세라노스탑' },
  // Seville
  '西班牙廣場': { 'zh-CN':'西班牙广场', en:'Plaza de España', ja:'スペイン広場', ko:'스페인광장' },
  '聖十字區': { 'zh-CN':'圣十字区', en:'Santa Cruz Quarter', ja:'サンタ・クルス地区', ko:'산타크루스지구' },
  '瑪莉亞路易莎公園': { 'zh-CN':'玛丽亚路易莎公园', en:'María Luisa Park', ja:'マリア・ルイサ公園', ko:'마리아루이사공원' },
  '特里亞納區': { 'zh-CN':'特里亚纳区', en:'Triana', ja:'トリアナ', ko:'트리아나' },
  // Bath
  '羅馬浴場': { 'zh-CN':'罗马浴场', en:'Roman Baths', ja:'ローマ浴場', ko:'로만바스' },
  '皇家新月樓': { 'zh-CN':'皇家新月楼', en:'Royal Crescent', ja:'ロイヤル・クレセント', ko:'로열크레센트' },
  '普爾特尼橋': { 'zh-CN':'普尔特尼桥', en:'Pulteney Bridge', ja:'パルトニー橋', ko:'풀트니다리' },
  '巴斯修道院': { 'zh-CN':'巴斯修道院', en:'Bath Abbey', ja:'バース寺院', ko:'배스수도원' },
  '圓形廣場': { 'zh-CN':'圆形广场', en:'The Circus', ja:'サーカス', ko:'서커스' },
  // Split
  '戴克里先宮': { 'zh-CN':'戴克里先宫', en:'Diocletian\'s Palace', ja:'ディオクレティアヌス宮殿', ko:'디오클레티아누스궁전' },
  '里瓦海濱大道': { 'zh-CN':'里瓦海滨大道', en:'Riva Promenade', ja:'リヴァ・プロムナード', ko:'리바산책로' },
  '馬爾揚山': { 'zh-CN':'马尔扬山', en:'Marjan Hill', ja:'マルヤン公園', ko:'마르얀언덕' },
  // Zagreb
  '耶拉契奇廣場': { 'zh-CN':'耶拉契奇广场', en:'Ban Jelačić Square', ja:'イェラチッチ広場', ko:'옐라치치광장' },
  '上城區': { 'zh-CN':'上城区', en:'Upper Town', ja:'アッパータウン', ko:'고르니그라드' },
  '多拉茨市場': { 'zh-CN':'多拉茨市场', en:'Dolac Market', ja:'ドラツ市場', ko:'돌라츠시장' },
  '聖史蒂芬大教堂': { 'zh-CN':'圣史蒂芬大教堂', en:'Zagreb Cathedral', ja:'ザグレブ大聖堂', ko:'자그레브대성당' },
  '馬克西米爾公園': { 'zh-CN':'马克西米尔公园', en:'Maksimir Park', ja:'マクシミール公園', ko:'막시미르공원' },
  // Warsaw
  '皇家大道': { 'zh-CN':'皇家大道', en:'Royal Route', ja:'王の道', ko:'로열루트' },
  '維拉諾夫宮': { 'zh-CN':'维拉诺夫宫', en:'Wilanów Palace', ja:'ヴィラヌフ宮殿', ko:'빌라누프궁전' },
  '普拉加': { 'zh-CN':'普拉加', en:'Praga', ja:'プラガ', ko:'프라가' },
  '新世界街': { 'zh-CN':'新世界街', en:'Nowy Świat Street', ja:'ノヴィ・シフィアト通り', ko:'노비시비아트거리' },
  '瓦津基公園': { 'zh-CN':'瓦津基公园', en:'Łazienki Park', ja:'ワジェンキ公園', ko:'와지엔키공원' },
  // Krakow
  '瓦維爾城堡': { 'zh-CN':'瓦维尔城堡', en:'Wawel Castle', ja:'ヴァヴェル城', ko:'바벨성' },
  '卡齊米日': { 'zh-CN':'卡齐米日', en:'Kazimierz', ja:'カジミエシュ', ko:'카지미에시' },
  '弗洛里安斯卡街': { 'zh-CN':'弗洛里安斯卡街', en:'Floriańska Street', ja:'フロリアンスカ通り', ko:'플로리안스카거리' },
  '扎科帕內': { 'zh-CN':'扎科帕内', en:'Zakopane', ja:'ザコパネ', ko:'자코파네' },
  '奧斯威辛': { 'zh-CN':'奥斯威辛', en:'Auschwitz', ja:'アウシュヴィッツ', ko:'아우슈비츠' },
  // Tallinn
  '卡德里奧': { 'zh-CN':'卡德里奥', en:'Kadriorg', ja:'カドリオルグ', ko:'카드리오르그' },
  '皮里塔': { 'zh-CN':'皮里塔', en:'Pirita', ja:'ピリタ', ko:'피리타' },
  '泰勒梅': { 'zh-CN':'塔林梅', en:'Telliskivi', ja:'テリスキヴィ', ko:'텔리스키비' },
  // Riga
  '阿爾伯特街': { 'zh-CN':'阿尔伯特街', en:'Alberta Street', ja:'アルベルタ通り', ko:'알베르타거리' },
  '麥澤帕克': { 'zh-CN':'梅扎帕克斯', en:'Mežaparks', ja:'メジャパルクス', ko:'메자파르크스' },
  '尤爾馬拉': { 'zh-CN':'尤尔马拉', en:'Jūrmala', ja:'ユールマラ', ko:'유르말라' },
  '聖彼得教堂': { 'zh-CN':'圣彼得教堂', en:'St. Peter\'s Church', ja:'聖ペテロ教会', ko:'성베드로교회' },
  // Vilnius
  '格迪米納斯塔': { 'zh-CN':'格迪米纳斯塔', en:'Gediminas Tower', ja:'ゲディミナス塔', ko:'게디미나스탑' },
  '烏日皮斯': { 'zh-CN':'乌日皮斯', en:'Užupis', ja:'ウジュピス', ko:'우주피스' },
  '特拉凱': { 'zh-CN':'特拉凯', en:'Trakai', ja:'トラカイ', ko:'트라카이' },
  // Bucharest
  '勝利大道': { 'zh-CN':'胜利大道', en:'Victory Avenue', ja:'勝利大通り', ko:'승리대로' },
  '赫勒斯特勞': { 'zh-CN':'赫勒斯特劳', en:'Herăstrău', ja:'ヘラストラウ公園', ko:'헤레스트러우' },
  '銀行廣場': { 'zh-CN':'银行广场', en:'Bank Square', ja:'銀行広場', ko:'은행광장' },
  '文化宮': { 'zh-CN':'文化宫', en:'Palace of the Parliament', ja:'国民の館', ko:'국민의궁전' },
  '弗洛雷亞斯卡': { 'zh-CN':'弗洛雷亚斯卡', en:'Floreasca', ja:'フロレアスカ', ko:'플로레아스카' },
  // New York
  '曼哈頓': { 'zh-CN':'曼哈顿', en:'Manhattan', ja:'マンハッタン', ko:'맨해튼' },
  '布魯克林': { 'zh-CN':'布鲁克林', en:'Brooklyn', ja:'ブルックリン', ko:'브루클린' },
  '皇后區': { 'zh-CN':'皇后区', en:'Queens', ja:'クイーンズ', ko:'퀸즈' },
  '中央公園': { 'zh-CN':'中央公园', en:'Central Park', ja:'セントラルパーク', ko:'센트럴파크' },
  '時代廣場': { 'zh-CN':'时代广场', en:'Times Square', ja:'タイムズスクエア', ko:'타임스스퀘어' },
  'SOHO': { 'zh-CN':'苏活区', en:'SoHo', ja:'ソーホー', ko:'소호' },
  '格林威治村': { 'zh-CN':'格林威治村', en:'Greenwich Village', ja:'グリニッジ・ヴィレッジ', ko:'그리니치빌리지' },
  '哈林區': { 'zh-CN':'哈林区', en:'Harlem', ja:'ハーレム', ko:'할렘' },
  '威廉斯堡': { 'zh-CN':'威廉斯堡', en:'Williamsburg', ja:'ウィリアムズバーグ', ko:'윌리엄스버그' },
  // Los Angeles
  '好萊塢': { 'zh-CN':'好莱坞', en:'Hollywood', ja:'ハリウッド', ko:'할리우드' },
  '聖塔莫尼卡': { 'zh-CN':'圣塔莫尼卡', en:'Santa Monica', ja:'サンタモニカ', ko:'산타모니카' },
  '威尼斯海灘': { 'zh-CN':'威尼斯海滩', en:'Venice Beach', ja:'ベニスビーチ', ko:'베니스비치' },
  '比弗利山': { 'zh-CN':'比弗利山', en:'Beverly Hills', ja:'ビバリーヒルズ', ko:'비벌리힐스' },
  '西好萊塢': { 'zh-CN':'西好莱坞', en:'West Hollywood', ja:'ウエストハリウッド', ko:'웨스트할리우드' },
  '韓國城': { 'zh-CN':'韩国城', en:'Koreatown', ja:'コリアタウン', ko:'코리아타운' },
  '唐人街': { 'zh-CN':'唐人街', en:'Chinatown', ja:'チャイナタウン', ko:'차이나타운' },
  '馬里布': { 'zh-CN':'马里布', en:'Malibu', ja:'マリブ', ko:'말리부' },
  // San Francisco
  '漁人碼頭': { 'zh-CN':'渔人码头', en:'Fisherman\'s Wharf', ja:'フィッシャーマンズワーフ', ko:'피셔맨스워프' },
  '使命區': { 'zh-CN':'教会区', en:'Mission District', ja:'ミッション地区', ko:'미션지구' },
  '卡斯楚': { 'zh-CN':'卡斯特罗', en:'Castro', ja:'カストロ', ko:'카스트로' },
  '海特-艾許伯里': { 'zh-CN':'海特-艾许伯里', en:'Haight-Ashbury', ja:'ヘイト・アシュベリー', ko:'헤이트애시베리' },
  '海灣區': { 'zh-CN':'海湾区', en:'Bay Area', ja:'ベイエリア', ko:'베이지역' },
  '金門橋': { 'zh-CN':'金门大桥', en:'Golden Gate Bridge', ja:'ゴールデンゲートブリッジ', ko:'금문교' },
  '諾布山': { 'zh-CN':'诺布山', en:'Nob Hill', ja:'ノブヒル', ko:'노브힐' },
  // Las Vegas
  '拉斯維加斯大道': { 'zh-CN':'拉斯维加斯大道', en:'The Strip', ja:'ラスベガス・ストリップ', ko:'라스베이거스스트립' },
  '弗里蒙特街': { 'zh-CN':'弗里蒙特街', en:'Fremont Street', ja:'フリーモント通り', ko:'프리몬트거리' },
  '城市中心': { 'zh-CN':'城市中心', en:'CityCenter', ja:'シティセンター', ko:'시티센터' },
  '薩默林': { 'zh-CN':'萨默林', en:'Summerlin', ja:'サマーリン', ko:'서머린' },
  '亨德森': { 'zh-CN':'亨德森', en:'Henderson', ja:'ヘンダーソン', ko:'헨더슨' },
  '麥卡倫機場': { 'zh-CN':'麦卡伦机场', en:'McCarran Airport Area', ja:'マッカラン空港周辺', ko:'매캐런공항인근' },
  // Miami
  '南海灘': { 'zh-CN':'南海滩', en:'South Beach', ja:'サウスビーチ', ko:'사우스비치' },
  '溫伍德': { 'zh-CN':'温伍德', en:'Wynwood', ja:'ウィンウッド', ko:'윈우드' },
  '科科納特格羅夫': { 'zh-CN':'椰林湾', en:'Coconut Grove', ja:'ココナッツグローブ', ko:'코코넛그로브' },
  '布里克爾': { 'zh-CN':'布里克爾', en:'Brickell', ja:'ブリッケル', ko:'브리켈' },
  '灣港島': { 'zh-CN':'湾港岛', en:'Bal Harbour', ja:'バルハーバー', ko:'발하버' },
  '科勒爾蓋布爾斯': { 'zh-CN':'珊瑚阁', en:'Coral Gables', ja:'コーラルゲーブルズ', ko:'코럴게이블스' },
  // Chicago
  '密歇根大道': { 'zh-CN':'密歇根大道', en:'Michigan Avenue', ja:'ミシガン通り', ko:'미시간애비뉴' },
  '河北': { 'zh-CN':'河北区', en:'River North', ja:'リバーノース', ko:'리버노스' },
  '金融區': { 'zh-CN':'金融区', en:'Financial District', ja:'金融街', ko:'금융지구' },
  '魏克爾公園': { 'zh-CN':'威克公园', en:'Wicker Park', ja:'ウィッカーパーク', ko:'위커파크' },
  '林肯廣場': { 'zh-CN':'林肯广场', en:'Lincoln Square', ja:'リンカーン広場', ko:'링컨스퀘어' },
  '芝加哥環路': { 'zh-CN':'芝加哥环路', en:'The Loop', ja:'ザ・ループ', ko:'더루프' },
  '海德公園': { 'zh-CN':'海德公园', en:'Hyde Park', ja:'ハイドパーク', ko:'하이드파크' },
  // Hawaii
  '威基基': { 'zh-CN':'威基基', en:'Waikiki', ja:'ワイキキ', ko:'와이키키' },
  '大鑽石頭': { 'zh-CN':'大钻石头', en:'Diamond Head', ja:'ダイヤモンドヘッド', ko:'다이아몬드헤드' },
  '珍珠港': { 'zh-CN':'珍珠港', en:'Pearl Harbor', ja:'真珠湾', ko:'진주만' },
  '歐胡島': { 'zh-CN':'欧胡岛', en:'Oahu', ja:'オアフ島', ko:'오아후섬' },
  '茂宜島': { 'zh-CN':'茂宜岛', en:'Maui', ja:'マウイ島', ko:'마우이섬' },
  '大島': { 'zh-CN':'大岛', en:'Big Island', ja:'ハワイ島', ko:'빅아일랜드' },
  '可愛島': { 'zh-CN':'可爱岛', en:'Kauai', ja:'カウアイ島', ko:'카우아이섬' },
  '拉奈島': { 'zh-CN':'拉奈岛', en:'Lanai', ja:'ラナイ島', ko:'라나이섬' },
  // Vancouver
  '溫哥華市中心': { 'zh-CN':'温哥华市中心', en:'Downtown Vancouver', ja:'ダウンタウン・バンクーバー', ko:'다운타운밴쿠버' },
  '格蘭維爾島': { 'zh-CN':'格兰维尔岛', en:'Granville Island', ja:'グランビル・アイランド', ko:'그랜빌아일랜드' },
  '蓋士鎮': { 'zh-CN':'盖士镇', en:'Gastown', ja:'ギャスタウン', ko:'개스타운' },
  '斯坦利公園': { 'zh-CN':'斯坦利公园', en:'Stanley Park', ja:'スタンレーパーク', ko:'스탠리파크' },
  '商業大道': { 'zh-CN':'商业大道', en:'Commercial Drive', ja:'コマーシャル・ドライブ', ko:'커머셜드라이브' },
  '奇拉諾': { 'zh-CN':'奇拉诺', en:'Kitsilano', ja:'キツラノ', ko:'키칠라노' },
  '素里': { 'zh-CN':'素里', en:'Surrey', ja:'サリー', ko:'서리' },
  // Toronto
  'CN塔': { 'zh-CN':'CN塔', en:'CN Tower', ja:'CNタワー', ko:'CN타워' },
  '肯星頓市場': { 'zh-CN':'肯辛顿市场', en:'Kensington Market', ja:'ケンジントン市場', ko:'켄싱턴마켓' },
  '皇后街西': { 'zh-CN':'皇后街西', en:'Queen Street West', ja:'クイーン・ストリート・ウエスト', ko:'퀸스트리트웨스트' },
  '蒸餾廠區': { 'zh-CN':'蒸馏厂区', en:'Distillery District', ja:'ディスティラリー地区', ko:'디스틸러리지구' },
  '約克維爾': { 'zh-CN':'约克维尔', en:'Yorkville', ja:'ヨークヴィル', ko:'요크빌' },
  // Cancun
  '酒店區': { 'zh-CN':'酒店区', en:'Hotel Zone', ja:'ホテルゾーン', ko:'호텔존' },
  '市中心': { 'zh-CN':'市中心', en:'Downtown', ja:'ダウンタウン', ko:'다운타운' },
  '普拉亞德爾卡門': { 'zh-CN':'普拉亚德尔卡门', en:'Playa del Carmen', ja:'プラヤ・デル・カルメン', ko:'플라야델카르멘' },
  '圖盧姆': { 'zh-CN':'图卢姆', en:'Tulum', ja:'トゥルム', ko:'툴룸' },
  '科蘇梅爾': { 'zh-CN':'科苏梅尔', en:'Cozumel', ja:'コスメル島', ko:'코수멜' },
  '伊斯拉穆赫雷斯': { 'zh-CN':'伊斯拉穆赫雷斯', en:'Isla Mujeres', ja:'イスラ・ムヘーレス', ko:'이슬라무헤레스' },
  // Mexico City
  '查普爾特佩克': { 'zh-CN':'查普尔特佩克', en:'Chapultepec', ja:'チャプルテペック', ko:'차풀테펙' },
  '索卡洛': { 'zh-CN':'索卡洛', en:'Zócalo', ja:'ソカロ広場', ko:'소칼로광장' },
  '波朗科': { 'zh-CN':'波兰科', en:'Polanco', ja:'ポランコ', ko:'폴랑코' },
  '羅馬區': { 'zh-CN':'罗马区', en:'Roma', ja:'ローマ地区', ko:'로마지구' },
  '科約阿坎': { 'zh-CN':'科约阿坎', en:'Coyoacán', ja:'コヨアカン', ko:'코요아칸' },
  '聖天使': { 'zh-CN':'圣天使', en:'San Ángel', ja:'サンアンヘル', ko:'산앙헬' },
  '特拉特洛爾科': { 'zh-CN':'特拉特洛尔科', en:'Tlatelolco', ja:'トラテロルコ', ko:'틀라텔롤코' },
  // Rio de Janeiro
  '科帕卡巴納': { 'zh-CN':'科帕卡巴纳', en:'Copacabana', ja:'コパカバーナ', ko:'코파카바나' },
  '伊帕內瑪': { 'zh-CN':'伊帕内玛', en:'Ipanema', ja:'イパネマ', ko:'이파네마' },
  '聖特雷莎': { 'zh-CN':'圣特蕾莎', en:'Santa Teresa', ja:'サンタ・テレサ', ko:'산타테레사' },
  '博塔福戈': { 'zh-CN':'博塔弗戈', en:'Botafogo', ja:'ボタフォゴ', ko:'보타포구' },
  '拉帕': { 'zh-CN':'拉帕', en:'Lapa', ja:'ラパ', ko:'라파' },
  '中心區': { 'zh-CN':'中心区', en:'Centro', ja:'セントロ', ko:'센트루' },
  '巴哈': { 'zh-CN':'巴哈', en:'Barra da Tijuca', ja:'バハ・ダ・チジュカ', ko:'바하다치주카' },
  // Buenos Aires
  '巴勒莫': { 'zh-CN':'巴勒莫', en:'Palermo', ja:'パレルモ', ko:'팔레르모' },
  '聖特爾莫': { 'zh-CN':'圣特尔莫', en:'San Telmo', ja:'サン・テルモ', ko:'산텔모' },
  '科里恩特斯大道': { 'zh-CN':'科连特斯大道', en:'Avenida Corrientes', ja:'コリエンテス通り', ko:'코리엔테스대로' },
  '波卡': { 'zh-CN':'博卡', en:'La Boca', ja:'ラボカ', ko:'라보카' },
  '雷科萊塔': { 'zh-CN':'雷科莱塔', en:'Recoleta', ja:'レコレータ', ko:'레콜레타' },
  '卡米尼托': { 'zh-CN':'卡米尼托', en:'Caminito', ja:'カミニート', ko:'카미니토' },
  // Lima
  '米拉弗洛雷斯': { 'zh-CN':'米拉弗洛雷斯', en:'Miraflores', ja:'ミラフローレス', ko:'미라플로레스' },
  '巴蘭科': { 'zh-CN':'巴兰科', en:'Barranco', ja:'バランコ', ko:'바랑코' },
  '聖伊西德羅': { 'zh-CN':'圣伊西德罗', en:'San Isidro', ja:'サン・イシドロ', ko:'산이시드로' },
  '馬格達萊納': { 'zh-CN':'马格达莱纳', en:'Magdalena', ja:'マグダレナ', ko:'막달레나' },
  '蘇爾科': { 'zh-CN':'苏尔科', en:'Surco', ja:'スルコ', ko:'수르코' },
  // Santiago
  '貝拉維斯塔': { 'zh-CN':'贝拉维斯塔', en:'Bellavista', ja:'ベジャビスタ', ko:'베야비스타' },
  '普羅維登西亞': { 'zh-CN':'普罗维登西亚', en:'Providencia', ja:'プロビデンシア', ko:'프로비덴시아' },
  '聖地牙哥老城': { 'zh-CN':'圣地亚哥老城', en:'Santiago Old Town', ja:'サンティアゴ旧市街', ko:'산티아고구시가지' },
  '拉斯孔德斯': { 'zh-CN':'拉斯孔德斯', en:'Las Condes', ja:'ラス・コンデス', ko:'라스콘데스' },
  '努紐阿': { 'zh-CN':'纽诺阿', en:'Ñuñoa', ja:'ニュニョア', ko:'뉴뇨아' },
  '波利奧': { 'zh-CN':'波希奥', en:'Bosque de Polio', ja:'ボスケ・デ・ポリオ', ko:'보스케데폴리오' },
  // Bogota
  '坎德拉里亞': { 'zh-CN':'坎德拉里亚', en:'La Candelaria', ja:'ラ・カンデラリア', ko:'라칸델라리아' },
  '查平納羅': { 'zh-CN':'查平纳罗', en:'Chapinero', ja:'チャピネロ', ko:'차피네로' },
  '波利瓦爾廣場': { 'zh-CN':'玻利瓦尔广场', en:'Plaza Bolívar', ja:'ボリバル広場', ko:'볼리바르광장' },
  '烏薩坎': { 'zh-CN':'乌萨昆', en:'Usaquén', ja:'ウサケン', ko:'우사켄' },
  '蒙塞拉特山': { 'zh-CN':'蒙塞拉特山', en:'Monserrate', ja:'モンセラーテ', ko:'몬세라테' },
  // Cartagena
  '博卡格蘭德': { 'zh-CN':'博卡格兰德', en:'Bocagrande', ja:'ボカグランデ', ko:'보카그란데' },
  '格茲馬尼': { 'zh-CN':'格茲马尼', en:'Getsemaní', ja:'ゲッセマニ', ko:'헤체마니' },
  '歷史中心': { 'zh-CN':'历史中心', en:'Historic Centre', ja:'歴史地区', ko:'역사지구' },
  '羅塞達爾': { 'zh-CN':'罗塞达尔', en:'Rosedal', ja:'ロセダル', ko:'로세달' },
  '海灘': { 'zh-CN':'海滩', en:'Beach', ja:'ビーチ', ko:'해변' },
  // Cusco
  '武器廣場': { 'zh-CN':'武器广场', en:'Plaza de Armas', ja:'アルマス広場', ko:'아르마스광장' },
  '聖多明哥教堂': { 'zh-CN':'圣多明哥教堂', en:'Santo Domingo Church', ja:'サント・ドミンゴ教会', ko:'산토도밍고교회' },
  '薩克塞瓦曼': { 'zh-CN':'萨克塞瓦曼', en:'Sacsayhuamán', ja:'サクサイワマン', ko:'삭사이와만' },
  '聖布拉斯': { 'zh-CN':'圣布拉斯', en:'San Blas', ja:'サン・ブラス', ko:'산블라스' },
  '烏魯班巴': { 'zh-CN':'乌鲁班巴', en:'Urubamba', ja:'ウルバンバ', ko:'우루밤바' },
  '馬丘比丘': { 'zh-CN':'马丘比丘', en:'Machu Picchu', ja:'マチュピチュ', ko:'마추픽추' },
  // Washington DC
  '國家廣場': { 'zh-CN':'国家广场', en:'National Mall', ja:'ナショナル・モール', ko:'내셔널몰' },
  '林肯紀念堂': { 'zh-CN':'林肯纪念堂', en:'Lincoln Memorial', ja:'リンカーン記念館', ko:'링컨기념관' },
  '國會山': { 'zh-CN':'国会山', en:'Capitol Hill', ja:'キャピトルヒル', ko:'캐피톨힐' },
  '喬治城': { 'zh-CN':'乔治城', en:'Georgetown', ja:'ジョージタウン', ko:'조지타운' },
  '史密森尼博物館群': { 'zh-CN':'史密森尼博物馆群', en:'Smithsonian Museums', ja:'スミソニアン博物館群', ko:'스미소니언박물관' },
  // Seattle
  '太空針塔': { 'zh-CN':'太空针塔', en:'Space Needle', ja:'スペースニードル', ko:'스페이스니들' },
  '派克市場': { 'zh-CN':'派克市场', en:'Pike Place Market', ja:'パイク・プレイス・マーケット', ko:'파이크플레이스마켓' },
  '西雅圖中心': { 'zh-CN':'西雅图中心', en:'Seattle Center', ja:'シアトルセンター', ko:'시애틀센터' },
  '國會山莊區': { 'zh-CN':'国会山庄区', en:'Capitol Hill', ja:'キャピトルヒル', ko:'캐피톨힐' },
  '巴拉德': { 'zh-CN':'巴拉德', en:'Ballard', ja:'バラード', ko:'발라드' },
  // Boston
  '自由之路': { 'zh-CN':'自由之路', en:'Freedom Trail', ja:'フリーダムトレイル', ko:'프리덤트레일' },
  '芬威球場': { 'zh-CN':'芬威球场', en:'Fenway Park', ja:'フェンウェイパーク', ko:'펜웨이파크' },
  '昆西市場': { 'zh-CN':'昆西市场', en:'Quincy Market', ja:'クインシー・マーケット', ko:'퀸시마켓' },
  '後灣區': { 'zh-CN':'后湾区', en:'Back Bay', ja:'バックベイ', ko:'백베이' },
  '哈佛廣場': { 'zh-CN':'哈佛广场', en:'Harvard Square', ja:'ハーバード広場', ko:'하버드스퀘어' },
  // New Orleans
  '法國區': { 'zh-CN':'法国区', en:'French Quarter', ja:'フレンチクォーター', ko:'프렌치쿼터' },
  '波本街': { 'zh-CN':'波旁街', en:'Bourbon Street', ja:'バーボン・ストリート', ko:'버번스트리트' },
  '花園區': { 'zh-CN':'花园区', en:'Garden District', ja:'ガーデン地区', ko:'가든디스트릭트' },
  '河濱步道': { 'zh-CN':'河滨步道', en:'Riverfront', ja:'リバーフロント', ko:'리버프론트' },
  '爵士樂博物館': { 'zh-CN':'爵士乐博物馆', en:'New Orleans Jazz Museum', ja:'ニューオーリンズ・ジャズ博物館', ko:'뉴올리언스재즈박물관' },
  // Montreal
  '舊蒙特婁': { 'zh-CN':'旧蒙特利尔', en:'Old Montreal', ja:'旧モントリオール', ko:'올드몬트리올' },
  '皇家山公園': { 'zh-CN':'皇家山公园', en:'Mount Royal Park', ja:'モン・ロワイヤル公園', ko:'몽로얄공원' },
  '聖凱瑟琳街': { 'zh-CN':'圣凯瑟琳街', en:'Saint Catherine Street', ja:'サント・カトリーヌ通り', ko:'생트카트린거리' },
  // Sao Paulo
  '保利斯塔大道': { 'zh-CN':'保利斯塔大道', en:'Avenida Paulista', ja:'パウリスタ大通り', ko:'파울리스타대로' },
  '解放區': { 'zh-CN':'自由区', en:'Liberdade', ja:'リベルダージ', ko:'리베르다지' },
  '莫倫比': { 'zh-CN':'莫伦比', en:'Morumbi', ja:'モルンビ', ko:'모룸비' },
  '伊比拉普耶拉公園': { 'zh-CN':'伊比拉普埃拉公园', en:'Ibirapuera Park', ja:'イビラプエラ公園', ko:'이비라푸에라공원' },
  // Uyuni
  '烏尤尼鹽沼': { 'zh-CN':'乌尤尼盐沼', en:'Salar de Uyuni', ja:'ウユニ塩湖', ko:'우유니소금사막' },
  '火車墳場': { 'zh-CN':'火车坟场', en:'Train Cemetery', ja:'列車の墓場', ko:'기차무덤' },
  '因卡瓦西島': { 'zh-CN':'因卡瓦西岛', en:'Incahuasi Island', ja:'インカワシ島', ko:'잉카와시섬' },
  '紅湖': { 'zh-CN':'红湖', en:'Laguna Colorada', ja:'赤い湖', ko:'라구나콜로라다' },
  '綠湖': { 'zh-CN':'绿湖', en:'Laguna Verde', ja:'緑の湖', ko:'라구나베르데' },
  // Sydney
  '岩石區': { 'zh-CN':'岩石区', en:'The Rocks', ja:'ザ・ロックス', ko:'더록스' },
  '達令港': { 'zh-CN':'达令港', en:'Darling Harbour', ja:'ダーリング・ハーバー', ko:'달링하버' },
  '邦迪海灘': { 'zh-CN':'邦迪海滩', en:'Bondi Beach', ja:'ボンダイビーチ', ko:'본다이비치' },
  '莫斯曼': { 'zh-CN':'莫斯曼', en:'Mosman', ja:'モスマン', ko:'모스만' },
  '薩里山': { 'zh-CN':'萨里山', en:'Surry Hills', ja:'サリーヒルズ', ko:'서리힐스' },
  '薩里丘': { 'zh-CN':'萨里丘', en:'Surry Hills', ja:'サリーヒルズ', ko:'서리힐스' },
  '帕丁頓': { 'zh-CN':'帕丁顿', en:'Paddington', ja:'パディントン', ko:'패딩턴' },
  '諾斯悉尼': { 'zh-CN':'北悉尼', en:'North Sydney', ja:'ノースシドニー', ko:'노스시드니' },
  // Melbourne
  '聯邦廣場': { 'zh-CN':'联邦广场', en:'Federation Square', ja:'フェデレーション・スクエア', ko:'페더레이션스퀘어' },
  '菲茨羅伊': { 'zh-CN':'菲茨罗伊', en:'Fitzroy', ja:'フィッツロイ', ko:'피츠로이' },
  '聖基爾達': { 'zh-CN':'圣基尔达', en:'St Kilda', ja:'セント・キルダ', ko:'세인트킬다' },
  '布倫瑞克': { 'zh-CN':'布倫瑞克', en:'Brunswick', ja:'ブランズウィック', ko:'브런즈윅' },
  '科林伍德': { 'zh-CN':'科林伍德', en:'Collingwood', ja:'コリングウッド', ko:'콜링우드' },
  '中央商業區': { 'zh-CN':'中央商业区', en:'CBD', ja:'CBD', ko:'CBD' },
  '南亞拉': { 'zh-CN':'南亚拉', en:'South Yarra', ja:'サウス・ヤラ', ko:'사우스야라' },
  // Gold Coast
  '衝浪者天堂': { 'zh-CN':'冲浪者天堂', en:'Surfers Paradise', ja:'サーファーズパラダイス', ko:'서퍼스파라다이스' },
  '寬闊海灘': { 'zh-CN':'宽阔海滩', en:'Broadbeach', ja:'ブロードビーチ', ko:'브로드비치' },
  '庫蘭加塔': { 'zh-CN':'库兰加塔', en:'Coolangatta', ja:'クーランガッタ', ko:'쿨랑가타' },
  '博覽地': { 'zh-CN':'博览地', en:'Expo Precinct', ja:'エキスポ地区', ko:'엑스포지구' },
  '聖靈群島': { 'zh-CN':'圣灵群岛', en:'Whitsunday Islands', ja:'ウィットサンデー諸島', ko:'휘트선데이제도' },
  '黃金海岸主題公園': { 'zh-CN':'黄金海岸主题公园', en:'Gold Coast Theme Parks', ja:'ゴールドコースト・テーマパーク', ko:'골드코스트테마파크' },
  // Brisbane
  '故事橋': { 'zh-CN':'故事桥', en:'Story Bridge', ja:'ストーリーブリッジ', ko:'스토리브리지' },
  '佛蒂谷': { 'zh-CN':'佛蒂谷', en:'Fortitude Valley', ja:'フォーティテュード・バレー', ko:'포티튜드밸리' },
  '新農場': { 'zh-CN':'新农场', en:'New Farm', ja:'ニューファーム', ko:'뉴팜' },
  '布里斯班CBD': { 'zh-CN':'布里斯班CBD', en:'Brisbane CBD', ja:'ブリスベンCBD', ko:'브리즈번CBD' },
  '史丹利街市場': { 'zh-CN':'斯坦利街市场', en:'Stanley Street Market', ja:'スタンレー・ストリート・マーケット', ko:'스탠리스트리트마켓' },
  '康尼爾山': { 'zh-CN':'康尼尔山', en:'Mount Coot-tha', ja:'クータ山', ko:'쿠타산' },
  // Perth
  '弗里曼特爾': { 'zh-CN':'弗里曼特尔', en:'Fremantle', ja:'フリーマントル', ko:'프리맨틀' },
  '珀斯CBD': { 'zh-CN':'珀斯CBD', en:'Perth CBD', ja:'パースCBD', ko:'퍼스CBD' },
  '諾斯布里奇': { 'zh-CN':'诺斯布里奇', en:'Northbridge', ja:'ノースブリッジ', ko:'노스브리지' },
  '科特斯洛海灘': { 'zh-CN':'科特斯洛海滩', en:'Cottesloe Beach', ja:'コテスロー・ビーチ', ko:'코테슬로비치' },
  '國王公園': { 'zh-CN':'国王公园', en:'Kings Park', ja:'キングスパーク', ko:'킹스파크' },
  '蘇比亞科': { 'zh-CN':'苏比亚科', en:'Subiaco', ja:'サビアコ', ko:'서비아코' },
  '科金納普': { 'zh-CN':'科金纳普', en:'Kwinana', ja:'クワナナ', ko:'퀴나나' },
  // Adelaide
  '阿德萊德CBD': { 'zh-CN':'阿德莱德CBD', en:'Adelaide CBD', ja:'アデレードCBD', ko:'애들레이드CBD' },
  '漢恩多夫': { 'zh-CN':'汉恩多夫', en:'Hahndorf', ja:'ハーンドルフ', ko:'한도르프' },
  '芭羅莎谷': { 'zh-CN':'巴罗莎谷', en:'Barossa Valley', ja:'バロッサバレー', ko:'바로사밸리' },
  '格倫埃爾格': { 'zh-CN':'格伦埃尔格', en:'Glenelg', ja:'グレネルグ', ko:'글레넬그' },
  '北德萊頓': { 'zh-CN':'北德莱顿', en:'North Terrace', ja:'ノーステラス', ko:'노스테라스' },
  '諾頓薩米特': { 'zh-CN':'诺顿萨米特', en:'Norton Summit', ja:'ノートンサミット', ko:'노턴서밋' },
  // Cairns
  '凱恩斯CBD': { 'zh-CN':'凯恩斯CBD', en:'Cairns CBD', ja:'ケアンズCBD', ko:'케언즈CBD' },
  '大堡礁': { 'zh-CN':'大堡礁', en:'Great Barrier Reef', ja:'グレートバリアリーフ', ko:'그레이트배리어리프' },
  '棕櫚灣': { 'zh-CN':'棕榈湾', en:'Palm Cove', ja:'パームコーブ', ko:'팜코브' },
  '庫蘭達': { 'zh-CN':'库兰达', en:'Kuranda', ja:'クランダ', ko:'쿠란다' },
  '道格拉斯港': { 'zh-CN':'道格拉斯港', en:'Port Douglas', ja:'ポートダグラス', ko:'포트더글러스' },
  '艾瑟頓高地': { 'zh-CN':'埃瑟顿高地', en:'Atherton Tablelands', ja:'アサートン・テーブルランド', ko:'애서턴테이블랜드' },
  // Auckland
  '龐森比': { 'zh-CN':'庞森比', en:'Ponsonby', ja:'ポンソンビー', ko:'폰소니' },
  '帕內爾': { 'zh-CN':'帕内尔', en:'Parnell', ja:'パーネル', ko:'파넬' },
  '德文波特': { 'zh-CN':'德文波特', en:'Devonport', ja:'デヴォンポート', ko:'데번포트' },
  '霍恩比': { 'zh-CN':'霍恩比', en:'Hornby', ja:'ホーンビー', ko:'혼비' },
  '懷赫科島': { 'zh-CN':'怀赫科岛', en:'Waiheke Island', ja:'ワイヘケ島', ko:'와이헤케섬' },
  '北岸': { 'zh-CN':'北岸', en:'North Shore', ja:'ノースショア', ko:'노스쇼어' },
  // Queenstown
  '天空纜車': { 'zh-CN':'天空缆车', en:'Skyline Gondola', ja:'スカイラインゴンドラ', ko:'스카이라인곤돌라' },
  '米爾福德峽灣': { 'zh-CN':'米尔福德峡湾', en:'Milford Sound', ja:'ミルフォード・サウンド', ko:'밀포드사운드' },
  '箭鎮': { 'zh-CN':'箭镇', en:'Arrowtown', ja:'アロータウン', ko:'애로우타운' },
  '瓦納卡': { 'zh-CN':'瓦纳卡', en:'Wanaka', ja:'ワナカ', ko:'와나카' },
  '皇后鎮灣': { 'zh-CN':'皇后镇湾', en:'Queenstown Bay', ja:'クイーンズタウン湾', ko:'퀸스타운베이' },
  // Wellington
  '古巴街': { 'zh-CN':'古巴街', en:'Cuba Street', ja:'キューバ・ストリート', ko:'쿠바스트리트' },
  '泰和碼頭': { 'zh-CN':'泰和码头', en:'Te Aro Waterfront', ja:'テ・アロ・ウォーターフロント', ko:'테아로워터프론트' },
  '維多利亞山': { 'zh-CN':'维多利亚山', en:'Mount Victoria', ja:'ヴィクトリア山', ko:'빅토리아산' },
  '蒂帕帕博物館': { 'zh-CN':'蒂帕帕博物馆', en:'Te Papa Museum', ja:'テ・パパ博物館', ko:'테파파박물관' },
  '科里馬馬港': { 'zh-CN':'科里马马港', en:'Kilbirnie', ja:'キルバーニー', ko:'킬버니' },
  '彼得敦': { 'zh-CN':'彼得敦', en:'Petone', ja:'ピトーネ', ko:'피토네' },
  // Christchurch
  '卡德博納廣場': { 'zh-CN':'卡德博纳广场', en:'Cathedral Square', ja:'大聖堂広場', ko:'대성당광장' },
  '埃文河': { 'zh-CN':'埃文河', en:'Avon River', ja:'エイヴォン川', ko:'에이번강' },
  '里卡頓市場': { 'zh-CN':'里卡顿市场', en:'Riccarton Market', ja:'リカートン市場', ko:'리카튼마켓' },
  '利特爾頓': { 'zh-CN':'利特尔顿', en:'Lyttelton', ja:'リトルトン', ko:'리틀턴' },
  '薩姆納': { 'zh-CN':'萨姆纳', en:'Sumner', ja:'サムナー', ko:'섬너' },
  // Rotorua
  '羅托魯阿湖': { 'zh-CN':'罗托鲁阿湖', en:'Lake Rotorua', ja:'ロトルア湖', ko:'로토루아호' },
  '地熱公園': { 'zh-CN':'地热公园', en:'Geothermal Park', ja:'地熱公園', ko:'지열공원' },
  '毛利文化村': { 'zh-CN':'毛利文化村', en:'Māori Cultural Village', ja:'マオリ文化村', ko:'마오리문화마을' },
  '彩虹溫泉': { 'zh-CN':'彩虹温泉', en:'Rainbow Springs', ja:'レインボースプリングス', ko:'레인보우스프링스' },
  '懷歐陶普地熱谷': { 'zh-CN':'怀欧陶普地热谷', en:'Waiotapu Thermal Wonderland', ja:'ワイオタプ', ko:'와이오타푸' },
  '地獄之門': { 'zh-CN':'地狱之门', en:'Hell\'s Gate', ja:'ヘルズゲート', ko:'헬스게이트' },
  // Hobart
  '薩拉曼卡市場': { 'zh-CN':'萨拉曼卡市场', en:'Salamanca Market', ja:'サラマンカ・マーケット', ko:'살라만카마켓' },
  '威靈頓山': { 'zh-CN':'惠灵顿山', en:'Mount Wellington', ja:'ウェリントン山', ko:'웰링턴산' },
  '巴特里角': { 'zh-CN':'巴特里角', en:'Battery Point', ja:'バッテリーポイント', ko:'배터리포인트' },
  '莫納現代藝術博物館': { 'zh-CN':'莫纳现代艺术博物馆', en:'MONA (Museum of Old and New Art)', ja:'モナ現代美術館', ko:'모나현대미술관' },
  // Uluru
  '烏魯魯巨石': { 'zh-CN':'乌鲁鲁巨石', en:'Uluru (Ayers Rock)', ja:'ウルル(エアーズロック)', ko:'울루루' },
  '卡塔丘塔': { 'zh-CN':'卡塔丘塔', en:'Kata Tjuta', ja:'カタジュタ', ko:'카타추타' },
  '尤拉拉小鎮': { 'zh-CN':'尤拉拉小镇', en:'Yulara', ja:'ユララ', ko:'율라라' },
  '田野之光': { 'zh-CN':'荒野之光', en:'Field of Light', ja:'フィールド・オブ・ライト', ko:'필드오브라이트' },
  // Cape Town
  '桌山': { 'zh-CN':'桌山', en:'Table Mountain', ja:'テーブルマウンテン', ko:'테이블마운틴' },
  '博卡普': { 'zh-CN':'波卡普', en:'Bo-Kaap', ja:'ボカープ', ko:'보카프' },
  '綠點': { 'zh-CN':'绿点', en:'Green Point', ja:'グリーンポイント', ko:'그린포인트' },
  '沃特坎特': { 'zh-CN':'沃特坎特', en:'V&A Waterfront', ja:'V&Aウォーターフロント', ko:'워터프론트' },
  '坎普斯灣': { 'zh-CN':'坎普斯湾', en:'Camps Bay', ja:'キャンプス・ベイ', ko:'캠프스베이' },
  '西蒙斯敦': { 'zh-CN':'西蒙斯敦', en:'Simon\'s Town', ja:'サイモンズタウン', ko:'사이먼스타운' },
  '斯特倫博斯': { 'zh-CN':'斯泰伦博斯', en:'Stellenbosch', ja:'ステレンボッシュ', ko:'스텔렌보스' },
  '羅本島': { 'zh-CN':'罗本岛', en:'Robben Island', ja:'ロベン島', ko:'로벤섬' },
  // Marrakech
  '麥地那': { 'zh-CN':'麦地那', en:'Medina', ja:'メディナ', ko:'메디나' },
  '賈馬拉夫納廣場': { 'zh-CN':'德吉玛广场', en:'Jemaa el-Fnaa', ja:'ジャマ・エル・フナ広場', ko:'제마엘프나광장' },
  '蘇克': { 'zh-CN':'苏克', en:'Souk', ja:'スーク', ko:'수크' },
  '吉利茲': { 'zh-CN':'吉利兹', en:'Gueliz', ja:'ゲリズ', ko:'겔리즈' },
  '帕爾梅里亞': { 'zh-CN':'棕榈园', en:'Palmeraie', ja:'パルメライエ', ko:'팔메레' },
  '薩阿德陵墓': { 'zh-CN':'萨阿德陵墓', en:'Saadian Tombs', ja:'サード朝の墓廟', ko:'사아드왕조무덤' },
  // Cairo
  '吉薩金字塔': { 'zh-CN':'吉萨金字塔', en:'Giza Pyramids', ja:'ギザのピラミッド', ko:'기자피라미드' },
  '汗哈利利市集': { 'zh-CN':'汗哈利利市集', en:'Khan el-Khalili', ja:'ハーン・ハリーリ市場', ko:'칸엘칼릴리시장' },
  '開羅博物館': { 'zh-CN':'开罗博物馆', en:'Egyptian Museum', ja:'エジプト考古学博物館', ko:'이집트박물관' },
  '伊斯蘭開羅': { 'zh-CN':'伊斯兰开罗', en:'Islamic Cairo', ja:'イスラム地区', ko:'이슬람카이로' },
  '科普特開羅': { 'zh-CN':'科普特开罗', en:'Coptic Cairo', ja:'コプト地区', ko:'콥트카이로' },
  '扎馬萊克': { 'zh-CN':'扎马雷克', en:'Zamalek', ja:'ザマレク', ko:'자말렉' },
  // Nairobi
  '奈洛比國家公園': { 'zh-CN':'内罗毕国家公园', en:'Nairobi National Park', ja:'ナイロビ国立公園', ko:'나이로비국립공원' },
  '長頸鹿中心': { 'zh-CN':'长颈鹿中心', en:'Giraffe Centre', ja:'キリンセンター', ko:'기린센터' },
  '大衛謝爾德里克大象孤兒院': { 'zh-CN':'大卫谢尔德里克大象孤儿院', en:'David Sheldrick Wildlife Trust', ja:'デイビッド・シェルドリック野生動物保護区', ko:'데이비드셸드릭야생동물보호구' },
  '卡倫': { 'zh-CN':'卡伦', en:'Karen', ja:'カレン', ko:'카렌' },
  // Serengeti
  '塞倫蓋提國家公園': { 'zh-CN':'塞伦盖蒂国家公园', en:'Serengeti National Park', ja:'セレンゲティ国立公園', ko:'세렝게티국립공원' },
  '恩戈羅恩戈羅保護區': { 'zh-CN':'恩戈罗恩戈罗保护区', en:'Ngorongoro Conservation Area', ja:'ンゴロンゴロ保全地域', ko:'응고롱고로보전지역' },
  '塞羅內拉': { 'zh-CN':'塞罗内拉', en:'Seronera', ja:'セロネラ', ko:'세로네라' },
  '格魯梅提': { 'zh-CN':'格鲁美提', en:'Grumeti', ja:'グルメティ', ko:'그루메티' },
  // Late additions found missing from initial pass
  '九份': { 'zh-CN':'九份', en:'Jiufen', ja:'九份', ko:'주펀' },
  '舊城廣場': { 'zh-CN':'旧城广场', en:'Old Town Square', ja:'旧市街広場', ko:'구시가지광장' },
  '下城': { 'zh-CN':'下城', en:'Lower Town', ja:'下町', ko:'아랫마을' },
  // 2026-10-05: translations for district chips added during the blank-district fill (zh-CN/ja derived via opencc or hand-written; ko intentionally omitted → falls back to the stored name)
  '兩江新區': { 'zh-CN':'两江新区', en:'Liangjiang New Area', ja:'両江新区' },
  '永川區': { 'zh-CN':'永川区', en:'Yongchuan District', ja:'永川区' },
  '九龍坡區': { 'zh-CN':'九龙坡区', en:'Jiulongpo District', ja:'九竜坡区' },
  '奉節縣': { 'zh-CN':'奉节县', en:'Fengjie County', ja:'奉節県' },
  '重慶高新區': { 'zh-CN':'重庆高新区', en:'Chongqing High-tech Zone', ja:'重慶高新区' },
  '合川區': { 'zh-CN':'合川区', en:'Hechuan District', ja:'合川区' },
  '江津區': { 'zh-CN':'江津区', en:'Jiangjin District', ja:'江津区' },
  '崖州區': { 'zh-CN':'崖州区', en:'Yazhou District', ja:'崖州区' },
  '天涯區': { 'zh-CN':'天涯区', en:'Tianya District', ja:'天涯区' },
  '海棠區': { 'zh-CN':'海棠区', en:'Haitang District', ja:'海棠区' },
  '吉陽區': { 'zh-CN':'吉阳区', en:'Jiyang District', ja:'吉陽区' },
  '新店區': { 'zh-CN':'新店区', en:'Xindian District', ja:'新店区' },
  '內湖區': { 'zh-CN':'内湖区', en:'Neihu District', ja:'内湖区' },
  '八里區': { 'zh-CN':'八里区', en:'Bali District', ja:'八里区' },
  '中和區': { 'zh-CN':'中和区', en:'Zhonghe District', ja:'中和区' },
  '汐止區': { 'zh-CN':'汐止区', en:'Xizhi District', ja:'汐止区' },
  '鳳山區': { 'zh-CN':'凤山区', en:'Fengshan District', ja:'鳳山区' },
  '燕巢區': { 'zh-CN':'燕巢区', en:'Yanchao District', ja:'燕巣区' },
  '大甲區': { 'zh-CN':'大甲区', en:'Dajia District', ja:'大甲区' },
  '外埔區': { 'zh-CN':'外埔区', en:'Waipu District', ja:'外埔区' },
  '南澳鄉': { 'zh-CN':'南澳乡', en:'Nan\'ao Township', ja:'南澳郷' },
  '豐濱鄉': { 'zh-CN':'丰滨乡', en:'Fengbin Township', ja:'豊浜郷' },
  '秀林鄉': { 'zh-CN':'秀林乡', en:'Xiulin Township', ja:'秀林郷' },
  '富里鄉': { 'zh-CN':'富里乡', en:'Fuli Township', ja:'富里郷' },
  '壽豐鄉': { 'zh-CN':'寿丰乡', en:'Shoufeng Township', ja:'寿豊郷' },
  '新城鄉': { 'zh-CN':'新城乡', en:'Xincheng Township', ja:'新城郷' },
  '卓溪鄉': { 'zh-CN':'卓溪乡', en:'Zhuoxi Township', ja:'卓渓郷' },
  '恆春鎮': { 'zh-CN':'恒春镇', en:'Hengchun Township', ja:'恒春鎮' },
  '滿州鄉': { 'zh-CN':'满州乡', en:'Manzhou Township', ja:'満州郷' },
  '車城鄉': { 'zh-CN':'车城乡', en:'Checheng Township', ja:'車城郷' },
  '烏來區': { 'zh-CN':'乌来区', en:'Wulai District', ja:'烏来区' },
  '龜山區': { 'zh-CN':'龟山区', en:'Guishan District', ja:'亀山区' },
  '復興區': { 'zh-CN':'复兴区', en:'Fuxing District', ja:'復興区' },
  '桃園區': { 'zh-CN':'桃园区', en:'Taoyuan District', ja:'桃園区' },
  '造橋鄉': { 'zh-CN':'造桥乡', en:'Zaoqiao Township', ja:'造橋郷' },
  '南庄鄉': { 'zh-CN':'南庄乡', en:'Nanzhuang Township', ja:'南庄郷' },
  '後龍鎮': { 'zh-CN':'后龙镇', en:'Houlong Township', ja:'後竜鎮' },
  '六腳鄉': { 'zh-CN':'六脚乡', en:'Liujiao Township', ja:'六脚郷' },
  '太保市': { 'zh-CN':'太保市', en:'Taibao City', ja:'太保市' },
  '梅山鄉': { 'zh-CN':'梅山乡', en:'Meishan Township', ja:'梅山郷' },
  '朴子市': { 'zh-CN':'朴子市', en:'Puzi City', ja:'朴子市' },
  '西螺鎮': { 'zh-CN':'西螺镇', en:'Xiluo Township', ja:'西螺鎮' },
  '虎尾鎮': { 'zh-CN':'虎尾镇', en:'Huwei Township', ja:'虎尾鎮' },
  '北港鎮': { 'zh-CN':'北港镇', en:'Beigang Township', ja:'北港鎮' },
  '八王子市': { 'zh-CN':'八王子市', en:'Hachioji', ja:'八王子市' },
  '中野区': { 'zh-CN':'中野区', en:'Nakano', ja:'中野区' },
  '江東区': { 'zh-CN':'江东区', en:'Koto', ja:'江東区' },
  '江戸川区': { 'zh-CN':'江户川区', en:'Edogawa', ja:'江戸川区' },
  '世田谷区': { 'zh-CN':'世田谷区', en:'Setagaya', ja:'世田谷区' },
  '大田区': { 'zh-CN':'大田区', en:'Ota', ja:'大田区' },
  '品川区': { 'zh-CN':'品川区', en:'Shinagawa', ja:'品川区' },
  '杉並区': { 'zh-CN':'杉并区', en:'Suginami', ja:'杉並区' },
  '吹田市': { 'zh-CN':'吹田市', en:'Suita', ja:'吹田市' },
  '摂津市': { 'zh-CN':'摂津市', en:'Settsu', ja:'摂津市' },
  '堺市': { 'zh-CN':'堺市', en:'Sakai', ja:'堺市' },
  '箕面市': { 'zh-CN':'箕面市', en:'Minoh', ja:'箕面市' },
  '北九州市': { 'zh-CN':'北九州市', en:'Kitakyushu', ja:'北九州市' },
  '福津市': { 'zh-CN':'福津市', en:'Fukutsu', ja:'福津市' },
  '中富良野町': { 'zh-CN':'中富良野町', en:'Naka-Furano', ja:'中富良野町' },
  '江別市': { 'zh-CN':'江别市', en:'Ebetsu', ja:'江別市' },
  '長久手市': { 'zh-CN':'长久手市', en:'Nagakute', ja:'長久手市' },
  '岩国市': { 'zh-CN':'岩国市', en:'Iwakuni', ja:'岩国市' },
  '東広島市': { 'zh-CN':'东広岛市', en:'Higashihiroshima', ja:'東広島市' },
  '廿日市市': { 'zh-CN':'廿日市市', en:'Hatsukaichi', ja:'廿日市市' },
  '山添村': { 'zh-CN':'山添村', en:'Yamazoe', ja:'山添村' },
  '阿蘇市': { 'zh-CN':'阿苏市', en:'Aso', ja:'阿蘇市' },
  '小国町': { 'zh-CN':'小国町', en:'Oguni', ja:'小国町' },
  '高森町': { 'zh-CN':'高森町', en:'Takamori', ja:'高森町' },
  '佐世保市': { 'zh-CN':'佐世保市', en:'Sasebo', ja:'佐世保市' },
  '利府町': { 'zh-CN':'利府町', en:'Rifu', ja:'利府町' },
  '旭川市': { 'zh-CN':'旭川市', en:'Asahikawa', ja:'旭川市' },
  '函館市': { 'zh-CN':'函馆市', en:'Hakodate', ja:'函館市' },
  '倶知安町': { 'zh-CN':'倶知安町', en:'Kutchan', ja:'倶知安町' },
  '壮瞥町': { 'zh-CN':'壮瞥町', en:'Sobetsu', ja:'壮瞥町' },
  '上富良野町': { 'zh-CN':'上富良野町', en:'Kami-Furano', ja:'上富良野町' },
  '豐臺區': { 'zh-CN':'丰台区', en:'Fengtai District', ja:'豊台区' },
  '海淀區': { 'zh-CN':'海淀区', en:'Haidian District', ja:'海淀区' },
  '懷柔區': { 'zh-CN':'怀柔区', en:'Huairou District', ja:'懐柔区' },
  '朝陽區': { 'zh-CN':'朝阳区', en:'Chaoyang District', ja:'朝陽区' },
  '門頭溝區': { 'zh-CN':'门头沟区', en:'Mentougou District', ja:'門頭溝区' },
  '昌平區': { 'zh-CN':'昌平区', en:'Changping District', ja:'昌平区' },
  '大興區': { 'zh-CN':'大兴区', en:'Daxing District', ja:'大興区' },
  '通州區': { 'zh-CN':'通州区', en:'Tongzhou District', ja:'通州区' },
  '延慶區': { 'zh-CN':'延庆区', en:'Yanqing District', ja:'延慶区' },
  '房山區': { 'zh-CN':'房山区', en:'Fangshan District', ja:'房山区' },
  '石景山區': { 'zh-CN':'石景山区', en:'Shijingshan District', ja:'石景山区' },
  '松江區': { 'zh-CN':'松江区', en:'Songjiang District', ja:'松江区' },
  '浦東新區': { 'zh-CN':'浦东新区', en:'Pudong New Area', ja:'浦東新区' },
  '寶山區': { 'zh-CN':'宝山区', en:'Baoshan District', ja:'宝山区' },
  '嘉定區': { 'zh-CN':'嘉定区', en:'Jiading District', ja:'嘉定区' },
  '青浦區': { 'zh-CN':'青浦区', en:'Qingpu District', ja:'青浦区' },
  '奉賢區': { 'zh-CN':'奉贤区', en:'Fengxian District', ja:'奉賢区' },
  '南沙區': { 'zh-CN':'南沙区', en:'Nansha District', ja:'南沙区' },
  '從化區': { 'zh-CN':'从化区', en:'Conghua District', ja:'従化区' },
  '黃埔區': { 'zh-CN':'黄埔区', en:'Huangpu District', ja:'黄埔区' },
  '白雲區': { 'zh-CN':'白云区', en:'Baiyun District', ja:'白雲区' },
  '增城區': { 'zh-CN':'增城区', en:'Zengcheng District', ja:'増城区' },
  '光明區': { 'zh-CN':'光明区', en:'Guangming District', ja:'光明区' },
  '龍華區': { 'zh-CN':'龙华区', en:'Longhua District', ja:'竜華区' },
  '坪山區': { 'zh-CN':'坪山区', en:'Pingshan District', ja:'坪山区' },
  '武侯區': { 'zh-CN':'武侯区', en:'Wuhou District', ja:'武侯区' },
  '雙流區': { 'zh-CN':'双流区', en:'Shuangliu District', ja:'双流区' },
  '溫江區': { 'zh-CN':'温江区', en:'Wenjiang District', ja:'温江区' },
  '成華區': { 'zh-CN':'成华区', en:'Chenghua District', ja:'成華区' },
  '郫都區': { 'zh-CN':'郫都区', en:'Pidu District', ja:'郫都区' },
  '金牛區': { 'zh-CN':'金牛区', en:'Jinniu District', ja:'金牛区' },
  '青羊區': { 'zh-CN':'青羊区', en:'Qingyang District', ja:'青羊区' },
  '新都區': { 'zh-CN':'新都区', en:'Xindu District', ja:'新都区' },
  '蕭山區': { 'zh-CN':'萧山区', en:'Xiaoshan District', ja:'蕭山区' },
  '濱江區': { 'zh-CN':'滨江区', en:'Binjiang District', ja:'浜江区' },
  '拱墅區': { 'zh-CN':'拱墅区', en:'Gongshu District', ja:'拱墅区' },
  '錢塘區': { 'zh-CN':'钱塘区', en:'Qiantang District', ja:'銭塘区' },
  '臨安區': { 'zh-CN':'临安区', en:'Lin\'an District', ja:'臨安区' },
  '餘杭區': { 'zh-CN':'余杭区', en:'Yuhang District', ja:'余杭区' },
  '臨平區': { 'zh-CN':'临平区', en:'Linping District', ja:'臨平区' },
  '富陽區': { 'zh-CN':'富阳区', en:'Fuyang District', ja:'富陽区' },
  '桐廬縣': { 'zh-CN':'桐庐县', en:'Tonglu County', ja:'桐廬県' },
  '湖裡區': { 'zh-CN':'湖里区', en:'Huli District', ja:'湖裏区' },
  '思明區': { 'zh-CN':'思明区', en:'Siming District', ja:'思明区' },
  '海滄區': { 'zh-CN':'海沧区', en:'Haicang District', ja:'海滄区' },
  '同安區': { 'zh-CN':'同安区', en:'Tong\'an District', ja:'同安区' },
  '翔安區': { 'zh-CN':'翔安区', en:'Xiang\'an District', ja:'翔安区' },
  '龍勝縣': { 'zh-CN':'龙胜县', en:'Longsheng County', ja:'竜勝県' },
  '雁山區': { 'zh-CN':'雁山区', en:'Yanshan District', ja:'雁山区' },
  '靈川縣': { 'zh-CN':'灵川县', en:'Lingchuan County', ja:'霊川県' },
  '慈利縣': { 'zh-CN':'慈利县', en:'Cili County', ja:'慈利県' },
  '呈貢區': { 'zh-CN':'呈贡区', en:'Chenggong District', ja:'呈貢区' },
  '晉寧區': { 'zh-CN':'晋宁区', en:'Jinning District', ja:'晋寧区' },
  '宜良縣': { 'zh-CN':'宜良县', en:'Yiliang County', ja:'宜良県' },
  '黃島區': { 'zh-CN':'黄岛区', en:'Huangdao District', ja:'黄島区' },
  '李滄區': { 'zh-CN':'李沧区', en:'Licang District', ja:'李滄区' },
  '城陽區': { 'zh-CN':'城阳区', en:'Chengyang District', ja:'城陽区' },
  '即墨區': { 'zh-CN':'即墨区', en:'Jimo District', ja:'即墨区' },
  '吳江區': { 'zh-CN':'吴江区', en:'Wujiang District', ja:'呉江区' },
  '蘇州工業園區': { 'zh-CN':'苏州工业园区', en:'Suzhou Industrial Park', ja:'蘇州工業園区' },
  '吳中區': { 'zh-CN':'吴中区', en:'Wuzhong District', ja:'呉中区' },
  '斗門區': { 'zh-CN':'斗门区', en:'Doumen District', ja:'斗門区' },
  '香洲區': { 'zh-CN':'香洲区', en:'Xiangzhou District', ja:'香洲区' },
  '南海區': { 'zh-CN':'南海区', en:'Nanhai District', ja:'南海区' },
  '三水區': { 'zh-CN':'三水区', en:'Sanshui District', ja:'三水区' },
  '史泰登島': { 'zh-CN':'史泰登岛', en:'Staten Island', ja:'スタテン島' },
  '阿凱迪亞': { 'zh-CN':'阿凯迪亚', en:'Arcadia', ja:'アルカディア' },
  '聖塔莫尼卡山脈': { 'zh-CN':'圣塔莫尼卡山脉', en:'Santa Monica Mountains', ja:'サンタモニカ山脈' },
  '格倫代爾': { 'zh-CN':'格伦代尔', en:'Glendale', ja:'グレンデール' },
  '帕薩迪納': { 'zh-CN':'帕萨迪纳', en:'Pasadena', ja:'パサデナ' },
  '蒙特利公園': { 'zh-CN':'蒙特利公园', en:'Monterey Park', ja:'モントレーパーク' },
  '阿罕布拉': { 'zh-CN':'阿罕布拉', en:'Alhambra', ja:'アルハンブラ' },
  '北拉斯維加斯': { 'zh-CN':'北拉斯维加斯', en:'North Las Vegas', ja:'ノースラスベガス' },
  '昆西': { 'zh-CN':'昆西', en:'Quincy', ja:'クインシー' },
  '悉尼奧林匹克公園': { 'zh-CN':'悉尼奥林匹克公园', en:'Sydney Olympic Park', ja:'シドニーオリンピックパーク' },
  '斯普林布魯克': { 'zh-CN':'斯普林布鲁克', en:'Springbrook', ja:'スプリングブルック' },
  '桑尼班克': { 'zh-CN':'桑尼班克', en:'Sunnybank', ja:'サニーバンク' },
  '布里斯班機場': { 'zh-CN':'布里斯班机场', en:'Brisbane Airport', ja:'ブリスベン空港' },
  '坦伯林山': { 'zh-CN':'坦伯林山', en:'Mount Tamborine', ja:'タンボリン山' },
  '德格拉朗': { 'zh-CN':'德格拉朗', en:'Tegallalang', ja:'テガララン' },
  '北雅加達': { 'zh-CN':'北雅加达', en:'North Jakarta', ja:'北ジャカルタ' },
  '默拉皮火山': { 'zh-CN':'默拉皮火山', en:'Mount Merapi', ja:'ムラピ山' },
  '納閩巴霍': { 'zh-CN':'纳闽巴霍', en:'Labuan Bajo', ja:'ラブアンバジョ' },
  '弗蘭克頓': { 'zh-CN':'弗兰克顿', en:'Frankton', ja:'フランクトン' },
  '卡馬拉': { 'zh-CN':'卡马拉', en:'Kamala', ja:'カマラ' },
  '蕉賴': { 'zh-CN':'蕉赖', en:'Cheras', ja:'チェラス' },
  '麥克坦島': { 'zh-CN':'麦克坦岛', en:'Mactan Island', ja:'マクタン島' },
  '納賽爾城': { 'zh-CN':'纳赛尔城', en:'Nasr City', ja:'ナスルシティ' },
  '老果阿': { 'zh-CN':'老果阿', en:'Old Goa', ja:'オールドゴア' },
  '雷克雅內斯半島': { 'zh-CN':'雷克雅内斯半岛', en:'Reykjanes Peninsula', ja:'レイキャネス半島' },
  // 2026-10-07: Yokohama / Karuizawa / Liverpool district chips
  '港未來': { 'zh-CN':'港未来', en:'Minato Mirai', ja:'みなとみらい', ko:'미나토미라이' },
  '山下公園': { 'zh-CN':'山下公园', en:'Yamashita Park', ja:'山下公園', ko:'야마시타 공원' },
  '橫濱中華街': { 'zh-CN':'横滨中华街', en:'Yokohama Chinatown', ja:'横浜中華街', ko:'요코하마 차이나타운' },
  '紅磚倉庫': { 'zh-CN':'红砖仓库', en:'Red Brick Warehouse', ja:'赤レンガ倉庫', ko:'아카렌가 창고' },
  '橫濱站': { 'zh-CN':'横滨站', en:'Yokohama Station', ja:'横浜駅', ko:'요코하마역' },
  '三溪園': { 'zh-CN':'三溪园', en:'Sankeien Garden', ja:'三溪園', ko:'산케이엔' },
  '八景島': { 'zh-CN':'八景岛', en:'Hakkeijima', ja:'八景島', ko:'핫케이지마' },
  '輕井澤站': { 'zh-CN':'轻井泽站', en:'Karuizawa Station', ja:'軽井沢駅', ko:'가루이자와역' },
  '中輕井澤': { 'zh-CN':'中轻井泽', en:'Naka-Karuizawa', ja:'中軽井沢', ko:'나카카루이자와' },
  '雲場池': { 'zh-CN':'云场池', en:'Kumoba Pond', ja:'雲場池', ko:'구모바 연못' },
  '白絲瀑布': { 'zh-CN':'白丝瀑布', en:'Shiraito Falls', ja:'白糸の滝', ko:'시라이토 폭포' },
  '王子購物廣場': { 'zh-CN':'王子购物广场', en:'Prince Shopping Plaza', ja:'プリンスショッピングプラザ', ko:'프린스 쇼핑 플라자' },
  '皇家阿爾伯特碼頭': { 'zh-CN':'皇家阿尔伯特码头', en:'Royal Albert Dock', ja:'ロイヤル・アルバート・ドック', ko:'로열 앨버트 독' },
  '碼頭大樓': { 'zh-CN':'码头大楼', en:'Pier Head', ja:'ピア・ヘッド', ko:'피어 헤드' },
  '利物浦一號': { 'zh-CN':'利物浦一号', en:'Liverpool ONE', ja:'リバプール・ワン', ko:'리버풀 원' },
  '馬修街': { 'zh-CN':'马修街', en:'Mathew Street', ja:'マシュー・ストリート', ko:'매슈 스트리트' },
  '安菲爾德': { 'zh-CN':'安菲尔德', en:'Anfield', ja:'アンフィールド', ko:'앤필드' },
  '利物浦大教堂': { 'zh-CN':'利物浦大教堂', en:'Liverpool Cathedral', ja:'リバプール大聖堂', ko:'리버풀 대성당' },
  // 2026-10-08: Stuttgart / Frankfurt / Bergen / Lugano / Maastricht district chips
  '施洛斯廣場': { 'zh-CN':'施洛斯广场', en:'Schlossplatz', ja:'シュロス広場', ko:'슐로스 광장' },
  '賓士博物館': { 'zh-CN':'奔驰博物馆', en:'Mercedes-Benz Museum', ja:'メルセデス・ベンツ博物館', ko:'메르세데스-벤츠 박물관' },
  '保時捷博物館': { 'zh-CN':'保时捷博物馆', en:'Porsche Museum', ja:'ポルシェ博物館', ko:'포르쉐 박물관' },
  '斯圖加特電視塔': { 'zh-CN':'斯图加特电视塔', en:'Stuttgart TV Tower', ja:'シュトゥットガルト・テレビ塔', ko:'슈투트가르트 TV 타워' },
  '威廉瑪動植物園': { 'zh-CN':'威廉玛动植物园', en:'Wilhelma Zoo', ja:'ヴィルヘルマ動植物園', ko:'빌헬마 동물원' },
  '國王大街': { 'zh-CN':'国王大街', en:'Königstraße', ja:'ケーニヒ通り', ko:'쾨니히 거리' },
  '斯圖加特中央車站': { 'zh-CN':'斯图加特中央车站', en:'Stuttgart Hauptbahnhof', ja:'シュトゥットガルト中央駅', ko:'슈투트가르트 중앙역' },
  '羅馬廣場': { 'zh-CN':'罗马广场', en:'Römerberg', ja:'レーマーベルク', ko:'뢰머베르크' },
  '博物館河岸': { 'zh-CN':'博物馆河岸', en:'Museumsufer', ja:'ミュージアムウーファー', ko:'박물관 강변' },
  '薩克森豪森': { 'zh-CN':'萨克森豪森', en:'Sachsenhausen', ja:'ザクセンハウゼン', ko:'작센하우젠' },
  '采爾大街': { 'zh-CN':'采尔大街', en:'Zeil', ja:'ツァイル通り', ko:'차일 거리' },
  '美因塔': { 'zh-CN':'美因塔', en:'Main Tower', ja:'マイン・タワー', ko:'마인 타워' },
  '棕櫚園': { 'zh-CN':'棕榈园', en:'Palmengarten', ja:'パルメンガルテン', ko:'팔멘가르텐' },
  '布呂根': { 'zh-CN':'布吕根', en:'Bryggen', ja:'ブリッゲン', ko:'브뤼겐' },
  '魚市場': { 'zh-CN':'鱼市场', en:'Fish Market', ja:'魚市場', ko:'어시장' },
  '弗洛伊恩山': { 'zh-CN':'弗洛伊恩山', en:'Mount Fløyen', ja:'フロイエン山', ko:'플뢰위엔 산' },
  '烏爾里肯山': { 'zh-CN':'乌尔里肯山', en:'Mount Ulriken', ja:'ウーリケン山', ko:'울리켄 산' },
  '哈康宮': { 'zh-CN':'哈康宫', en:'Håkonshallen', ja:'ホーコンスホール', ko:'호콘 홀' },
  '卑爾根水族館': { 'zh-CN':'卑尔根水族馆', en:'Bergen Aquarium', ja:'ベルゲン水族館', ko:'베르겐 수족관' },
  '盧加諾湖畔': { 'zh-CN':'卢加诺湖畔', en:'Lugano Lakefront', ja:'ルガーノ湖畔', ko:'루가노 호반' },
  '改革廣場': { 'zh-CN':'改革广场', en:'Piazza della Riforma', ja:'リフォルマ広場', ko:'리포르마 광장' },
  '聖薩爾瓦多山': { 'zh-CN':'圣萨尔瓦多山', en:'Monte San Salvatore', ja:'サン・サルヴァトーレ山', ko:'산 살바토레 산' },
  '布雷山': { 'zh-CN':'布雷山', en:'Monte Brè', ja:'ブレ山', ko:'브레 산' },
  '甘德里亞': { 'zh-CN':'甘德里亚', en:'Gandria', ja:'ガンドリア', ko:'간드리아' },
  '莫爾科特': { 'zh-CN':'莫尔科特', en:'Morcote', ja:'モルコテ', ko:'모르코테' },
  '維克廣場': { 'zh-CN':'维克广场', en:'Vrijthof', ja:'フライトホフ', ko:'프레이트호프' },
  '市場廣場': { 'zh-CN':'市场广场', en:'Markt', ja:'マルクト広場', ko:'마르크트 광장' },
  '聖瑟法斯橋': { 'zh-CN':'圣瑟法斯桥', en:'Sint Servaasbrug', ja:'シント・セルファース橋', ko:'신트 세르파스 다리' },
  '多明我會書店教堂': { 'zh-CN':'多明我会书店教堂', en:'Boekhandel Dominicanen', ja:'ドミニカン書店', ko:'도미니칸 서점' },
  '聖彼得要塞': { 'zh-CN':'圣彼得要塞', en:'Fort Sint Pieter', ja:'シント・ピーテル要塞', ko:'신트 피터르 요새' },
  '維克區': { 'zh-CN':'维克区', en:'Wyck', ja:'ウィック地区', ko:'윅 지구' },
  // 2026-10-11: Kurashiki / Santiago de Compostela / Tilburg / Curitiba / Palenque district chips
  '倉敷美觀地區': { 'zh-CN':'仓敷美观地区', en:'Kurashiki Bikan Historical Quarter', ja:'倉敷美観地区', ko:'구라시키 미관지구' },
  '大原美術館': { 'zh-CN':'大原美术馆', en:'Ohara Museum of Art', ja:'大原美術館', ko:'오하라 미술관' },
  '倉敷站': { 'zh-CN':'仓敷站', en:'Kurashiki Station', ja:'倉敷駅', ko:'구라시키역' },
  '阿智神社': { 'zh-CN':'阿智神社', en:'Achi Shrine', ja:'阿智神社', ko:'아치 신사' },
  '兒島牛仔褲街': { 'zh-CN':'儿岛牛仔裤街', en:'Kojima Jeans Street', ja:'児島ジーンズストリート', ko:'고지마 청바지 거리' },
  '鷲羽山': { 'zh-CN':'鹫羽山', en:'Washuzan', ja:'鷲羽山', ko:'와시우산' },
  '聖地牙哥大教堂': { 'zh-CN':'圣地亚哥大教堂', en:'Santiago de Compostela Cathedral', ja:'サンティアゴ・デ・コンポステーラ大聖堂', ko:'산티아고 데 콤포스텔라 대성당' },
  '奧布拉多伊羅廣場': { 'zh-CN':'奥布拉多伊罗广场', en:'Praza do Obradoiro', ja:'オブラドイロ広場', ko:'오브라도이로 광장' },
  '阿拉梅達公園': { 'zh-CN':'阿拉梅达公园', en:'Alameda Park', ja:'アラメダ公園', ko:'알라메다 공원' },
  '食品市場': { 'zh-CN':'食品市场', en:'Mercado de Abastos', ja:'アバストス市場', ko:'아바스토스 시장' },
  '加利西亞文化城': { 'zh-CN':'加利西亚文化城', en:'City of Culture of Galicia', ja:'ガリシア文化都市', ko:'갈리시아 문화 도시' },
  '紡織博物館': { 'zh-CN':'纺织博物馆', en:'TextielMuseum', ja:'テキスタイル博物館', ko:'섬유 박물관' },
  '德蓬特美術館': { 'zh-CN':'德蓬特美术馆', en:'De Pont Museum', ja:'デ・ポント美術館', ko:'더 폰트 미술관' },
  '鐵道區': { 'zh-CN':'铁道区', en:'Spoorzone', ja:'スポールゾーン', ko:'스포르존' },
  '莫倫堡公園': { 'zh-CN':'莫伦堡公园', en:'Moerenburg Park', ja:'モーレンブルフ公園', ko:'무렌부르흐 공원' },
  '鐵絲網歌劇院': { 'zh-CN':'铁丝网歌剧院', en:'Ópera de Arame', ja:'オペラ・デ・アラメ', ko:'철사 오페라 극장' },
  '奧德姆廣場': { 'zh-CN':'奥德姆广场', en:'Largo da Ordem', ja:'オルデン広場', ko:'오르뎅 광장' },
  '尼邁耶博物館': { 'zh-CN':'尼迈耶博物馆', en:'Oscar Niemeyer Museum', ja:'オスカー・ニーマイヤー博物館', ko:'오스카 니마이어 박물관' },
  '巴里古伊公園': { 'zh-CN':'巴里古伊公园', en:'Barigui Park', ja:'バリグイ公園', ko:'바리귀 공원' },
  '十一月十五日街': { 'zh-CN':'十一月十五日街', en:'Rua XV de Novembro', ja:'11月15日通り', ko:'11월 15일 거리' },
  '帕倫克遺址': { 'zh-CN':'帕伦克遗址', en:'Palenque Ruins', ja:'パレンケ遺跡', ko:'팔렌케 유적' },
  '阿瓜阿祖爾瀑布': { 'zh-CN':'阿瓜阿祖尔瀑布', en:'Agua Azul Waterfalls', ja:'アグア・アスール滝', ko:'아구아 아술 폭포' },
  '米索哈瀑布': { 'zh-CN':'米索哈瀑布', en:'Misol-Ha Waterfall', ja:'ミソル・ハの滝', ko:'미솔하 폭포' },
  '帕倫克市中心': { 'zh-CN':'帕伦克市中心', en:'Palenque Town Centre', ja:'パレンケ市街', ko:'팔렌케 시내' },
  // 2026-10-12: Nemuro / Shijiazhuang / Banff district chips
  '納沙布岬': { 'zh-CN':'纳沙布岬', en:'Cape Nosappu', ja:'納沙布岬', ko:'노샤푸 곶' },
  '根室站': { 'zh-CN':'根室站', en:'Nemuro Station', ja:'根室駅', ko:'네무로역' },
  '花咲港': { 'zh-CN':'花咲港', en:'Hanasaki Port', ja:'花咲港', ko:'하나사키 항' },
  '風蓮湖': { 'zh-CN':'风莲湖', en:'Lake Furen', ja:'風蓮湖', ko:'후렌 호' },
  '春國岱': { 'zh-CN':'春国岱', en:'Shunkunitai', ja:'春国岱', ko:'슌쿠니타이' },
  '正定古城': { 'zh-CN':'正定古城', en:'Zhengding Ancient City', ja:'正定古城', ko:'정정 고성' },
  '隆興寺': { 'zh-CN':'隆兴寺', en:'Longxing Temple', ja:'隆興寺', ko:'융싱사' },
  '西柏坡': { 'zh-CN':'西柏坡', en:'Xibaipo', ja:'西柏坡', ko:'시바이포' },
  '趙州橋': { 'zh-CN':'赵州桥', en:'Zhaozhou Bridge', ja:'趙州橋', ko:'자오저우교' },
  '蒼岩山': { 'zh-CN':'苍岩山', en:'Cangyan Mountain', ja:'蒼岩山', ko:'창옌산' },
  '河北博物院': { 'zh-CN':'河北博物院', en:'Hebei Museum', ja:'河北博物院', ko:'허베이 박물원' },
  '石家莊站': { 'zh-CN':'石家庄站', en:'Shijiazhuang Railway Station', ja:'石家荘駅', ko:'스자좡역' },
  '班夫大道': { 'zh-CN':'班夫大道', en:'Banff Avenue', ja:'バンフ・アベニュー', ko:'밴프 애비뉴' },
  '班夫上溫泉': { 'zh-CN':'班夫上温泉', en:'Banff Upper Hot Springs', ja:'バンフ・アッパー・ホットスプリングス', ko:'밴프 어퍼 핫 스프링스' },
  '硫磺山': { 'zh-CN':'硫磺山', en:'Sulphur Mountain', ja:'サルファー山', ko:'설퍼 산' },
  '弓河瀑布': { 'zh-CN':'弓河瀑布', en:'Bow Falls', ja:'ボウ滝', ko:'보 폭포' },
  '明尼旺卡湖': { 'zh-CN':'明尼旺卡湖', en:'Lake Minnewanka', ja:'ミニワンカ湖', ko:'미니원카 호' },
  '露易絲湖': { 'zh-CN':'路易斯湖', en:'Lake Louise', ja:'レイク・ルイーズ', ko:'레이크 루이스' },
  '夢蓮湖': { 'zh-CN':'梦莲湖', en:'Moraine Lake', ja:'モレーン湖', ko:'모레인 호' },
  // 2026-10-13: Penghu / Nantou / Taitung County district chips
  '望安島': { 'zh-CN':'望安岛', en:'Wangan Island', ja:'望安島', ko:'왕안섬' },
  '西嶼': { 'zh-CN':'西屿', en:'Xiyu', ja:'西嶼', ko:'시위' },
  '風櫃': { 'zh-CN':'风柜', en:'Fenggui', ja:'風櫃', ko:'펑구이' },
  '日月潭': { 'zh-CN':'日月潭', en:'Sun Moon Lake', ja:'日月潭', ko:'르웨탄' },
  '清境農場': { 'zh-CN':'清境农场', en:'Qingjing Farm', ja:'清境農場', ko:'칭징 농장' },
  '合歡山': { 'zh-CN':'合欢山', en:'Hehuanshan', ja:'合歡山', ko:'허환산' },
  '溪頭': { 'zh-CN':'溪头', en:'Xitou', ja:'渓頭', ko:'시터우' },
  '埔里': { 'zh-CN':'埔里', en:'Puli', ja:'埔里', ko:'푸리' },
  '集集': { 'zh-CN':'集集', en:'Jiji', ja:'集集', ko:'지지' },
  '台東市區': { 'zh-CN':'台东市区', en:'Taitung City', ja:'台東市街', ko:'타이둥 시내' },
  '池上': { 'zh-CN':'池上', en:'Chishang', ja:'池上', ko:'츠상' },
  '鹿野高台': { 'zh-CN':'鹿野高台', en:'Luye Highland', ja:'鹿野高台', ko:'루예 고원' },
  '三仙台': { 'zh-CN':'三仙台', en:'Sanxiantai', ja:'三仙台', ko:'싼셴타이' },
  '知本溫泉': { 'zh-CN':'知本温泉', en:'Zhiben Hot Springs', ja:'知本温泉', ko:'즈번 온천' },
  '綠島': { 'zh-CN':'绿岛', en:'Green Island', ja:'緑島', ko:'뤼다오' },
  '蘭嶼': { 'zh-CN':'兰屿', en:'Orchid Island', ja:'蘭嶼', ko:'란위' },
  // 2026-10-14: Kinmen / Lienchiang / Changhua County district chips
  '金城(後浦)': { 'zh-CN':'金城(后浦)', en:'Jincheng (Houpu)', ja:'金城(後浦)', ko:'진청(허우푸)' },
  '水頭聚落': { 'zh-CN':'水头聚落', en:'Shuitou Village', ja:'水頭集落', ko:'수터우 마을' },
  '金湖': { 'zh-CN':'金湖', en:'Jinhu', ja:'金湖', ko:'진후' },
  '金沙': { 'zh-CN':'金沙', en:'Jinsha', ja:'金沙', ko:'진샤' },
  '古寧頭': { 'zh-CN':'古宁头', en:'Guningtou', ja:'古寧頭', ko:'구닝터우' },
  '烈嶼': { 'zh-CN':'烈屿', en:'Lieyu (Little Kinmen)', ja:'烈嶼(小金門)', ko:'례위(샤오진먼)' },
  '南竿': { 'zh-CN':'南竿', en:'Nangan', ja:'南竿', ko:'난간' },
  '北竿': { 'zh-CN':'北竿', en:'Beigan', ja:'北竿', ko:'베이간' },
  '芹壁村': { 'zh-CN':'芹壁村', en:'Qinbi Village', ja:'芹壁村', ko:'친비 마을' },
  '莒光': { 'zh-CN':'莒光', en:'Juguang', ja:'莒光', ko:'쥐광' },
  '東引': { 'zh-CN':'东引', en:'Dongyin', ja:'東引', ko:'둥인' },
  '鹿港老街': { 'zh-CN':'鹿港老街', en:'Lukang Old Street', ja:'鹿港老街', ko:'루강 올드 스트리트' },
  '八卦山大佛': { 'zh-CN':'八卦山大佛', en:'Baguashan Great Buddha', ja:'八卦山大仏', ko:'바과산 대불' },
  '田尾': { 'zh-CN':'田尾', en:'Tianwei', ja:'田尾', ko:'톈웨이' },
  '溪湖': { 'zh-CN':'溪湖', en:'Xihu', ja:'渓湖', ko:'시후' },
  '員林': { 'zh-CN':'员林', en:'Yuanlin', ja:'員林', ko:'위안린' },
  '二林': { 'zh-CN':'二林', en:'Erlin', ja:'二林', ko:'얼린' },
};
